webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(822)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(1042),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(830)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(1048),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(832)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(1050),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(814)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(1035),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAs1JREFUSA3tVU1rVDEUPTczVsWPjkW70LoXxY+iWC2KC4suBJfduBBpaf34E/0BUtwoVUTBlYiICLaIoihSiwVxKSoqCFIXfoCl2k7nxZM3k7yXvIx1W2jgcXNP7sl5SW5ugKW22HdAwgXoy9hOrAsaG2hnaL/STsgZfKJt2vQItkJhH+PbGTRLO4UyJqUf7/MkT5BiR5CgOx+Q9oVoDWNyDpOFMQIUO0yBg4UxRVTwUAYwbseU7ehr6Yr2W9+zmv9ewlF9A6s8nI6+ijZOeiDEUz/hSIIeLqTVjjtBVLGZg96KbVBqNTfoN/Z6mHHm0LEAz2h0WV4mqNBiwaZWOHnYNJaHUMHX2GSxTBBpclg8bjXWRgamIlgIOV4m2J9m4bsw0vMjgkykzzzfN15c0VljIScowoyq4jZPcYLfvA0IbBL4dbeCO0yr8aY8zbkbLZokeoj0DlQY1krpkzaY6E8ZxAXnBx3Hm2U2K/S5YcG0nMZ547sVukF2ZAgJL+x3Zl+YED/ycWHf8cqFBHS8qKCbqBZkpbB6/E+rYaMXVq9WKdRUkJd1GZOh0yMm+OD5EUffIquE3d5QCR+tX7adgtXYwzPMKovw2rctLIhv2MG5Km4+xVT8Apf90RWmZU5wyJFMR/BSellR/9H0dQop9HghNbzi2c5ZrLBCfRGr+U8nmDArbBDtDNPgRc4vdPUwVnJaw8t2RREp43k+2BPkua3nNvaSlG2JiS7hrpzCnzwx39eXsI47YHjmScuaYFT68CsDQP1G4xOzk91jFPRrquAxn5e3Ni60+gq2Ueg4ef4VMkcwgNdhfHaGkhJ9sRKe8MI+C0mer/nwhmKK7+Ygxry4hpMJtmCUWDXFFbdP4Sb/8GmM5GHznNhksGmmJCrcYzW6n5ZKL7DueKWN29PNv20n7RGL8nQkPgqRt4v5u4XcB3IWrqpEg5fARb8DfwF7HrRlP5oAwQAAAABJRU5ErkJggg=="

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAArZJREFUSA3tVd2LTVEU/+09d2bciYfxQkqhruZRQkMikkJJkjwpEqK8evDin7gYjZTyMv+BIqQwIiLKO6nB+G5m7p1ztt+67v68957jlWbVOevzt9fee62zDrBA//oNqLIDmEsYhsZuPm/VSbwoi7d+U8diVLALClPEPbT2woRmDOthsJdPhcAZZKirs/hpwb04cSP0HUCOReRNvuvqGL5KvJZXSsZAEbSPgP2tZBJgUGXaPWlsqpur2E7ckXYycfejwU23qWKFiI9xYYONkU1hjqd8E9kSxVzBNt7Cjsismc7gtbV1JOQO1xG0yQa0+QfueEKdxpfE7lTi1hK30xlEYP34Ftwna4+u1FzDEu7GHb8VpPGR1buhzhQku84qZaxZSJo1y4g75ZOJOz7hHLZyVwMOp/GL2k2CZpytm9DAZpqHnEtjlpUTXEeDuROai1y6j10ZUo7btrtCcyibCaJMUgKD++o4b6YL+ROuQI1X0O9i5EqG8dLpvYRprGHCqnPLrQBPnZ4I7oRMtjryZXimDtNaRpoJQ8rwnFfZDE2h7BMqLAsdlN8nenfVYHnk6MO7SE8UnxC8wJAMmmYcS1nbMCaMsHKMyzFbhHOjjZPlAr81X0O7nMI8O/cJt3OPV9ywZsv5sZ+PamgdgpNaNnBXnePQaJPfPceZNUZc5miOLfiMg5HdK34Nb5NRWOEzyiMcklFpXWHwD2vswUf4B1jZ4VP43mGLDTWMY5U1hQnLgIKJG0Qs5QklyjWkT6j+oitlgKdkiruyFT7vcT4hMMnd5ul6TtesyECXxatsqD8N4kIjQXCDHucS8mP9RtcdfgQmAlhF44E6gWmrWq6OcrJo3CrY7KNwzLnusQuwzWuUN3ABqdcg+RTP/Zi/mOJ/4eVWY4wyXuo1RC6zdJIHeUW+QP/RDfwGR4i4wUx0hYYAAAAASUVORK5CYII="

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(835)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(1053),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(876)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(1088),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getEvaluation;
/* harmony export (immutable) */ __webpack_exports__["e"] = getEvaluationCal;
/* harmony export (immutable) */ __webpack_exports__["b"] = getEvaluationSave;
/* harmony export (immutable) */ __webpack_exports__["c"] = getResaultProductList;
/* harmony export (immutable) */ __webpack_exports__["d"] = getEvaluationUpdate;
/* unused harmony export getEvaluationRecord */
/* harmony export (immutable) */ __webpack_exports__["h"] = loginGetAu;
/* unused harmony export needSignTest */
/* harmony export (immutable) */ __webpack_exports__["a"] = quesSignSave;
/* harmony export (immutable) */ __webpack_exports__["g"] = questionNewList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_http__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_config__ = __webpack_require__(232);



function getEvaluation(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["d" /* evaluationUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].evaluation, data, au);
}

function getEvaluationCal(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["d" /* evaluationUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].evaluationCal, data, au);
}

function getEvaluationSave(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["d" /* evaluationUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].evaluationSave, data, au);
}

function getResaultProductList(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["e" /* productUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].productList, data, au);
}

function getEvaluationUpdate(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["d" /* evaluationUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].evaluationUpdate, data, au);
}

function getEvaluationRecord(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["d" /* evaluationUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].record, data, au);
}

function loginGetAu(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["a" /* investorUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].loginApp, data, au);
}

function needSignTest(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["a" /* investorUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].needSignTest, data, au);
}

function quesSignSave(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["d" /* evaluationUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].setEvaluationResultFileSign, data, au);
}

// 问卷、问题列表 http://192.168.88.120:200/index.php?s=/21&page_id=1572
function questionNewList(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["d" /* evaluationUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].questionNewList, data, au);
}

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(858)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(1072),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(811)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(1032),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(818)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(1038),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(882)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1092),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getInvestorPersonal;
/* harmony export (immutable) */ __webpack_exports__["b"] = getInvestorAgency;
/* harmony export (immutable) */ __webpack_exports__["d"] = getInvestorProduct;
/* harmony export (immutable) */ __webpack_exports__["c"] = getInvestorAuth;
/* harmony export (immutable) */ __webpack_exports__["f"] = getInvestorOtherAuth;
/* harmony export (immutable) */ __webpack_exports__["a"] = msgReady;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_http__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_config__ = __webpack_require__(232);



function getInvestorPersonal(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["a" /* investorUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].investorPersonal, data, au);
}

function getInvestorAgency(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["a" /* investorUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].investorAgency, data, au);
}

function getInvestorProduct(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["a" /* investorUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].investorProduct, data, au);
}

function getInvestorAuth(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["a" /* investorUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].idAuth, data, au);
}

function getInvestorOtherAuth(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["a" /* investorUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].idAuthOther, data, au);
}

function msgReady(data, au) {
  return __WEBPACK_IMPORTED_MODULE_0_common_js_http__["a" /* http */](__WEBPACK_IMPORTED_MODULE_1_api_config__["c" /* msgBaseUrl */] + __WEBPACK_IMPORTED_MODULE_1_api_config__["b" /* resUrl */].msgReady, data, au);
}

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/one-title.34c4367.png";

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/share-download.b5c3c1a.png";

/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(803)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(870)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(1084),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(859)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(1073),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(792)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(848)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(1065),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(820)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(1040),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return appDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appDownloadDemo; });
var mode = "prod" || 'dev';
console.log(mode);
// debug环境
// export default 'http://192.168.0.252:8011'

// live环境
// export default 'http://peys.totodi.com:17811'

// release环境
// export default 'http://pe.totodi.com:13811'

// 深圳通测试环境
// export default 'http://peys.totodi.com:37811'

var config = {
  dev: 'http://192.168.0.252:8011', // 开发
  test: 'http://peys.totodi.com:27811', // 测试
  testtx: 'https://petx.totodi.com', // 腾讯云测试
  jryhd: 'https://graytestopenapi.totodi.com',
  live: 'http://peys.totodi.com:17811', // 演示
  prod: 'http://pe.totodi.com:13811' // 生产


  /*
    androidInvestorUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=208', // 投资者
    androidFinancialUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=210', // 企业版
    iosInvestorUrl: 'https://itunes.apple.com/cn/app/妥私募/id1332550394?mt=8',
    iosFinancialUrl: 'https://itunes.apple.com/cn/app//id1332552677',
  */
};var appDownloadConfig = {
  testtx: {
    androidInvestorUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=461',
    androidFinancialUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=462',
    iosInvestorUrl: 'https://testflight.apple.com/join/9WfoQy4A',
    iosFinancialUrl: 'https://testflight.apple.com/join/i7gLVOgn'
  },
  live: {
    androidInvestorUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=207',
    androidFinancialUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=209',
    iosInvestorUrl: 'https://testflight.apple.com/join/zoZ19LPd',
    iosFinancialUrl: 'https://testflight.apple.com/join/bfSDZxTC'
  },
  other: {
    androidInvestorUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=208', // 投资者
    androidFinancialUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=210', // 企业版
    iosInvestorUrl: 'https://itunes.apple.com/cn/app/妥私募/id1332550394?mt=8',
    iosFinancialUrl: 'https://itunes.apple.com/cn/app//id1332552677'
  }
};

var appDownload = appDownloadConfig[mode] || appDownloadConfig.other;

// 增加一个固定演示环境的地址
var appDownloadDemo = appDownloadConfig.live;

/* harmony default export */ __webpack_exports__["a"] = (config[mode]);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iDCardTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return iDCardTypesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatOldCatType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isForeign; });
// import { getIsoCountryList, identityForeignFourFactorAuth } from '@/api/user';

var iDCardTypes = [{ key: '身份证', value: '身份证' }, { key: '定居国外的中国公民护照', value: '定居国外的中国公民护照' }, { key: '港澳居民来往内地通行证', value: '港澳居民来往内地通行证' }, { key: '台湾居民来往内地通行证', value: '台湾居民来往内地通行证' }, { key: '外国人永久居留身份证', value: '外国人永久居留身份证' }];

var iDCardTypesLabel = function iDCardTypesLabel(val) {
  var obj = iDCardTypes.find(function (item) {
    return item.key === val;
  });
  if (obj) return obj.value;
  return val;
};

// export const getCountryList = async () => {
//   const res = await getIsoCountryList();
//   const { code, data } = res;
//   if (code === 0) {
//     return (data.list || []).sort((c1, c2) => (c1.namePinyin < c2.namePinyin ? -1 : 1));
//   }
//   return [];
// };

/**
 * 验证证件号码是否正确
 * @param {*} postData
 * {
 *  userName: '' // 姓名
 *  userDocumentNo: '' // 证件号码
 *  userIdType: '' // 证件类型
 *  userCountry: '' // 证件国籍
 * }
 * @returns
 */
// export const vertifyIDCard = async (postData) => {
//   if (postData.userIdType === '身份证') return true;
//   const res = await identityForeignFourFactorAuth(postData);
//   if (res.code === 0) return true;
//   return false;
// };

var formatOldCatType = function formatOldCatType(type) {
  if (type === '身份证' || type === '身份证') return '身份证';
  return type;
};

var isForeign = function isForeign(type) {
  return type === '外国人永久居留身份证';
};

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(815)
__webpack_require__(816)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1036),
  /* scopeId */
  "data-v-2fc10d69",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(862)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(1077),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(796)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return evaluationUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return investorUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return productUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return msgBaseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resUrl; });
/* unused harmony export phone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseurl__ = __webpack_require__(156);

var evaluationUrl = __WEBPACK_IMPORTED_MODULE_0__baseurl__["a" /* default */] + '/ttd-fund-question';
var investorUrl = __WEBPACK_IMPORTED_MODULE_0__baseurl__["a" /* default */] + '/ttd-fund-user';
var productUrl = __WEBPACK_IMPORTED_MODULE_0__baseurl__["a" /* default */] + '/ttd-fund-order';
var msgBaseUrl = __WEBPACK_IMPORTED_MODULE_0__baseurl__["a" /* default */] + '/message-service';

var resUrl = {
  evaluation: '/question/new/list',
  evaluationCal: '/evaluation/calculation',
  evaluationSave: '/evaluation/save',
  investorPersonal: '/personalInvenstem/getBaseInfo',
  investorAgency: '/orgInvenstem/getBaseInfo',
  investorProduct: '/productInvenstement/getProductInvenstement',
  evaluationUpdate: '/evaluation/updateResult',
  idAuth: '/author/idcardAuthor',
  idAuthOther: '/author/addInvenstemIdCardAuthor',
  record: '/evaluation/getUserEvaluationResult',
  productList: '/order/no/match',
  loginApp: '/userInfo/investorLogin',
  msgReady: '/ms/read',

  needSignTest: '/parm/sginQuestion',
  setEvaluationResultFileSign: '/evaluation/setEvaluationResultFileSign',
  uploadBaseStrFile: '/oos/uploadBase64',

  questionNewList: '/question/new/list' // 问卷、问题列表
};

var phone = '400-688-9268';

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = http;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_util__ = __webpack_require__(406);





/**
 * ajax请求
 * @param  {[type]} url  [description]
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
function http(url, data, au) {
  data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
    requestInfo: { systemName: 'TO_PRIVATE_APP' }
  }, data);
  // console.log(data)
  var aesData = '';
  console.log('\u4E0A\u884C:' + url + ';au:' + au, data);
  var timestamp = __WEBPACK_IMPORTED_MODULE_4_common_js_util__["a" /* uuid */]() + '-' + __WEBPACK_IMPORTED_MODULE_4_common_js_util__["b" /* getTimeStamp */]();
  aesData = __WEBPACK_IMPORTED_MODULE_4_common_js_util__["c" /* enctypeAes */](data, timestamp);
  aesData = __WEBPACK_IMPORTED_MODULE_4_common_js_util__["d" /* encryptBase64 */](aesData);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default()({
      url: url,
      method: 'post',
      timeout: 100000,
      data: { body: aesData },
      headers: __WEBPACK_IMPORTED_MODULE_4_common_js_util__["e" /* authorization */](timestamp, aesData, au),
      transformRequest: [function (data) {
        data = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(data);
        return data;
      }],
      transformResponse: [function (data) {
        // Base64 转码
        data = __WEBPACK_IMPORTED_MODULE_4_common_js_util__["f" /* decryptBase64 */](data);
        // aes 解密
        data = __WEBPACK_IMPORTED_MODULE_4_common_js_util__["g" /* dectyptAES */](data);
        console.log('下行：' + url, JSON.parse(data));
        return JSON.parse(data);
      }]
    }).then(function (res) {
      resolve(res.data);
    }).catch(function (e) {
      reject(e);
    });
  });
}

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by Administrator on 2018/5/15.
 */
// 获取可见窗口顶端与body对象最顶端的距离，考虑到浏览器版本兼容性问题，解析方式可能会不一样
var getScrollTop = function getScrollTop() {
  return document.documentElement.scrollTop || document.body.scrollTop;
};
// 获取视口高度（网页可见区域高）浏览器可见内容高度,浏览器所有内容高度(考虑到浏览器版本兼容性问题，解析方式可能会不一样)
var getWinHeight = function getWinHeight() {
  return document.documentElement.clientHeight || document.body.clientHeight;
};
// 获取文档总高度
var getScrollHeight = function getScrollHeight() {
  var bodyScrollHeight = 0;
  var documentScrollHeight = 0;
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight;
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight;
  }
  // 当页面内容超出浏览器可视窗口大小时，Html的高度包含body高度+margin+padding+border所以html高度可能会大于body高度
  return bodyScrollHeight - documentScrollHeight > 0 ? bodyScrollHeight : documentScrollHeight;
};
// 是否滚动到底部
var isReachBottom = function isReachBottom() {
  var scrollTop = getScrollTop(); // 获取滚动条的高度
  var winHeight = getWinHeight(); // 一屏的高度
  var scrollHeight = getScrollHeight(); // 获取文档总高度
  return scrollTop >= parseInt(scrollHeight) - winHeight;
};
// 绑定方法
var bingListenScroll = function bingListenScroll(vm) {
  window.addEventListener('scroll', function () {
    if (isReachBottom()) {
      vm.isReady = false;
    }
  });
};
/* harmony default export */ __webpack_exports__["a"] = (bingListenScroll);

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download-tips.f66f485.png";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/totodi.f9e8f15.png";

/***/ }),
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(837)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1055),
  /* scopeId */
  "data-v-54bbcf2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(824)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(1044),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(852)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(1068),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(809)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(1030),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by Administrator on 2018/4/12.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  getFormatDate: function getFormatDate() {
    var date = new Date();
    var year = parseInt(date.getFullYear());
    var month = parseInt(date.getMonth()) + 1;
    var day = parseInt(date.getDate());
    month = month < 10 ? '0' + month : month.toString();
    day = day < 10 ? '0' + day : day.toString();
    return year + '-' + month + '-' + day;
  },

  toBoolean: function toBoolean(str) {
    if (str === 'true') {
      return true;
    } else {
      return false;
    }
  },

  formatOrderState: function formatOrderState(state) {
    var str = '';
    switch (state) {
      case 10001:
        str = '预约审核中';
        break;
      case 10002:
        str = '订单信息待确认';
        break;
      case 10003:
        str = '合同待签署';
        break;
      case 10004:
        str = '合同待打款';
        break;
      case 10005:
        str = '打款资料确认中';
        break;
      case 10006:
        str = '冷静期';
        break;
      case 10007:
        str = '签约成功';
        break;
      case 10008:
        str = '签约失败';
        break;
      case 10009:
        str = '预约审核失败';
        break;
      case 10010:
        str = '打款资料审核失败';
        break;
      case 10011:
        str = '订单已取消';
        break;
      case 10012:
        str = '撤销订单';
        break;
      case 10013:
        str = '订单赎回';
        break;
      case 10014:
        str = '合同待签署';
        break;
      case 10015:
        str = '双录待审核';
        break;
      case 10016:
        str = '双录审核失败';
        break;
      case 10017:
        str = '追加确认中';
        break;
      case 10018:
        str = '合同信息待审核';
        break;
      case 10019:
        str = '合同信息审核失败';
        break;
      case 10020:
        str = '追加审核不通过';
        break;
      case 10021:
        str = '订单回访中';
        break;
      case 10022:
        str = '合同待签署';
        break;
      case 10023:
        str = '合同待签署';
        break;
      default:
        str = '';
    }
    return str;
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vconsole__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vconsole___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vconsole__);
/**
 * Created by Administrator on 2018/6/4.
 */

/* eslint-disable */
var mode = "prod";
var VConsole = void 0;
if ("production" === 'development' || mode === 'testtx') {
  VConsole = new __WEBPACK_IMPORTED_MODULE_0_vconsole___default.a();
}

/* unused harmony default export */ var _unused_webpack_default_export = (VConsole);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_baseComponents_SubmitButton_vue__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_baseComponents_SubmitButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_baseComponents_SubmitButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_baseComponents_ChooseButton_vue__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_baseComponents_ChooseButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_baseComponents_ChooseButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_baseComponents_MySelector_vue__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_baseComponents_MySelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_baseComponents_MySelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_baseComponents_MyStep_vue__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_baseComponents_MyStep_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_baseComponents_MyStep_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_baseComponents_MyCheckStyle_vue__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_baseComponents_MyCheckStyle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_baseComponents_MyCheckStyle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_baseComponents_MyCellHeader_vue__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_baseComponents_MyCellHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_baseComponents_MyCellHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_baseComponents_MyStepper_vue__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_baseComponents_MyStepper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_baseComponents_MyStepper_vue__);
/**
 * Created by Administrator on 2017/11/8.
 */







var glomount = {
  install: function install(Vue, options) {
    Vue.component('submit-button', __WEBPACK_IMPORTED_MODULE_0__components_baseComponents_SubmitButton_vue___default.a);
    Vue.component('choose-button', __WEBPACK_IMPORTED_MODULE_1__components_baseComponents_ChooseButton_vue___default.a);
    Vue.component('my-selector', __WEBPACK_IMPORTED_MODULE_2__components_baseComponents_MySelector_vue___default.a);
    Vue.component('my-step', __WEBPACK_IMPORTED_MODULE_3__components_baseComponents_MyStep_vue___default.a);
    Vue.component('my-check-style', __WEBPACK_IMPORTED_MODULE_4__components_baseComponents_MyCheckStyle_vue___default.a);
    Vue.component('my-cell-header', __WEBPACK_IMPORTED_MODULE_5__components_baseComponents_MyCellHeader_vue___default.a);
    Vue.component('my-stepper', __WEBPACK_IMPORTED_MODULE_6__components_baseComponents_MyStepper_vue___default.a);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (glomount);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Index__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Evaluation_One__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Evaluation_One___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Evaluation_One__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Evaluation_Question__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Evaluation_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Evaluation_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Evaluation_lastLow__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Evaluation_lastLow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Evaluation_lastLow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Evaluation_lastLowEnd__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Evaluation_lastLowEnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_Evaluation_lastLowEnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Evaluation_batchLow__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Evaluation_batchLow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Evaluation_batchLow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Evaluation_normal__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Evaluation_normal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_Evaluation_normal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_InvestorInfo_Agency_One__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_InvestorInfo_Agency_One___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_InvestorInfo_Agency_One__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_InvestorInfo_Agency_Two__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_InvestorInfo_Agency_Two___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_InvestorInfo_Agency_Two__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_InvestorInfo_Agency_Three__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_InvestorInfo_Agency_Three___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_InvestorInfo_Agency_Three__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_InvestorInfo_Agency_Question__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_InvestorInfo_Agency_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_InvestorInfo_Agency_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_InvestorInfo_Personal_One__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_InvestorInfo_Personal_One___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_InvestorInfo_Personal_One__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_Personal_Question__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_Personal_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_Personal_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_InvestorInfo_Product_One__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_InvestorInfo_Product_One___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_InvestorInfo_Product_One__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_InvestorInfo_Product_Two__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_InvestorInfo_Product_Two___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_InvestorInfo_Product_Two__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_InvestorInfo_Product_Three__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_InvestorInfo_Product_Three___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_InvestorInfo_Product_Three__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_InvestorInfo_Product_Question__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_InvestorInfo_Product_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_InvestorInfo_Product_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Share_Index__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Share_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_Share_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Share_page_one__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Share_page_one___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_components_Share_page_one__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Share_page_two__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Share_page_two___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_components_Share_page_two__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Share_page_three__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Share_page_three___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_components_Share_page_three__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_Share_page_four__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_Share_page_four___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_components_Share_page_four__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_Share_page_five__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_Share_page_five___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_components_Share_page_five__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_Share_page_six__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_Share_page_six___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_components_Share_page_six__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_Share_page_seven__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_Share_page_seven___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_components_Share_page_seven__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_Share_page_eight__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_Share_page_eight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_components_Share_page_eight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_Relation__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_Relation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_components_Relation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_Download__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_Download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_components_Download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_DownloadDemo__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_DownloadDemo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_components_DownloadDemo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_Guide_guideList__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_Guide_guideList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_components_Guide_guideList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_Guide_registerGuide__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_Guide_registerGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_components_Guide_registerGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_Guide_Confirm_confirmListGuide__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_Guide_Confirm_confirmListGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_components_Guide_Confirm_confirmListGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_Guide_appointmentStepGuide__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_Guide_appointmentStepGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_components_Guide_appointmentStepGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_components_Guide_appointmentConfStepGuide__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_components_Guide_appointmentConfStepGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_components_Guide_appointmentConfStepGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_Guide_contractStepGuide__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_Guide_contractStepGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_components_Guide_contractStepGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_components_Guide_inviteGuide__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_components_Guide_inviteGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_components_Guide_inviteGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_components_Guide_confirmGuide__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_components_Guide_confirmGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_components_Guide_confirmGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_components_Guide_riskGuide__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_components_Guide_riskGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_components_Guide_riskGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_components_Guide_appointmentGuide__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_components_Guide_appointmentGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_components_Guide_appointmentGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_components_Guide_createProductGuide__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_components_Guide_createProductGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_components_Guide_createProductGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_components_Guide_recordGuide__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_components_Guide_recordGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_components_Guide_recordGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_components_Guide_contractGuide__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_components_Guide_contractGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_components_Guide_contractGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_components_Guide_orderStateGuide__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_components_Guide_orderStateGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_components_Guide_orderStateGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_components_Guide_findPwdGuide__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_components_Guide_findPwdGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_components_Guide_findPwdGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_components_Guide_Confirm_perNormalConfirm__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_components_Guide_Confirm_perNormalConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_components_Guide_Confirm_perNormalConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_components_Guide_Confirm_perEmpConfirm__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_components_Guide_Confirm_perEmpConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_components_Guide_Confirm_perEmpConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_components_Guide_Confirm_perProConfirm__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_components_Guide_Confirm_perProConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_components_Guide_Confirm_perProConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_components_Guide_Confirm_orgNorConfirm__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_components_Guide_Confirm_orgNorConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_components_Guide_Confirm_orgNorConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_components_Guide_Confirm_orgSelfConfirm__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_components_Guide_Confirm_orgSelfConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_components_Guide_Confirm_orgSelfConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_components_Guide_Confirm_orgProConfirm__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_components_Guide_Confirm_orgProConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_components_Guide_Confirm_orgProConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_components_Guide_Confirm_orgFinConfirm__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_components_Guide_Confirm_orgFinConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_components_Guide_Confirm_orgFinConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_components_AgreeUpdate_index__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_components_AgreeUpdate_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_components_AgreeUpdate_index__);










// 投资者信息表-机构




// 投资者信息表-个人


// 机构产品买产品




// 分享







































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var Routes = [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_2_components_Index___default.a, meta: { title: '首页' } }, { path: '/evaluation/one', component: __WEBPACK_IMPORTED_MODULE_3_components_Evaluation_One___default.a, meta: { title: '风险测评问卷' } }, { path: '/evaluation/question', component: __WEBPACK_IMPORTED_MODULE_4_components_Evaluation_Question___default.a, meta: { title: '风险测评问卷' } }, { path: '/evaluation/lastlow', component: __WEBPACK_IMPORTED_MODULE_5_components_Evaluation_lastLow___default.a, meta: { title: '最低风险承受能力选择' } }, { path: '/evaluation/lastlowend', component: __WEBPACK_IMPORTED_MODULE_6_components_Evaluation_lastLowEnd___default.a, meta: { title: '风险承受等级' } }, { path: '/evaluation/batchlow', component: __WEBPACK_IMPORTED_MODULE_7_components_Evaluation_batchLow___default.a, meta: { title: '最低风险承受能力选择' } }, { path: '/evaluation/normal', component: __WEBPACK_IMPORTED_MODULE_8_components_Evaluation_normal___default.a, meta: { title: '风险承受等级' } }, { path: '/investor/agency/one', component: __WEBPACK_IMPORTED_MODULE_9_components_InvestorInfo_Agency_One___default.a, meta: { title: '投资者信息表' } }, { path: '/investor/agency/two', component: __WEBPACK_IMPORTED_MODULE_10_components_InvestorInfo_Agency_Two___default.a, meta: { title: '投资者信息表' } }, { path: '/investor/agency/three', component: __WEBPACK_IMPORTED_MODULE_11_components_InvestorInfo_Agency_Three___default.a, meta: { title: '投资者信息表' } }, { path: '/investor/agency/four', component: __WEBPACK_IMPORTED_MODULE_12_components_InvestorInfo_Agency_Question___default.a, meta: { title: '投资者信息表' } }, { path: '/investor/personal/one', component: __WEBPACK_IMPORTED_MODULE_13_components_InvestorInfo_Personal_One___default.a, meta: { title: '投资者信息表' } }, { path: '/investor/personal/question', component: __WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_Personal_Question___default.a, meta: { title: '投资者信息表' } }, { path: '/investor/product/one', component: __WEBPACK_IMPORTED_MODULE_15_components_InvestorInfo_Product_One___default.a, meta: { title: '投资者信息表' } }, { path: '/investor/product/two', component: __WEBPACK_IMPORTED_MODULE_16_components_InvestorInfo_Product_Two___default.a, meta: { title: '投资者信息表' } }, { path: '/investor/product/three', component: __WEBPACK_IMPORTED_MODULE_17_components_InvestorInfo_Product_Three___default.a, meta: { title: '投资者信息表' } }, { path: '/investor/product/four', component: __WEBPACK_IMPORTED_MODULE_18_components_InvestorInfo_Product_Question___default.a, meta: { title: '投资者信息表' } }, { path: '/share/index', component: __WEBPACK_IMPORTED_MODULE_19_components_Share_Index___default.a, meta: { title: '特定对象认证' } }, { path: '/share/one', component: __WEBPACK_IMPORTED_MODULE_20_components_Share_page_one___default.a, meta: { title: '特定对象认证' } }, { path: '/share/two', component: __WEBPACK_IMPORTED_MODULE_21_components_Share_page_two___default.a, meta: { title: '特定对象认证' } }, { path: '/share/three', component: __WEBPACK_IMPORTED_MODULE_22_components_Share_page_three___default.a, meta: { title: '特定对象认证' } }, { path: '/share/four', component: __WEBPACK_IMPORTED_MODULE_23_components_Share_page_four___default.a, meta: { title: '特定对象认证' } }, { path: '/share/five', component: __WEBPACK_IMPORTED_MODULE_24_components_Share_page_five___default.a, meta: { title: '特定对象认证' } }, { path: '/share/six', component: __WEBPACK_IMPORTED_MODULE_25_components_Share_page_six___default.a, meta: { title: '特定对象认证' } }, { path: '/share/seven', component: __WEBPACK_IMPORTED_MODULE_26_components_Share_page_seven___default.a, meta: { title: '特定对象认证' } }, { path: '/share/eight', component: __WEBPACK_IMPORTED_MODULE_27_components_Share_page_eight___default.a, meta: { title: '特定对象认证' } }, { path: '/relation', component: __WEBPACK_IMPORTED_MODULE_28_components_Relation___default.a, meta: { title: '投资者关联' } }, { path: '/download', component: __WEBPACK_IMPORTED_MODULE_29_components_Download___default.a, meta: { title: 'App下载' } }, { path: '/downloadDemo', component: __WEBPACK_IMPORTED_MODULE_30_components_DownloadDemo___default.a, meta: { title: 'App下载' } }, { path: '/guide/list', component: __WEBPACK_IMPORTED_MODULE_31_components_Guide_guideList___default.a, meta: { title: '投资者APP操作手册' } }, { path: '/guide/register', component: __WEBPACK_IMPORTED_MODULE_32_components_Guide_registerGuide___default.a, meta: { title: '账户注册流程' } }, { path: '/guide/confirmList', component: __WEBPACK_IMPORTED_MODULE_33_components_Guide_Confirm_confirmListGuide___default.a, meta: { title: '特定对象确认流程' } }, { path: '/guide/appointmentStep', component: __WEBPACK_IMPORTED_MODULE_34_components_Guide_appointmentStepGuide___default.a, meta: { title: '预约申请流程' } }, { path: '/guide/appointmentConStep', component: __WEBPACK_IMPORTED_MODULE_35_components_Guide_appointmentConfStepGuide___default.a, meta: { title: '预约确认流程' } }, { path: '/guide/contractStep', component: __WEBPACK_IMPORTED_MODULE_36_components_Guide_contractStepGuide___default.a, meta: { title: '合同签署流程说明' } }, { path: '/guide/invite', component: __WEBPACK_IMPORTED_MODULE_37_components_Guide_inviteGuide___default.a, meta: { title: '邀请码关联' } }, { path: '/guide/confirm', component: __WEBPACK_IMPORTED_MODULE_38_components_Guide_confirmGuide___default.a, meta: { title: '身份认证' } }, { path: '/guide/risk', component: __WEBPACK_IMPORTED_MODULE_39_components_Guide_riskGuide___default.a, meta: { title: '风险承受能力测评' } }, { path: '/guide/appointment', component: __WEBPACK_IMPORTED_MODULE_40_components_Guide_appointmentGuide___default.a, meta: { title: '预约申请' } }, { path: '/guide/createProduct', component: __WEBPACK_IMPORTED_MODULE_41_components_Guide_createProductGuide___default.a, meta: { title: '创建产品（产品买产品）' } }, { path: '/guide/record', component: __WEBPACK_IMPORTED_MODULE_42_components_Guide_recordGuide___default.a, meta: { title: '双录' } }, { path: '/guide/contract', component: __WEBPACK_IMPORTED_MODULE_43_components_Guide_contractGuide___default.a, meta: { title: '合同签署' } }, { path: '/guide/orderState', component: __WEBPACK_IMPORTED_MODULE_44_components_Guide_orderStateGuide___default.a, meta: { title: '订单状态说明' } }, { path: '/guide/findPwd', component: __WEBPACK_IMPORTED_MODULE_45_components_Guide_findPwdGuide___default.a, meta: { title: '如何找回密码' } }, { path: '/guide/confirm/perNor', component: __WEBPACK_IMPORTED_MODULE_46_components_Guide_Confirm_perNormalConfirm___default.a, meta: { title: '普通投资者自然人' } }, { path: '/guide/confirm/perPro', component: __WEBPACK_IMPORTED_MODULE_48_components_Guide_Confirm_perProConfirm___default.a, meta: { title: '专业投资者自然人' } }, { path: '/guide/confirm/perEmp', component: __WEBPACK_IMPORTED_MODULE_47_components_Guide_Confirm_perEmpConfirm___default.a, meta: { title: '员工跟股' } }, { path: '/guide/confirm/orgNor', component: __WEBPACK_IMPORTED_MODULE_49_components_Guide_Confirm_orgNorConfirm___default.a, meta: { title: '普通投资者机构' } }, { path: '/guide/confirm/orgPro', component: __WEBPACK_IMPORTED_MODULE_51_components_Guide_Confirm_orgProConfirm___default.a, meta: { title: '专业投资者机构' } }, { path: '/guide/confirm/orgSelf', component: __WEBPACK_IMPORTED_MODULE_50_components_Guide_Confirm_orgSelfConfirm___default.a, meta: { title: '本机构' } }, { path: '/guide/confirm/orgFin', component: __WEBPACK_IMPORTED_MODULE_52_components_Guide_Confirm_orgFinConfirm___default.a, meta: { title: '金融机构' } },

// 服务协议及隐私变更通知
{ path: '/agreeupdate/index', name: 'agreeupdate', component: __WEBPACK_IMPORTED_MODULE_53_components_AgreeUpdate_index___default.a, meta: { title: '服务协议及隐私变更通知' } }];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: Routes,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_browser__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_integrations__ = __webpack_require__(369);




__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["a" /* init */]({
  dsn: 'https://317d2a2048264e00ba955b1c9a8f2d2c@sentry.io/1516971',
  integrations: [new __WEBPACK_IMPORTED_MODULE_2__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */], attachProps: true })]
});

// import { captureMessage, captureException } from '@sentry/browser'

// captureMessage('Something went wrong')

// try {
//   aFunctionThatMightFail();
// } catch (err) {
//   captureException(err);
// }

/***/ }),
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */,
/* 342 */,
/* 343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(877)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(1089),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = enctypeAes;
/* harmony export (immutable) */ __webpack_exports__["g"] = dectyptAES;
/* harmony export (immutable) */ __webpack_exports__["a"] = uuid;
/* harmony export (immutable) */ __webpack_exports__["e"] = authorization;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTimeStamp;
/* unused harmony export encryptMd5 */
/* harmony export (immutable) */ __webpack_exports__["d"] = encryptBase64;
/* harmony export (immutable) */ __webpack_exports__["f"] = decryptBase64;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js__);


var a = '2a4ac92b';
var b = '8217a77a';
var c = '44bf0314';
var d = 'c4e1b101';
var key = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse('' + a + b);
var iv = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse('' + c + d);
/**
 * AES加密
 * @param  {[type]} prama     [description]
 * @param  {[type]} timestamp [description]
 * @return {[type]}           [description]
 */
function enctypeAes(prama, timestamp) {
  // 成产key
  var KeyStr = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.SHA256(timestamp).toString().substring(0, 16);
  var key = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(KeyStr);
  // 生产 iv
  var ivStr = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.SHA256(KeyStr + timestamp).toString().substring(0, 16);
  var iv = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(ivStr);
  // 加密
  var encryptResult = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.AES.encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(prama), key, {
    iv: iv,
    mode: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.mode.CBC,
    padding: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.pad.Pkcs7
  });
  return encryptResult.toString();
}
/**
 * 解密
 * @param       {[type]} content [description]
 * @constructor
 * @return      {[type]}         [description]
 */
function dectyptAES(content) {
  var bytes = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.AES.decrypt(content.toString(), key, {
    iv: iv,
    mode: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.mode.CBC,
    padding: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.pad.Pkcs7
  });
  return bytes.toString(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8);
}
/**
 * 获取请求uuid
 * @return {[type]} [description]
 */
function uuid() {
  var s = [];
  var hexDigits = '0123456789abcdef';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';

  var uuid = s.join('');
  return uuid;
}
/**
 * 公共参数
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
var getDevice = function getDevice() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
  // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (isAndroid) {
    return 'Android';
  } else {
    return 'IOS';
  }
};

function authorization(currTimeStamp, body, au) {
  var data = {};
  data.os = getDevice();
  data.version = '3.0';
  data.timestamp = currTimeStamp;
  data.access_token = encryptMd5(currTimeStamp).substring(11, 17).toUpperCase();
  data.cm = encryptMd5(body);
  data.au = au;
  return data;
}

/**
 * 获取时间戳
 * @return {[type]} [description]
 */
function getTimeStamp() {
  return new Date().getTime().toString();
}

/**
 * md5加密
 * @param  {[type]} prama [description]
 * @return {[type]}       [description]
 */
function encryptMd5(prama) {
  return __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.MD5(prama).toString();
}

/**
 * Base64转码
 * @param  {[type]} prama [description]
 * @return {[type]}       [description]
 */
function encryptBase64(prama) {
  var str = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(prama);
  return __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Base64.stringify(str);
}

/**
 * Base64解码
 * @param  {[type]} prama [description]
 * @return {[type]}       [description]
 */
function decryptBase64(prama) {
  var str = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Base64.parse(prama);
  return str.toString(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8);
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_evaluation__ = __webpack_require__(53);


var _this = this;

/**
 * Created by Administrator on 2018/5/10.
 */


var getSignResult = function getSignResult(signFile, vm) {
  var data = {
    sysCode: vm.params.sysCode,
    managerAdminUserId: vm.params.managerId,
    userId: vm.params.invenstemUserId, // 理财师添加的用户ID
    platformUserId: vm.params.platformUserId,
    evaluationResultFile: vm.params.evaluationResultFile,
    signImagesFileInfo: signFile
  };
  console.log('合成签名提交的数据：', data);
  vm.$vux.loading.show({ text: '签名合成中' });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_evaluation__["a" /* quesSignSave */])(data, vm.params.au).then(function (res) {
    vm.$vux.loading.hide();
    if (res.code === 0) {
      console.log('签章合成返回', res);
      vm.params.evaluationResultFileSign = res.data.bean.evaluationResultFileSign;
      vm.$vux.toast.show({ text: '签署成功', type: 'success' });
      switchRouter(vm);
    } else {
      vm.$vux.toast.show({ text: res.msg, type: 'warn' });
    }
  }).catch(function (e) {
    _this.$vux.loading.hide();
    _this.$vux.toast.show({ text: '服务器繁忙, 请重试', type: 'warn' });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(e);
  });
};

var switchRouter = function switchRouter(vm) {
  console.log('风险测评签署跳转数据', vm);
  var re = vm.params.re;
  if (re === 1) {
    // 最低风险等级
    vm.$router.push({ path: '/evaluation/lastlowend', query: vm.params });
    return;
  }
  if (re === 2) {
    // 正常情况
    vm.$router.push({ path: '/evaluation/normal', query: vm.params });
    return;
  }
  if (re === 3) {
    // 比原等级低
    vm.$router.push({ path: '/evaluation/batchlow', query: vm.params });
  }
};

var signPdf = function signPdf(vm) {
  var isNeedSign = parseInt(vm.params.isNeedSign);
  if (isNeedSign === 1) {
    vm.$bridge.registerHandler('getSignData', function (data) {
      getSignResult(data, vm);
    });
    vm.$bridge.callHandler('sign', { message: '用户签名', userId: vm.params.userId }, function (data) {});
  }
};

/* harmony default export */ __webpack_exports__["a"] = (signPdf);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bridge_webview__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bridge_webview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bridge_webview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fastclick__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_toast_index_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_alert_index_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_plugins_loading_index_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_confirm_index_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_polyfill__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_js_my_util__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_css_commom_css__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_css_commom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_css_commom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_globalmount__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vant__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vant_lib_vant_css_index_css__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vant_lib_vant_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vant_lib_vant_css_index_css__);





















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vant__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13__plugins_globalmount__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_bridge_webview___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_toast_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_alert_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vux_src_plugins_loading_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_confirm_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_fastclick___default.a.attach(document.body);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.isDev = "production" !== 'production';
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$util = __WEBPACK_IMPORTED_MODULE_11__common_js_my_util__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.initTime = 3000;
__WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].beforeEach(function (to, from, next) {
  window.document.title = to.meta.title;
  next();
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_9__App___default.a);
  }
}).$mount('#app-box');

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alert',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_router__ = __webpack_require__(160);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_router__["a" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_router__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__props__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_clean_style__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__ = __webpack_require__(507);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cell',
  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_0__inline_desc___default.a
  },
  props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__props__["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__libs_clean_style__["a" /* default */])({
        width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__["a" /* default */])(this, 'labelWidth'),
        textAlign: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__["a" /* default */])(this, 'labelAlign'),
        marginRight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__icon__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'check-icon',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__icon___default.a
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.value) === 'object' && isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(one);
          }).indexOf(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function isEqual(obj1, obj2) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj1) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj2);
}

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirm',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datetime__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datetime_datetimepicker__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_assign__);
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datetime-view',
  extends: __WEBPACK_IMPORTED_MODULE_0__datetime___default.a,
  methods: {
    render: function render() {
      var _this = this;

      this.$nextTick(function () {
        _this.picker && _this.picker.destroy();
        _this.picker = new __WEBPACK_IMPORTED_MODULE_1__datetime_datetimepicker__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2_object_assign___default()(_this.pickerOptions, {
          renderInline: true
        }));
        // #2797
        _this.$nextTick(function () {
          _this.picker.show();
        });
      });
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datetimepicker__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__group__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_uuid__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_date_format__ = __webpack_require__(241);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datetime',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_uuid__["a" /* default */]],
  components: {
    Group: __WEBPACK_IMPORTED_MODULE_3__group___default.a,
    InlineDesc: __WEBPACK_IMPORTED_MODULE_4__inline_desc___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_1__icon___default.a
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new __WEBPACK_IMPORTED_MODULE_2__datetimepicker__["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tools_date_format__["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_clean_style__ = __webpack_require__(121);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'group',
  methods: {
    cleanStyle: __WEBPACK_IMPORTED_MODULE_0__libs_clean_style__["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inline-desc'
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cell__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popup__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__radio__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__radio_props__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cell_props__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_transfer_dom__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_array_find__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_array_find__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _cellProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__cell_props__["a" /* default */])();
delete _cellProps.value;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup-radio',
  components: {
    Popup: __WEBPACK_IMPORTED_MODULE_3__popup___default.a,
    Radio: __WEBPACK_IMPORTED_MODULE_4__radio___default.a,
    Cell: __WEBPACK_IMPORTED_MODULE_2__cell___default.a
  },
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_7__directives_transfer_dom__["a" /* default */]
  },
  props: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    placeholder: String,
    readonly: Boolean
  }, _cellProps, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__radio_props__["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.options[0]) === 'object') {
        var match = __WEBPACK_IMPORTED_MODULE_8_array_find___default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_dom__ = __webpack_require__(238);

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new __WEBPACK_IMPORTED_MODULE_1__popup__["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && __WEBPACK_IMPORTED_MODULE_2__libs_dom__["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && __WEBPACK_IMPORTED_MODULE_2__libs_dom__["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_base__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checklist_object_filter__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__props__ = __webpack_require__(237);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'radio',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__libs_base__["a" /* default */]],
  filters: {
    getValue: __WEBPACK_IMPORTED_MODULE_1__checklist_object_filter__["a" /* getValue */],
    getKey: __WEBPACK_IMPORTED_MODULE_1__checklist_object_filter__["b" /* getKey */]
  },
  props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__props__["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: __WEBPACK_IMPORTED_MODULE_1__checklist_object_filter__["a" /* getValue */],
    getKey: __WEBPACK_IMPORTED_MODULE_1__checklist_object_filter__["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__checklist_object_filter__["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_uuid__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_clean_style__ = __webpack_require__(121);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var findByKey = function findByKey(key, options) {
  var _rs = __WEBPACK_IMPORTED_MODULE_1_array_find___default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'selector',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_uuid__["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: __WEBPACK_IMPORTED_MODULE_3__libs_clean_style__["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(510);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_router__ = __webpack_require__(160);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__ = __webpack_require__(509);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_base__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_debounce__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vanilla_masker__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vanilla_masker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vanilla_masker__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: __WEBPACK_IMPORTED_MODULE_5_validator_lib_isEmail___default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return __WEBPACK_IMPORTED_MODULE_6_validator_lib_isMobilePhone___default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tools_debounce__["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__libs_base__["a" /* default */]],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2__icon___default.a,
    InlineDesc: __WEBPACK_IMPORTED_MODULE_4__inline_desc___default.a,
    Toast: __WEBPACK_IMPORTED_MODULE_3__toast___default.a
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? __WEBPACK_IMPORTED_MODULE_8_vanilla_masker___default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_big_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_big_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_big_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new __WEBPACK_IMPORTED_MODULE_0_big_js___default.a(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new __WEBPACK_IMPORTED_MODULE_0_big_js___default.a(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_clean_style__ = __webpack_require__(121);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-switch',
  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_0__inline_desc___default.a
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_clean_style__["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_base__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inline_desc__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autosize__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_autosize__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-textarea',
  minxins: [__WEBPACK_IMPORTED_MODULE_0__libs_base__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_1__inline_desc___default.a
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      __WEBPACK_IMPORTED_MODULE_2_autosize___default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      __WEBPACK_IMPORTED_MODULE_2_autosize___default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      __WEBPACK_IMPORTED_MODULE_2_autosize___default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_flexbox_flexbox_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_flexbox_flexbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_flexbox_flexbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_item_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_api_investor__ = __webpack_require__(61);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue___default.a,
    Flexbox: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_flexbox_flexbox_vue___default.a,
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_item_vue___default.a
  },
  data: function data() {
    return {
      loading: true,
      text: '加载中',
      title: '服务协议及隐私变更通知',
      content: '',
      noticeType: '1', // 0 按钮 1 按钮 2 按钮
      readyForm: {
        sysName: 'TTD_FUND_GJ',
        userId: '',
        ids: ''
      },
      au: '',
      testContent: '{"au":"VS8rOW5LdmM2aVE2WFp3M1VtTHBiL0JsOUtHQzUzdk5NN3B4RlZKMTlvcDJKc2dtTitMT1BnQWhubHhGRnNnNQ==","content":"1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","created":1528427440000,"id":38756,"introduction":"1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","title":"\u661F\u671F\u4E94\u516C\u544A2","userId":1757}'
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$bridge.registerHandler('agreeNotice', function (data) {
        console.log(data, 333);
        _this.agreeNotiec(data);
      });
      _this.getAgreeInfo();
    }, 1000);

    this.init('getParamsJson', function (res) {
      console.log(res, 222);
      var data = JSON.parse(res);
      _this.noticeType = data.noticeType;
      _this.readyForm.userId = data.userId;
      _this.readyForm.ids = data.id;
      _this.au = data.au;
      _this.$refs.content.innerHTML = data.content;
    });
  },

  computed: {},
  methods: {
    init: function init(fun, callback) {
      window.initValue = function (options) {
        var res = window.injs[fun]();
        callback(res);
      };
    },
    getAgreeInfo: function getAgreeInfo() {
      var _this2 = this;

      this.$bridge.callHandler('getOptionsJson', { message: '获取内容' }, function (res) {
        console.log(res, 111);
        var data = JSON.parse(res);
        _this2.noticeType = data.noticeType;
        _this2.readyForm.userId = data.userId;
        _this2.readyForm.ids = data.id.toString();
        _this2.au = data.au;
        _this2.$refs.content.innerHTML = data.content;
      });
    },
    agree: function agree() {
      var _this3 = this;

      console.log(this.readyForm);
      console.log({ au: this.au });
      if (this.readyForm.userId && this.readyForm.ids && this.au) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_api_investor__["a" /* msgReady */])(this.readyForm, this.au).then(function (res) {
          if (res.code === 0 || res.code === 1001) {
            _this3.$bridge.callHandler('agreeNotice', { message: '已同意' }, function (data) {});
          } else {
            _this3.$vux.toast.show({ type: 'warn', text: res.msg });
          }
        });
      } else {
        this.$vux.toast.show({ type: 'warn', text: '消息内容不完整' });
      }
    },
    notAgree: function notAgree() {
      this.$bridge.callHandler('disAgreeNotice', { message: '不同意' }, function (data) {});
    },
    agreeNotiec: function agreeNotiec(info) {
      var _this4 = this;

      var data = JSON.parse(info);
      if (data.userId && data.ids && data.au) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_api_investor__["a" /* msgReady */])({ sysName: 'TTD_FUND_GJ', userId: data.userId, ids: data.ids }, this.au).then(function (res) {
          if (res.code === 0 || res.code === 1001) {
            _this4.$bridge.callHandler('agreeNotice', { message: '已同意' }, function (data) {});
          } else {
            _this4.$vux.toast.show({ type: 'warn', text: res.msg });
          }
        });
      } else {
        this.$vux.toast.show({ type: 'warn', text: '消息内容不完整' });
      }
    }
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_baseurl__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue___default.a
  },
  data: function data() {
    return {

      androidInvestorUrl: __WEBPACK_IMPORTED_MODULE_1__api_baseurl__["b" /* appDownloadDemo */].androidInvestorUrl, // 投资者
      androidFinancialUrl: __WEBPACK_IMPORTED_MODULE_1__api_baseurl__["b" /* appDownloadDemo */].androidFinancialUrl, // 企业版
      iosInvestorUrl: __WEBPACK_IMPORTED_MODULE_1__api_baseurl__["b" /* appDownloadDemo */].iosInvestorUrl,
      iosFinancialUrl: __WEBPACK_IMPORTED_MODULE_1__api_baseurl__["b" /* appDownloadDemo */].iosFinancialUrl,
      isWeiXin: false,
      appName: '',
      notMatch: true
    };
  },
  created: function created() {
    this.initDownload();
    console.log('process.env.VUE_APP_MODE ---', "prod");
  },

  methods: {
    initDownload: function initDownload() {
      var u = navigator.userAgent;

      this.appName = Number(this.$route.query.isInvestor) === 1 ? '妥私募' : '妥私募企业版';

      this.isWeiXin = u.indexOf('MicroMessenger') > -1;
      if (this.isWeiXin) {
        // 微信里面不进行下载
        return;
      }

      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;

      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (this.isDev) {
        console.log('isAndroid:' + isAndroid + ',isiOS:' + isiOS + ', query:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.query));
      } else {
        if (isAndroid) {
          this.toDownload(1);
        } else if (isiOS) {
          this.toDownload(2);
        } else {

          this.notMatch = true;
        }
      }
    },
    toDownload: function toDownload(version) {
      if (version === 1) {
        if (Number(this.$route.query.isInvestor) === 1) {

          window.location.href = this.androidInvestorUrl;
        } else {

          window.location.href = this.androidFinancialUrl;
        }
      } else if (version === 2) {
        if (Number(this.$route.query.isInvestor) === 1) {

          window.location.href = this.iosInvestorUrl;
        } else {

          window.location.href = this.iosFinancialUrl;
        }
      } else {
        var _this = this;
        this.$vux.alert.show({
          title: '提示',
          content: '未检测到设备信息',
          onHide: function onHide() {
            _this.$router.go(-1);
          }
        });
      }
    }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_baseurl__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_button_index_vue___default.a
  },
  data: function data() {
    return {

      androidInvestorUrl: __WEBPACK_IMPORTED_MODULE_1__api_baseurl__["c" /* appDownload */].androidInvestorUrl, // 投资者
      androidFinancialUrl: __WEBPACK_IMPORTED_MODULE_1__api_baseurl__["c" /* appDownload */].androidFinancialUrl, // 企业版
      iosInvestorUrl: __WEBPACK_IMPORTED_MODULE_1__api_baseurl__["c" /* appDownload */].iosInvestorUrl,
      iosFinancialUrl: __WEBPACK_IMPORTED_MODULE_1__api_baseurl__["c" /* appDownload */].iosFinancialUrl,
      isWeiXin: false,
      appName: '',
      notMatch: true
    };
  },
  created: function created() {
    this.initDownload();
    console.log('process.env.VUE_APP_MODE ---', "prod");
  },

  methods: {
    initDownload: function initDownload() {
      var u = navigator.userAgent;

      this.appName = Number(this.$route.query.isInvestor) === 1 ? '妥私募' : '妥私募企业版';

      this.isWeiXin = u.indexOf('MicroMessenger') > -1;
      if (this.isWeiXin) {
        // 微信里面不进行下载
        return;
      }

      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;

      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (this.isDev) {
        console.log('isAndroid:' + isAndroid + ',isiOS:' + isiOS + ', query:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.query));
      } else {
        if (isAndroid) {
          this.toDownload(1);
        } else if (isiOS) {
          this.toDownload(2);
        } else {

          this.notMatch = true;
        }
      }
    },
    toDownload: function toDownload(version) {
      if (version === 1) {
        if (Number(this.$route.query.isInvestor) === 1) {

          window.location.href = this.androidInvestorUrl;
        } else {

          window.location.href = this.androidFinancialUrl;
        }
      } else if (version === 2) {
        if (Number(this.$route.query.isInvestor) === 1) {

          window.location.href = this.iosInvestorUrl;
        } else {

          window.location.href = this.iosFinancialUrl;
        }
      } else {
        var _this = this;
        this.$vux.alert.show({
          title: '提示',
          content: '未检测到设备信息',
          onHide: function onHide() {
            _this.$router.go(-1);
          }
        });
      }
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_cell_index_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_cell_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_cell_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_card_index_vue__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_card_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_card_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_radio_index_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_radio_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_radio_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_tools_date_format_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_evaluation__ = __webpack_require__(53);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_loading_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue___default.a,
    Cell: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_cell_index_vue___default.a,
    Card: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_card_index_vue___default.a,
    Radio: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_radio_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue___default.a
  },
  data: function data() {
    return {
      isDevBak: false,
      loading: true,
      time: '',

      params: { "appName": null, "au": "VS8rOW5LdmM2aVE2WFp3M1VtTHBiMnkwa09jN043TExHb01NU1BTbkFZeG1kQlpJK3dTYk9qa1IyZ0g4dzFhdw==", "invenstemUserId": 8023, "mac": null, "managerId": 7956, "os": null, "platformUserId": 8022, "productId": 0, "productUrl": null, "specialObj": false, "stepCurrent": 0, "stepTotal": 0, "sysCode": "1003", "type": null, "userId": 8023, "userName": "李彬杰", "userType": null, "version": null },

      stepCurrent: 0,
      stepTotal: 4,
      question: {}
    };
  },
  created: function created() {
    this.$vux.loading.show({ text: '加载中' });
    this.$_evaluation_time();
    this.$_evaluation_init();
  },

  methods: {
    $_evaluation_back: function $_evaluation_back() {
      this.$bridge.callHandler('finish', { message: '关闭h5' }, function (data) {
        console.log('finish');
      });
    },
    $_evaluation_time: function $_evaluation_time() {
      var _this2 = this;

      this.time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vux_src_tools_date_format_js__["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');
      setInterval(function () {
        _this2.time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vux_src_tools_date_format_js__["a" /* default */])(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }, 1000);
    },
    $_evaluation_init: function $_evaluation_init() {
      var _this3 = this;

      var _this = this;
      setTimeout(function () {
        if (_this.isDevBak) {
          _this3.questionNewList().then(function () {
            _this.$vux.loading.hide();
            _this.loading = false;
          });
        } else {
          _this.$bridge.callHandler('getUserInfo', { message: '获取用户信息: managerId,userId,userName,sysCode(1003,1004), au' }, function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(data) {
              var res;
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _this.$vux.loading.hide();
                      res = JSON.parse(data);

                      console.log(res);

                      if (!(res.userName && res.userId && res.managerId && res.sysCode && res.au)) {
                        _context.next = 19;
                        break;
                      }

                      _this3.params.userName = res.userName;
                      _this3.params.userId = parseInt(res.userId);
                      _this3.params.platformUserId = parseInt(res.platformUserId);
                      _this3.params.managerId = parseInt(res.managerId);
                      _this3.params.invenstemUserId = parseInt(res.invenstemUserId);
                      _this3.params.sysCode = parseInt(res.sysCode);
                      _this3.params.au = res.au;
                      _this3.params.specialObj = res.specialObj ? 'true' : 'false';
                      _this3.stepCurrent = parseInt(res.stepCurrent);
                      _this3.stepTotal = parseInt(res.stepTotal);

                      _context.next = 16;
                      return _this3.questionNewList();

                    case 16:
                      _this.loading = false;
                      _context.next = 20;
                      break;

                    case 19:
                      _this.$vux.toast.show({
                        type: 'warn',
                        text: '用户信息获取失败'
                      });

                    case 20:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this3);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        }
      }, this.initTime);
    },
    $_evaluation_test: function $_evaluation_test() {
      this.$router.push({ path: '/evaluation/question', query: this.params });
    },
    questionNewList: function questionNewList() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  sysCode: _this4.params.sysCode,
                  managerAdminUserId: _this4.params.managerId
                };
                _context2.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__api_evaluation__["g" /* questionNewList */])(params, _this4.params.au);

              case 3:
                resp = _context2.sent;

                if (!(resp.code === 0)) {
                  _context2.next = 9;
                  break;
                }

                _this4.question = resp.data.list[0];
                _this4.params.version = resp.data.list[0].queationVersion;
                _context2.next = 11;
                break;

              case 9:
                _this4.$vux.toast.show({
                  type: 'warn',
                  text: '获取问卷失败'
                });
                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('获取问卷失败'));

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_radio_index_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_radio_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_radio_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_flexbox_flexbox_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_flexbox_flexbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_flexbox_flexbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_flexbox_flexbox_item_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_flexbox_flexbox_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_flexbox_flexbox_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_api_evaluation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__signHandle__ = __webpack_require__(407);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_loading_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue___default.a,
    Radio: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_radio_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue___default.a,
    Flexbox: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_flexbox_flexbox_vue___default.a,
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_flexbox_flexbox_item_vue___default.a
  },
  filters: {
    formatAnswer: function formatAnswer(content, i) {
      return String.fromCharCode(65 + i) + '. ' + content;
    }
  },
  data: function data() {
    return {
      params: '',
      loading: true,
      show: false,
      isSubmit: false,
      list: {
        sysCode: '',
        pageSize: 100,
        managerAdminUserId: ''
      },
      index: 1,
      question: [],
      subData: {
        sysCode: '',
        managerAdminUserId: '',
        userId: '',
        loginUserId: '',
        answerJsonStr: '',
        version: ''
      }
    };
  },
  created: function created() {
    this.params = this.$route.query;
    this.$vux.loading.show({ text: '加载中' });
    this.judgeNeedSign();
    this.$_evaluation_set();
  },

  computed: {
    total: function total() {
      return this.question.length;
    },
    prevStyle: function prevStyle() {
      return this.index === 1 ? { 'color': '#ccc' } : { 'color': '#666666' };
    },
    nextStyle: function nextStyle() {
      return this.index === this.total ? { 'color': '#ccc' } : { 'color': '#666666' };
    },
    progressPercent: function progressPercent() {
      var endNum = 0;
      if (this.question.every(function (item, index) {
        return item.checked === '';
      })) {
        return 0;
      }
      this.question.forEach(function (item, index) {
        if (item.checked) {
          endNum = endNum + 1;
        }
      });
      return Math.ceil(endNum / this.total * 100) + '%';
    }
  },
  methods: {
    $_evaluation_set: function $_evaluation_set() {
      this.list.sysCode = this.params.sysCode;
      this.list.managerAdminUserId = this.params.managerId;
      this.subData.managerAdminUserId = this.params.managerId;
      this.subData.userId = this.params.invenstemUserId;
      this.subData.sysCode = this.params.sysCode;
      this.subData.loginUserId = this.params.userId;
      this.subData.version = this.params.version;
      this.$_evaluation_init();
    },
    $_evaluation_init: function $_evaluation_init() {
      var _this2 = this;

      var _this = this;
      setTimeout(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_api_evaluation__["f" /* getEvaluation */])(_this2.list, _this2.params.au).then(function (res) {
          _this.loading = false;
          _this.$vux.loading.hide();
          if (res.data.list.length) {
            var dataList = res.data.list[0].questionInfos;
            _this.question = dataList.map(function (item, index) {
              var answerItem = item.answerList.map(function (v, k) {
                return { key: v.answerId + '', value: v.answerContent };
              });
              return { title: item.questionContent, key: item.questionKey, checked: '', options: answerItem };
            });
            console.log(_this.question);
          } else {
            _this.$vux.alert.show({
              title: '提示',
              content: '当前机构或个人没有风险评测问卷',
              onHide: function onHide() {
                _this.$router.go(-1);
              }
            });
          }
        });
      }, 500);
    },
    $_evaluation_back: function $_evaluation_back() {
      var _this = this;
      if (_this.question[0].checked) {
        _this.$vux.confirm.show({
          title: '提示',
          content: '退出将不会保存当前的评测结果，是否继续？',
          onCancel: function onCancel() {
            console.log('plugin cancel');
          },
          onConfirm: function onConfirm() {
            _this.$router.go(-1);
          }
        });
      } else {
        _this.$router.go(-1);
      }
    },
    change: function change(index) {
      var _this3 = this;

      setTimeout(function () {
        if (index === _this3.total) {
          _this3.isSubmit = true;
        } else {
          if (_this3.question[index - 1].checked) {
            _this3.index = index + 1;
          }
        }
      }, 300);
    },
    $_evaluation_next: function $_evaluation_next(index) {
      if (index === this.total) {
        return;
      }
      if (this.question[index - 1].checked) {
        this.index = index + 1;
      } else {
        this.$vux.toast.show({ text: '\u8BF7\u9009\u62E9\u7B26\u5408\u60A8\u7684\u9009\u9879', type: 'warn', position: 'middle' });
      }
    },
    $_evaluation_prev: function $_evaluation_prev(index) {
      if (index === 1) {
        return;
      }
      this.index = index - 1;
    },
    judgeRisk: function judgeRisk(level, orglevel) {
      console.log('测评结果：' + level, '原始风险等级：' + orglevel);
      var specialObj = this.$util.toBoolean(this.params.specialObj);
      if (specialObj) {
        if (level === 'C1') {
          return 1;
        } else {
          return 2;
        }
      } else {
        if (orglevel === '最低风险等级' && level !== 'C1') {
          return 2;
        }
        return level === 'C1' ? 1 : parseInt(level.split('C')[1]) >= parseInt(orglevel.split('C')[1]) ? 2 : 3;
      }
    },
    judgeNeedSign: function judgeNeedSign() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                /* ----------- 2020.7.23 versiont: 1.14  删除风险测评配置是否需要签署, 改为全部签署 ------------ */

                _this4.params.isNeedSign = 1;

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    showPlugin: function showPlugin() {
      var vm = this;
      this.$vux.confirm.show({
        title: '温馨提示',
        content: '本人已经了解并愿意遵守国家有关证券市场、基金市场管理的法律、法规、规章及相关业务规则，本人在此郑重承诺以上填写的内容真实、准确、完整。若本人提供的信息发生任何重大变化，本人将及时书面通知贵公司。',
        onConfirm: function onConfirm() {
          if (vm.params.re === 2) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__signHandle__["a" /* default */])(vm);
            return;
          }
          if (vm.params.re === 3) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__signHandle__["a" /* default */])(vm);
          }
        }
      });
    },
    $_evaluation_submitCal: function $_evaluation_submitCal(index) {
      var _this5 = this;

      var quesJson = [];
      if (this.question[index - 1].checked) {
        this.question.map(function (item) {
          quesJson.push({ questionKey: item.key, answerId: item.checked });
        });
        this.subData.answerJsonStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(quesJson);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_api_evaluation__["e" /* getEvaluationCal */])(this.subData, this.params.au).then(function (res) {
          if (res.code === 0) {
            _this5.params.subData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this5.subData);

            _this5.params.evaluationResultFile = res.data.bean.evaluationResultFile;
            _this5.params.result = res.data.bean.evaluationResult;
            _this5.params.orgResult = res.data.bean.lastEvaluationResult || '';

            _this5.params.re = _this5.judgeRisk(_this5.params.result, _this5.params.orgResult);
            console.log('分析页面跳转状态结果：' + _this5.params.re);

            if (_this5.params.re === 1) {
              _this5.$router.push({ path: '/evaluation/lastlow', query: _this5.params });
              return;
            }

            if (_this5.params.re === 2) {
              _this5.$router.push({ path: '/evaluation/normal', query: _this5.params });
              return;
            }

            if (_this5.params.re === 3) {
              _this5.$router.push({ path: '/evaluation/batchlow', query: _this5.params });
              return;
            }
          } else {
            _this5.isSubmit = true;
            _this5.$vux.toast.show({ type: 'warn', text: res.msg });
          }
        });
      } else {
        this.$vux.toast.show({ text: '\u8BF7\u9009\u62E9\u7B26\u5408\u60A8\u7684\u9009\u9879', type: 'warn', position: 'middle' });
      }
    },
    $_evaluation_set_prefix: function $_evaluation_set_prefix(index) {
      var arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'];
      return arr[index];
    }
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commom_tableList_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commom_tableList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__commom_tableList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_item_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_item_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_api_evaluation__ = __webpack_require__(53);













/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_header_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default.a,
    Flexbox: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_vue___default.a,
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_item_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_button_index_vue___default.a,
    Checker: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_vue___default.a,
    CheckerItem: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_item_vue___default.a,
    TableList: __WEBPACK_IMPORTED_MODULE_0__commom_tableList_vue___default.a
  },
  data: function data() {
    return {
      text: '加载中',
      params: '',
      title: '风险承受等级'
    };
  },
  created: function created() {
    this.params = this.$route.query;
    this.params.specialObj = this.$util.toBoolean(this.params.specialObj);
  },

  computed: {
    level: function level() {
      switch (this.params.result) {
        case 'C1':
          return 'R1';
        case 'C2':
          return 'R1、R2';
        case 'C3':
          return 'R1、R2、R3';
        case 'C4':
          return 'R1、R2、R3、R4';
        case 'C5':
          return 'R1、R2、R3、R4、R5';
      }
    }
  },
  methods: {
    $_evaluation_again: function $_evaluation_again() {
      this.$router.push({ path: '/evaluation/one' });
    },
    $_evaluation_checkSubmit: function $_evaluation_checkSubmit() {
      var _this = this;

      var isNeedSign = parseInt(this.params.isNeedSign);
      if (isNeedSign === 1) {
        this.$bridge.registerHandler('getSignData', function (data) {
          setTimeout(function () {
            _this.$_getSignResult(data);
          }, 30);
        });
        setTimeout(function () {
          _this.$bridge.callHandler('sign', { message: '用户签名', userId: _this.params.userId, result: _this.params.result }, function (data) {});
        }, 30);
      } else {
        this.$_handleSubmit();
      }
    },
    $_getSignResult: function $_getSignResult(signFile) {
      var _this2 = this;

      var data = {
        sysCode: this.params.sysCode,
        managerAdminUserId: this.params.managerId,
        userId: this.params.invenstemUserId, // 理财师添加的用户ID
        platformUserId: this.params.platformUserId,
        evaluationResultFile: this.params.evaluationResultFile,
        signImagesFileInfo: signFile
      };
      console.log('合成签名提交的数据：', data);
      this.$vux.loading.show({ text: '签名合成中' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_api_evaluation__["a" /* quesSignSave */])(data, this.params.au).then(function (res) {
        _this2.$vux.loading.hide();
        if (res.code === 0) {
          console.log('签章合成返回', res);
          _this2.params.evaluationResultFileSign = res.data.bean.evaluationResultFileSign;
          _this2.$vux.toast.show({ text: '签署成功', type: 'success' });
          _this2.$_handleSubmit();
        } else {
          _this2.$vux.toast.show({ text: res.msg, type: 'warn' });
        }
      }).catch(function (e) {
        console.log(e);
        _this2.$vux.loading.hide();
        _this2.$vux.toast.show({ text: '服务器繁忙, 请重试', type: 'warn' });
      });
    },
    $_handleSubmit: function $_handleSubmit() {
      var _this3 = this;

      this.$vux.loading.show({ text: '提交中' });
      var subData = JSON.parse(this.params.subData);
      subData.evaluationResultFile = this.params.evaluationResultFile;
      subData.evaluationResultFileSign = this.params.evaluationResultFileSign;
      console.log(subData);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_api_evaluation__["b" /* getEvaluationSave */])(subData, this.params.au).then(function (res) {
        _this3.$vux.loading.hide();
        if (res.code === 0) {
          _this3.$_evaluation_submit(res.data.bean.evaluationId);
        } else {
          _this3.$vux.toast.show({ type: 'warn', text: res.msg });
        }
      });
    },
    $_evaluation_submit: function $_evaluation_submit(evaluationId) {
      this.$vux.toast.show({ type: 'success', text: '提交成功' });
      this.$bridge.callHandler('getResult', { message: '最后确认', level: this.params.result, evaluationId: evaluationId }, function (data) {
        console.log('submit');
      });
    },
    $_view_quesDetail: function $_view_quesDetail() {
      var viewPdf = this.params.evaluationResultFileSign ? this.params.evaluationResultFileSign : this.params.evaluationResultFile;
      this.$bridge.callHandler('seePDF', { message: '查看pdf', pdfSign: viewPdf }, function (data) {
        console.log('submit');
      });
    }
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_flexbox_flexbox_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_flexbox_flexbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_flexbox_flexbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_item_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_api_evaluation__ = __webpack_require__(53);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_header_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default.a,
    Flexbox: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_flexbox_flexbox_vue___default.a,
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_item_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_button_index_vue___default.a,
    Checker: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue___default.a,
    CheckerItem: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue___default.a
  },
  data: function data() {
    return {
      text: '加载中',
      params: '',
      title: '最低风险承受能力选择'
    };
  },
  created: function created() {
    this.params = this.$route.query;
  },

  methods: {
    $_evaluation_confirm: function $_evaluation_confirm(type) {
      var _this = this;

      this.params.isLowAccept = type;
      if (type === 1) {

        var subdata = JSON.parse(this.params.subData);
        subdata.afterResult = '风险承受最低类别';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_api_evaluation__["e" /* getEvaluationCal */])(subdata, this.params.au).then(function (res) {
          if (res.code === 0) {
            _this.$router.push({ path: '/evaluation/lastlowend', query: _this.params });
          }
        });
        return;
      }
      this.$router.push({ path: '/evaluation/lastlowend', query: this.params });
    }
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commom_tableList_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commom_tableList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__commom_tableList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_item_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_item_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_api_evaluation__ = __webpack_require__(53);













/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_header_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default.a,
    Flexbox: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_flexbox_flexbox_vue___default.a,
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_item_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_button_index_vue___default.a,
    Checker: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_vue___default.a,
    CheckerItem: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_item_vue___default.a,
    TableList: __WEBPACK_IMPORTED_MODULE_0__commom_tableList_vue___default.a
  },
  data: function data() {
    return {
      text: '加载中',
      params: '',
      title: '风险承受等级',
      imgStyle: ''
    };
  },

  computed: {
    level: function level() {
      var result = this.params.result || '';
      switch (result.toUpperCase()) {
        case 'C1':
          return 'R1';
        case 'C2':
          return 'R1、R2';
        case 'C3':
          return 'R1、R2、R3';
        case 'C4':
          return 'R1、R2、R3、R4';
        case 'C5':
          return 'R1、R2、R3、R4、R5';
      }
    }
  },
  created: function created() {
    this.params = this.$route.query;
    this.params.specialObj = this.$util.toBoolean(this.params.specialObj);
    this.setRiskStyle();
  },

  methods: {
    $_evaluation_back: function $_evaluation_back() {
      this.$router.back();
      this.$bridge.callHandler('reserveFinish', { message: '关闭h5' }, function (data) {
        console.log('reserveFinish');
      });
    },
    setRiskStyle: function setRiskStyle() {
      if (this.params.isLowAccept === '0') {
        var imgBg = __webpack_require__(932);
        this.imgStyle = {
          'background': 'url(' + imgBg + ')',
          'color': '#2E6BE6'
        };
      } else {
        var _imgBg = __webpack_require__(933);
        this.imgStyle = {
          'background': 'url(' + _imgBg + ')',
          'color': 'red'
        };
      }
    },
    $_evaluation_again: function $_evaluation_again() {
      this.$router.push({ path: '/evaluation/one' });
    },
    $_evaluation_update: function $_evaluation_update() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_api_evaluation__["d" /* getEvaluationUpdate */])({
        sysCode: this.params.sysCode,
        managerAdminUserId: this.params.managerId,
        userId: this.params.userId,
        afterResult: '风险承受最低类别'
      }, this.params.au).then(function (res) {
        if (res.code === 0) {
          _this.$_evaluation_submit();
        } else {
          _this.$vux.toast.show({ type: 'warn', text: res.msg });
        }
      });
    },
    $_evaluation_checkSubmit: function $_evaluation_checkSubmit() {
      var _this2 = this;

      var isNeedSign = parseInt(this.params.isNeedSign);
      if (isNeedSign === 1) {
        this.$bridge.registerHandler('getSignData', function (data) {
          setTimeout(function () {
            _this2.$_getSignResult(data);
          }, 30);
        });
        setTimeout(function () {
          _this2.$bridge.callHandler('sign', { message: '用户签名', userId: _this2.params.userId, result: _this2.params.result }, function (data) {});
        }, 30);
      } else {
        this.$_handleSubmit();
      }
    },
    $_getSignResult: function $_getSignResult(signFile) {
      var _this3 = this;

      var data = {
        sysCode: this.params.sysCode,
        managerAdminUserId: this.params.managerId,
        userId: this.params.invenstemUserId, // 理财师添加的用户ID
        platformUserId: this.params.platformUserId,
        evaluationResultFile: this.params.evaluationResultFile,
        signImagesFileInfo: signFile
      };
      console.log('合成签名提交的数据：', data);
      this.$vux.loading.show({ text: '签名合成中' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_api_evaluation__["a" /* quesSignSave */])(data, this.params.au).then(function (res) {
        _this3.$vux.loading.hide();
        if (res.code === 0) {
          console.log('签章合成返回', res);
          _this3.params.evaluationResultFileSign = res.data.bean.evaluationResultFileSign;
          _this3.$vux.toast.show({ text: '签署成功', type: 'success' });
          _this3.$_handleSubmit();
        } else {
          _this3.$vux.toast.show({ text: res.msg, type: 'warn' });
        }
      }).catch(function (e) {
        console.log(e);
        _this3.$vux.loading.hide();
        _this3.$vux.toast.show({ text: '服务器繁忙, 请重试', type: 'warn' });
      });
    },
    $_handleSubmit: function $_handleSubmit() {
      var _this4 = this;

      this.$vux.loading.show({ text: '提交中' });
      var subData = JSON.parse(this.params.subData);
      subData.evaluationResultFile = this.params.evaluationResultFile;
      subData.evaluationResultFileSign = this.params.evaluationResultFileSign;
      subData.afterResult = this.params.isLowAccept === 1 ? '风险承受最低类别' : this.params.result;
      console.log(subData, 111111);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_api_evaluation__["b" /* getEvaluationSave */])(subData, this.params.au).then(function (res) {
        _this4.$vux.loading.hide();
        if (res.code === 0) {

          _this4.$_evaluation_submit(res.data.bean.evaluationId);
        } else {
          _this4.$vux.toast.show({ type: 'warn', text: res.msg });
        }
      });
    },
    $_evaluation_submit: function $_evaluation_submit(evaluationId) {
      this.$vux.toast.show({ type: 'success', text: '提交成功' });
      this.$bridge.callHandler('getResult', { message: '最后确认', level: this.params.result, evaluationId: evaluationId }, function (data) {
        console.log('submit');
      });
    },
    $_view_quesDetail: function $_view_quesDetail() {
      var viewPdf = this.params.evaluationResultFileSign ? this.params.evaluationResultFileSign : this.params.evaluationResultFile;
      this.$bridge.callHandler('seePDF', { message: '查看pdf', pdfSign: viewPdf }, function (data) {
        console.log('submit');
      });
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commom_tableList_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commom_tableList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__commom_tableList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_flexbox_flexbox_item_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_flexbox_flexbox_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_flexbox_flexbox_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_checker_checker_item_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_checker_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_checker_checker_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_api_evaluation__ = __webpack_require__(53);














/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_group_index_vue___default.a,
    Flexbox: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_flexbox_flexbox_vue___default.a,
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_flexbox_flexbox_item_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue___default.a,
    Checker: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_checker_checker_vue___default.a,
    CheckerItem: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_checker_checker_item_vue___default.a,
    TableList: __WEBPACK_IMPORTED_MODULE_1__commom_tableList_vue___default.a
  },
  data: function data() {
    return {
      text: '加载中',
      params: '',
      title: '风险承受等级'
    };
  },
  created: function created() {
    this.params = this.$route.query;
    this.params.specialObj = this.$util.toBoolean(this.params.specialObj);
  },

  computed: {
    level: function level() {
      switch (this.params.result) {
        case 'C1':
          return 'R1';
        case 'C2':
          return 'R1、R2';
        case 'C3':
          return 'R1、R2、R3';
        case 'C4':
          return 'R1、R2、R3、R4';
        case 'C5':
          return 'R1、R2、R3、R4、R5';
      }
    }
  },
  methods: {
    $_evaluation_again: function $_evaluation_again() {
      this.$router.push({ path: '/evaluation/one' });
    },
    $_evaluation_checkSubmit: function $_evaluation_checkSubmit() {
      var _this = this;

      var isNeedSign = parseInt(this.params.isNeedSign);
      if (isNeedSign === 1) {
        this.$bridge.registerHandler('getSignData', function (data) {
          _this.$_getSignResult(data);
        });
        this.$bridge.callHandler('sign', { message: '用户签名', userId: this.params.userId, result: this.params.result }, function (data) {});
      } else {
        this.$_handleSubmit();
      }
    },
    $_getSignResult: function $_getSignResult(signFile) {
      var _this2 = this;

      var data = {
        sysCode: this.params.sysCode,
        managerAdminUserId: this.params.managerId,
        userId: this.params.invenstemUserId, // 理财师添加的用户ID
        platformUserId: this.params.platformUserId,
        evaluationResultFile: this.params.evaluationResultFile,
        signImagesFileInfo: signFile
      };
      console.log('合成签名提交的数据：', data);
      this.$vux.loading.show({ text: '签名合成中' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_api_evaluation__["a" /* quesSignSave */])(data, this.params.au).then(function (res) {
        _this2.$vux.loading.hide();
        if (res.code === 0) {
          console.log('签章合成返回', res);
          _this2.params.evaluationResultFileSign = res.data.bean.evaluationResultFileSign;
          _this2.$vux.toast.show({ text: '签署成功', type: 'success' });
          _this2.$_handleSubmit();
        } else {
          _this2.$vux.toast.show({ text: res.msg, type: 'warn' });
        }
      }).catch(function (e) {
        _this2.$vux.loading.hide();
        _this2.$vux.toast.show({ text: '服务器繁忙, 请重试', type: 'warn' });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(e);
      });
    },
    $_handleSubmit: function $_handleSubmit() {
      var _this3 = this;

      this.$vux.loading.show({ text: '提交中' });
      var subData = JSON.parse(this.params.subData);
      subData.evaluationResultFile = this.params.evaluationResultFile;
      subData.evaluationResultFileSign = this.params.evaluationResultFileSign;
      console.log(subData);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_api_evaluation__["b" /* getEvaluationSave */])(subData, this.params.au).then(function (res) {
        _this3.$vux.loading.hide();
        if (res.code === 0) {
          _this3.$_evaluation_submit(res.data.bean.evaluationId);
        } else {
          _this3.$vux.toast.show({ type: 'warn', text: res.msg });
        }
      });
    },
    $_evaluation_submit: function $_evaluation_submit(evaluationId) {
      this.$vux.toast.show({ type: 'success', text: '提交成功' });
      this.$bridge.callHandler('getResult', { message: '最后确认', level: this.params.result, evaluationId: evaluationId }, function (data) {
        console.log('submit');
      });
    },
    $_view_quesDetail: function $_view_quesDetail() {
      var viewPdf = this.params.evaluationResultFileSign ? this.params.evaluationResultFileSign : this.params.evaluationResultFile;
      this.$bridge.callHandler('seePDF', { message: '查看pdf', pdfSign: viewPdf }, function (data) {
        console.log('submit');
      });
    }
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant__ = __webpack_require__(151);


var _components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1_vant__["b" /* Cell */].name, __WEBPACK_IMPORTED_MODULE_1_vant__["b" /* Cell */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1_vant__["c" /* CellGroup */].name, __WEBPACK_IMPORTED_MODULE_1_vant__["c" /* CellGroup */]), _components),
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  },

  methods: {
    perNor: function perNor(event) {
      //    this.$router.push({path: '/guide/confirm/perNor'})
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/confirm/perNor' }, function (data) {
        console.log('functionSecelted');
      });
    },
    perEmp: function perEmp(event) {
      //    this.$router.push({path: '/guide/confirm/perEmp'})
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/confirm/perEmp' }, function (data) {
        console.log('functionSecelted');
      });
    },
    perPro: function perPro(event) {
      //    this.$router.push({path: '/guide/confirm/perPro'})
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/confirm/perPro' }, function (data) {
        console.log('functionSecelted');
      });
    },
    orgNor: function orgNor(event) {
      //    this.$router.push({path: '/guide/confirm/orgNor'})
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/confirm/orgNor' }, function (data) {
        console.log('functionSecelted');
      });
    },
    orgPro: function orgPro(event) {
      //    this.$router.push({path: '/guide/confirm/orgPro'})
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/confirm/orgPro' }, function (data) {
        console.log('functionSecelted');
      });
    },
    orgSelf: function orgSelf(event) {
      //    this.$router.push({path: '/guide/confirm/orgSelf'})
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/confirm/orgSelf' }, function (data) {
        console.log('functionSecelted');
      });
    },
    orgFin: function orgFin(event) {
      //    this.$router.push({path: '/guide/confirm/orgFin'})
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/confirm/orgFin' }, function (data) {
        console.log('functionSecelted');
      });
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false,
      currentStep: '01',
      steps: ['填写并确认信息', '三秒强制阅读'],
      message: '填写并确认信息',
      showindicators: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  },

  methods: {
    onChange: function onChange(index) {
      this.currentStep = '0' + (Number(index) + 1);
      this.message = this.steps[Number(index)];
    },
    leftClick: function leftClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2));
    },
    rightClick: function rightClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep));
    }
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false,
      currentStep: '01'
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  },

  methods: {
    onChange: function onChange(index) {
      this.currentStep = '0' + (Number(index) + 1);
    },
    leftClick: function leftClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2));
    },
    rightClick: function rightClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep));
    }
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false,
      currentStep: '01',
      currentStep1: '01',
      message: '发起双录',
      message1: '阅读风险揭示书',
      steps: ['阅读风险揭示书', '签字', '签章'],
      message2: '合同文件签署',
      showindicators: false,
      loopenable: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  },

  methods: {
    onChange: function onChange(index) {
      this.currentStep = '0' + (Number(index) + 1);
      this.message1 = this.steps[Number(index)];
    },
    leftClick: function leftClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2));
    },
    rightClick: function rightClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep));
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false,
      currentStep: '01',
      steps: ['点击添加', '添加产品', '提交产品'],
      message: '点击添加',
      showindicators: false,
      loopenable: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  },

  methods: {
    onChange: function onChange(index) {
      this.currentStep = '0' + (Number(index) + 1);
      this.message = this.steps[Number(index)];
    },
    leftClick: function leftClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2));
    },
    rightClick: function rightClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep));
    }
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant__ = __webpack_require__(151);


var _components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1_vant__["b" /* Cell */].name, __WEBPACK_IMPORTED_MODULE_1_vant__["b" /* Cell */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1_vant__["c" /* CellGroup */].name, __WEBPACK_IMPORTED_MODULE_1_vant__["c" /* CellGroup */]), _components),
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  },

  methods: {
    reigsterProcess: function reigsterProcess(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/register' }, function (data) {
        console.log('functionSecelted');
      });
    },
    confirmProcess: function confirmProcess(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/confirmList' }, function (data) {
        console.log('functionSecelted');
      });
    },
    appointmentProcess: function appointmentProcess(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/appointmentStep' }, function (data) {
        console.log('functionSecelted');
      });
    },
    appointmentconfirmProcess: function appointmentconfirmProcess(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/appointmentConStep' }, function (data) {
        console.log('functionSecelted');
      });
    },
    contractProcess: function contractProcess(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/contractStep' }, function (data) {
        console.log('functionSecelted');
      });
    },
    invite: function invite(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/invite' }, function (data) {
        console.log('functionSecelted');
      });
    },
    confirm: function confirm(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/confirm' }, function (data) {
        console.log('functionSecelted');
      });
    },
    riskTest: function riskTest(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/risk' }, function (data) {
        console.log('functionSecelted');
      });
    },
    appointment: function appointment(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/appointment' }, function (data) {
        console.log('functionSecelted');
      });
    },
    createProduct: function createProduct(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/createProduct' }, function (data) {
        console.log('functionSecelted');
      });
    },
    record: function record(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/record' }, function (data) {
        console.log('functionSecelted');
      });
    },
    contract: function contract(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/contract' }, function (data) {
        console.log('functionSecelted');
      });
    },
    orderState: function orderState(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/orderState' }, function (data) {
        console.log('functionSecelted');
      });
    },
    findPwd: function findPwd(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: '/guide/findPwd' }, function (data) {
        console.log('functionSecelted');
      });
    },
    recordList: function recordList(event) {
      this.$bridge.callHandler('functionSecelted', { message: '详情说明', guideUrl: 'recordList' }, function (data) {
        console.log('recordList');
      });
    }
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false,
      currentStep: '01',
      currentStep1: '01',
      steps: ['输入邀请码'],
      message: '输入邀请码',
      steps1: ['点击关联管理人', '输入邀请码'],
      message1: '点击关联管理人',
      showindicators: false,
      loopenable: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  },

  methods: {
    onChange: function onChange(index) {
      this.currentStep = '0' + (Number(index) + 1);
      this.message = this.steps[Number(index)];
    },
    leftClick: function leftClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2));
    },
    rightClick: function rightClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep));
    },
    onChange1: function onChange1(index) {
      this.currentStep1 = '0' + (Number(index) + 1);
      this.message1 = this.steps1[Number(index)];
    },
    leftClick1: function leftClick1(event) {
      this.$refs['vanswipe1'].swipeTo(Number(this.currentStep1 - 2));
    },
    rightClick1: function rightClick1(event) {
      this.$refs['vanswipe1'].swipeTo(Number(this.currentStep1));
    }
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false,
      currentStep: '01',
      currentStep1: '01',
      steps: ['发起双录', '录制完成'],
      message: '发起双录',
      steps1: ['发起双录', '录制完成'],
      message1: '发起双录',
      showindicators: false,
      loopenable: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  },

  methods: {
    onChange: function onChange(index) {
      this.currentStep = '0' + (Number(index) + 1);
      this.message = this.steps[Number(index)];
    },
    leftClick: function leftClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2));
    },
    rightClick: function rightClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep));
    },
    onChange1: function onChange1(index) {
      this.currentStep1 = '0' + (Number(index) + 1);
      this.message1 = this.steps1[Number(index)];
    },
    leftClick1: function leftClick1(event) {
      this.$refs['vanswipe1'].swipeTo(Number(this.currentStep1 - 2));
    },
    rightClick1: function rightClick1(event) {
      this.$refs['vanswipe1'].swipeTo(Number(this.currentStep1));
    }
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
    console.log(1);
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false,
      currentStep: '01',
      currentStep1: '01',
      steps: ['开始测评', '提交问卷'],
      message: '开始测评',
      steps1: ['个人中心前往测评', '开始测评', '提交问卷'],
      message1: '个人中心前往测评',
      showindicators: false,
      loopenable: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  },

  methods: {
    onChange: function onChange(index) {
      this.currentStep = '0' + (Number(index) + 1);
      this.message = this.steps[Number(index)];
    },
    leftClick: function leftClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2));
    },
    rightClick: function rightClick(event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep));
    },
    onChange1: function onChange1(index) {
      this.currentStep1 = '0' + (Number(index) + 1);
      this.message1 = this.steps1[Number(index)];
    },
    leftClick1: function leftClick1(event) {
      this.$refs['vanswipe1'].swipeTo(Number(this.currentStep1 - 2));
    },
    rightClick1: function rightClick1(event) {
      this.$refs['vanswipe1'].swipeTo(Number(this.currentStep1));
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_evaluation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_baseComponents_MyStep__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_baseComponents_MyStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_baseComponents_MyStep__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_button_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_input_index_vue___default.a,
    myStep: __WEBPACK_IMPORTED_MODULE_4__components_baseComponents_MyStep___default.a
  },
  data: function data() {
    return {
      loading: false,
      text: '加载中',
      step1: 1,
      formData: {
        loginName: '15281018761',
        authCode: '12',
        password: 'smqy123',
        userType: 'USER_TYPE_PERSONAL'
      },
      au: ''
    };
  },
  created: function created() {
    this.loading = this.isDev;
    if (this.isDev) {
      this.getAu();
    }
  },

  methods: {
    getAu: function getAu() {
      var _this = this;

      var vm = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_api_evaluation__["h" /* loginGetAu */])(this.formData, '').then(function (res) {
        if (res.code === 0) {
          _this.au = res.data.bean.au;
          vm.$vux.toast.show({ type: 'success', text: '登录成功' });
        } else {
          vm.$vux.toast.show({ type: 'warn', text: res.msg });
        }
      });
    }
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_api_investor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OneLook_vue__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OneLook_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__OneLook_vue__);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default.a,
    Selector: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default.a,
    XNumber: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default.a,
    Datetime: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default.a,
    OneLook: __WEBPACK_IMPORTED_MODULE_11__OneLook_vue___default.a,
    PopupRadio: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue___default.a
  },
  data: function data() {
    return {
      hasResp: false,
      localValidity: '存在有效期',
      finance: ['保险机构', '上市公司', '信托公司', '证券公司', '期货公司', '基金管理公司', '基金管理公司子公司', '银行', '财务公司', '证券公司子公司', '期货公司子公司', '私募基金管理人'],
      otherOrg: ['非金融机构企业法人', '机关法人', '事业单位法人', '社会团体法人', '非金融类非法人机构', '其他境内金融机构', '境外代理人', '境外金融机构', '外国战略投资者', '境外非金融机构', '其它'],
      managerOrg: ['私募基金管理人'],

      orgTypeArry: [],

      orgCardArry: ['组织机构代码', '营业执照', '行政机关', '社会团体', '军队', '武警', '下属机构(具有主管单位批文号)', '基金会', '其它'],

      loading: true,

      baseInfo: {
        type: 1, // 1新增 0 查看
        isNormal: 1,
        invenstemType: 'SPECIFIC_PERSONAL_ORDINARY',
        userId: 1755,
        isShowBtn: false,
        invenstemUserId: 2023,
        stepCurrent: 1,
        stepTotal: 4,
        au: 'eUJpWXhmNTJZMWtya0NDNDF5QjlwTThJcnFPWTdzMUhxdEc0dktXdHl3ZUtGSW4vZmVSaERDS0N4aWJreWl1Tw==',
        orgType: 'fund'
      },
      BusinessScope: ['农、林、牧、渔业', '采矿业', '制造业', '电力、燃气及水的生产和供应业', '建筑业', '交通运输、仓储和邮政业', '信息传输、计算机服务和软件业', '批发和零售业', '住宿和餐饮业', '金融业', '房地产业', '租赁和商务服务业', '科学研究、技术服务和地质勘查业', '水利、环境和公共设施管理业', '居民服务和其他服务业', '教育', '卫生、社会保障和社会福利业', '文化、体育和娱乐业', '公共管理与社会组织', '国际组织'],
      data: {
        orgName: '',
        orgType: '',
        orgDocumentsType: '组织机构代码',
        orgDocumentsNo: '',
        orgDocumentsValidity: '',
        orgQualificationProve: '',
        orgQualificationNo: '',
        orgBusinessScope: '农、林、牧、渔业',
        orgRegisterAddress: '',
        orgAddress: '',
        orgRegisteredCapital: '',
        orgController: ''
      },
      valid: {
        orgName: false,
        orgType: false,
        orgDocumentsType: false,
        orgDocumentsNo: false,
        orgDocumentsValidity: false,
        orgQualificationProve: false,
        orgQualificationNo: false,
        orgBusinessScope: false,
        orgRegisterAddress: false,
        orgAddress: false,
        orgRegisteredCapital: false,
        orgController: false
      }
    };
  },

  watch: {
    localValidity: function localValidity(val, oldVal) {
      if (val === '永久有效') {
        this.data.orgDocumentsValidity = val;
      } else {
        this.data.orgDocumentsValidity = '';
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$vux.loading.show({ text: '加载中' });
    setTimeout(function () {
      _this2.$bridge.registerHandler('getUpdate', _this2.$_agency_update);
      _this2.$_agency_init();
    }, this.initTime);
  },

  methods: {
    $_agency_update: function $_agency_update() {
      this.baseInfo.type = 1;
    },
    $_agency_init: function $_agency_init() {
      var _this = this;

      if (_this.isDev) {
        if (_this.baseInfo.type === 0) {
          _this.$_agency_info(this.baseInfo.userId, this.baseInfo.invenstemUserId, _this.baseInfo.au);
        }
        _this.loading = false;
        _this.$vux.loading.hide();
      } else {
        var info = '\u65B0\u589E/\u67E5\u770B\u6295\u8D44\u8005\u4FE1\u606F,\n\u53C2\u6570\ntype\uFF081 \u65B0\u589E, 0 \u67E5\u770B),\nisNormal(1\u662F 0 \u5426\uFF0Cstring\u7C7B\u578B),\nuserId(\u7528\u6237Id),\ninvenstemUserId(\u7406\u8D22\u5E08\u62E5\u6709\u7684\u6295\u8D44\u8005ID,\u65B0\u589E\u6CA1\u6709\u5C31\u4E0D\u4F20),\ninvenstemType(\u6295\u8D44\u8005\u7279\u5B9A\u5BF9\u8C61\u8BA4\u8BC1\u7C7B\u578B),\nau';
        _this.$bridge.callHandler('getUserInfo', { message: info }, function (data) {
          _this.loading = false;
          _this.$vux.loading.hide();
          var res = JSON.parse(data);
          console.log(res, 'org');
          if (res.type && res.isNormal && res.userId && res.invenstemType && res.au) {
            _this.baseInfo.isShowBtn = parseInt(res.isShowBtn || 0);
            _this.baseInfo.type = parseInt(res.type);
            _this.baseInfo.isNormal = parseInt(res.isNormal);
            _this.baseInfo.userId = res.userId;
            _this.baseInfo.invenstemType = res.invenstemType;
            _this.baseInfo.invenstemUserId = res.invenstemUserId;
            _this.baseInfo.au = res.au;
            _this.baseInfo.stepCurrent = parseInt(res.stepCurrent);
            _this.baseInfo.stepTotal = parseInt(res.stepTotal);
            _this.baseInfo.orgType = res.orgType;
            _this.getOrgList(res.invenstemType);
            if (_this.baseInfo.type === 0) {
              _this.$_agency_info(res.userId, res.invenstemUserId, res.globalVersion, res.au);
            }
          } else {
            _this.$vux.toast.show({ type: 'warn', text: '信息获取失败' });
          }
        });
      }
    },
    getOrgList: function getOrgList(invenstemType) {
      switch (invenstemType) {
        case 'SPECIFIC_ORG_ORG':
          // 金融机构
          this.orgTypeArry = this.finance;
          this.data.orgType = this.finance[0];
          break;
        case 'SPECIFIC_ORG_PRACTITIONERS':
          // 管理人
          this.orgTypeArry = this.managerOrg;
          this.data.orgType = this.managerOrg[0];
          break;
        default:
          this.orgTypeArry = this.otherOrg;
          this.data.orgType = this.otherOrg[0];
          break;
      }
    },
    $_agency_info: function $_agency_info(userId, invenstemUserId, globalVersion, au) {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_api_investor__["b" /* getInvestorAgency */])({ userId: userId, invenstemUserId: invenstemUserId, globalVersion: globalVersion }, au).then(function (res) {
        if (res.code === 0) {
          _this3.data = {
            orgName: res.data.bean.orgName,
            orgType: res.data.bean.orgType,
            orgDocumentsType: res.data.bean.orgDocumentsType,
            orgDocumentsNo: res.data.bean.orgDocumentsNo,
            orgDocumentsValidity: res.data.bean.orgDocumentsValidity,
            orgQualificationProve: res.data.bean.orgQualificationProve,
            orgQualificationNo: res.data.bean.orgQualificationNo,
            orgBusinessScope: res.data.bean.orgBusinessScope,
            orgRegisterAddress: res.data.bean.orgRegisterAddress,
            orgAddress: res.data.bean.orgAddress,
            orgRegisteredCapital: res.data.bean.orgRegisteredCapital,
            orgController: res.data.bean.orgController,
            oldInfo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.bean)
          };
          _this3.hasResp = true;
        } else {
          _this3.$vux.toast.show({
            type: 'warn',
            text: '信息获取失败'
          });
        }
      });
    },
    $_agency_next: function $_agency_next() {
      var _this = this;
      if (_this.baseInfo.type === 0) {
        _this.data.type = this.baseInfo.type;
        _this.data.isNormal = this.baseInfo.isNormal;
        _this.data.invenstemType = this.baseInfo.invenstemType;
        _this.data.userId = this.baseInfo.userId;
        _this.data.invenstemUserId = this.baseInfo.invenstemUserId;
        _this.data.au = this.baseInfo.au;
        _this.$router.push({ path: '/investor/agency/two', query: _this.data });
      } else {
        for (var item in _this.valid) {
          console.log(_this.data[item]);
          if (_this.data[item] === '') {
            _this.$vux.toast.show({ type: 'warn', text: _this.$refs[item].title + '为空或输入不合规范' });
            return;
          }
        }
        _this.data.type = this.baseInfo.type;
        _this.data.isNormal = this.baseInfo.isNormal;
        _this.data.invenstemType = this.baseInfo.invenstemType;
        _this.data.userId = this.baseInfo.userId;
        _this.data.invenstemUserId = this.baseInfo.invenstemUserId;
        _this.data.au = this.baseInfo.au;
        _this.$router.push({ path: '/investor/agency/two', query: _this.data });
      }
    }
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_number_index_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_number_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_number_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_selector_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_selector_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_selector_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_datetime_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_checker_checker_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_checker_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vux_src_components_checker_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vux_src_components_checker_checker_item_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vux_src_components_checker_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vux_src_components_checker_checker_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vux_src_components_x_textarea_index_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vux_src_components_x_textarea_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vux_src_components_x_textarea_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vux_src_components_icon_index_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vux_src_components_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_common_investorConfig__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_js_isReachBottom__ = __webpack_require__(234);


















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    propData: {
      type: [Object]
    },
    baseInfo: {
      type: [Object]
    },
    hasResp: {
      type: [Boolean],
      default: false
    }
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_input_index_vue___default.a,
    Selector: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_selector_index_vue___default.a,
    XNumber: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_number_index_vue___default.a,
    Datetime: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_datetime_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue___default.a,
    Checker: __WEBPACK_IMPORTED_MODULE_10_vux_src_components_checker_checker_vue___default.a,
    CheckerItem: __WEBPACK_IMPORTED_MODULE_11_vux_src_components_checker_checker_item_vue___default.a,
    XTextarea: __WEBPACK_IMPORTED_MODULE_12_vux_src_components_x_textarea_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_13_vux_src_components_icon_index_vue___default.a
  },
  data: function data() {
    return {
      isReady: true,
      twoData: {
        representativeName: '',
        representativeSex: '',
        representativeAge: '',
        representativeDocumentsType: '身份证',
        representativeIdCardNo: '',
        representativeDocumentsValidity: '',
        representativePosition: '',
        representativeLanline: '',
        representativeMobile: '',
        representativeEmail: '',
        representativeZip: '',
        representativeAddress: '',
        legalCountry: '中国'
      },
      threeData: {
        managersName: '',
        managersSex: '',
        managersAge: '',
        managersDocumentsType: '',
        managersIdCardNo: '',
        managersDocumentsValidity: '',
        managersPosition: '',
        managersLanline: '',
        managersMobile: '',
        managersEmail: '',
        managersZip: '',
        managersAddress: '',
        relationshipWithOrg: ''
      },

      question: {
        isProfessionalInvestors: {
          checked: ''
        },
        orgAssetsScale: {
          checked: ''
        },
        isControllingShareholder: {
          checked: '',
          description: ''
        },
        transactionActualBeneficiary: {
          checked: '',
          description: ''
        },
        isBadFaith: {
          checked: '',
          description: ''
        }
      }
    };
  },

  computed: {
    isFund: function isFund() {
      return this.baseInfo.orgType !== 'futures';
    }
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common_js_isReachBottom__["a" /* default */])(this);
  },

  watch: {
    hasResp: function hasResp(bool) {
      if (bool) {
        this.$_agency_init();
      }
    }
  },
  methods: {
    isForeign: __WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_common_investorConfig__["b" /* isForeign */],
    iDCardTypesLabel: __WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_common_investorConfig__["c" /* iDCardTypesLabel */],
    $_agency_init: function $_agency_init() {
      if (this.propData.oldInfo) {
        var res = JSON.parse(this.propData.oldInfo);
        this.twoData = {
          representativeName: res.representativeName,
          representativeSex: res.representativeSex,
          representativeAge: res.representativeAge,
          representativeDocumentsType: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_common_investorConfig__["a" /* formatOldCatType */])(res.representativeDocumentsType),
          representativeIdCardNo: res.representativeIdCardNo,
          representativeDocumentsValidity: res.representativeDocumentsValidity,
          representativePosition: res.representativePosition,
          representativeLanline: res.representativeLanline,
          representativeMobile: res.representativeMobile,
          representativeEmail: res.representativeEmail,
          representativeZip: res.representativeZip,
          representativeAddress: res.representativeAddress,
          legalCountry: res.legalCountry
        };

        this.threeData = {
          managersName: res.managersName,
          managersSex: res.managersSex,
          managersAge: res.managersAge,
          managersDocumentsType: res.managersDocumentsType,
          managersIdCardNo: res.managersIdCardNo,
          managersDocumentsValidity: res.managersDocumentsValidity,
          managersPosition: res.managersPosition,
          managersLanline: res.managersLanline,
          managersMobile: res.managersMobile,
          managersEmail: res.managersEmail,
          managersZip: res.managersZip,
          managersAddress: res.managersAddress,
          relationshipWithOrg: res.relationshipWithOrg
        };
        this.$_agency_init_ques(res);
      }
    },
    $_agency_init_ques: function $_agency_init_ques(res) {
      this.question = {
        isProfessionalInvestors: {
          checked: JSON.parse(res.isProfessionalInvestors).checked
        },
        orgAssetsScale: {
          checked: JSON.parse(res.orgAssetsScale).checked
        },
        isControllingShareholder: {
          checked: JSON.parse(res.isControllingShareholder).checked,
          description: JSON.parse(res.isControllingShareholder).description
        },
        transactionActualBeneficiary: {
          checked: JSON.parse(res.transactionActualBeneficiary).checked,
          description: JSON.parse(res.transactionActualBeneficiary).description
        },
        isBadFaith: {
          checked: JSON.parse(res.isBadFaith).checked,
          description: JSON.parse(res.isBadFaith).description
        }
      };
    },
    $_agency_submit: function $_agency_submit() {
      var subObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.twoData, this.threeData, this.question, this.propData);
      delete subObj.oldInfo;
      delete subObj.type;
      delete subObj.isNormal;
      this.$_agency_commit(subObj);
    },
    $_agency_commit: function $_agency_commit(json) {
      if (this.isDev) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json));
      } else {
        this.$bridge.callHandler('getResult', { message: '最后确认', json: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json) }, function (data) {
          console.log('submit');
        });
      }
    }
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue___default.a,
    Checker: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue___default.a,
    CheckerItem: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue___default.a,
    XTextarea: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue___default.a
  },
  data: function data() {
    return {
      loading: true,
      type: 0,
      invenstemType: '',
      data: {
        isProfessionalInvestors: {
          checked: ''
        },
        orgAssetsScale: {
          checked: ''
        },
        isControllingShareholder: {
          checked: '',
          description: ''
        },
        transactionActualBeneficiary: {
          checked: '',
          description: ''
        },
        isBadFaith: {
          checked: '',
          description: ''
        }
      }
    };
  },

  watch: {
    'data.orgAssetsScale.checked': function dataOrgAssetsScaleChecked(val, oldVal) {
      this.$_personal_toast(val, oldVal);
    }
  },
  created: function created() {
    this.$vux.loading.show({ text: '加载中' });
    this.$bridge.registerHandler('getUpdate', this.$_agency_update);
    this.$_agency_init();
  },
  mounted: function mounted() {
    var _this = this;
    _this.$bridge.callHandler('getUserInfo', { message: '获取投资者类型' }, function (res) {
      var data = JSON.parse(res);
      if (data.invenstemType) {
        _this.invenstemType = data.invenstemType;
      }
    });
  },

  methods: {
    $_agency_update: function $_agency_update() {
      this.type = 1;
    },
    $_agency_init: function $_agency_init() {
      var _this2 = this;

      var _this = this;
      setTimeout(function () {
        _this.data.isProfessionalInvestors.checked = parseInt(_this2.$route.query.isNormal) === 1 ? '否' : '是';
        _this.type = parseInt(_this2.$route.query.type);
        if (_this.$route.query.oldInfo) {
          var res = JSON.parse(_this2.$route.query.oldInfo);
          _this.data = {
            isProfessionalInvestors: {
              checked: JSON.parse(res.isProfessionalInvestors).checked
            },
            orgAssetsScale: {
              checked: JSON.parse(res.orgAssetsScale).checked
            },
            isControllingShareholder: {
              checked: JSON.parse(res.isControllingShareholder).checked,
              description: JSON.parse(res.isControllingShareholder).description
            },
            transactionActualBeneficiary: {
              checked: JSON.parse(res.transactionActualBeneficiary).checked,
              description: JSON.parse(res.transactionActualBeneficiary).description
            },
            isBadFaith: {
              checked: JSON.parse(res.isBadFaith).checked,
              description: JSON.parse(res.isBadFaith).description
            }
          };
        }
        _this.loading = false;
        _this.$vux.loading.hide();
      }, 500);
    },
    $_agency_submit: function $_agency_submit() {
      for (var item in this.data) {
        if (this.data[item].checked === '') {
          this.$vux.toast.show({
            type: 'warn',
            text: '选择为空或输入不合规范'
          });
          return;
        }
        var isControllingShareholder = item === 'isControllingShareholder' && this.data[item].checked === '是' && this.data[item].description === '';
        var transactionActualBeneficiary = item === 'transactionActualBeneficiary' && this.data[item].checked === '其他机构或个人' && this.data[item].description === '';
        var isBadFaith = item === 'isBadFaith' && this.data[item].checked === '是' && this.data[item].description === '';
        if (isControllingShareholder || transactionActualBeneficiary || isBadFaith) {
          this.$vux.toast.show({
            type: 'warn',
            text: '请输入说明内容'
          });
          return;
        }
      }
      this.$_agency_commit(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.data, this.$route.query));
    },
    $_agency_commit: function $_agency_commit(json) {
      delete json.oldInfo;
      delete json.type;
      delete json.isNormal;
      if (this.isDev) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json));
      } else {
        this.$bridge.callHandler('getResult', { message: '最后确认', json: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json) }, function (data) {
          console.log('submit');
        });
      }
    },
    $_personal_toast: function $_personal_toast(val, oldVal) {
      var _this = this;
      if (this.type === 1) {

        if (_this.invenstemType === 'SPECIFIC_ORG_PRACTITIONERS') {
          if (val === '否') {
            _this.$vux.alert.show({
              title: '提示',
              content: '据《私募投资基金募集行为管理办法》32条规定，此项选“否”，将标记该投资者为“投资于所管理私募基金的私募基金管理人”，即当然合格投资者，后续无需签署合格投资者承诺函'
            });
          }
        }

        if (_this.invenstemType === 'SPECIFIC_ORG_PROFESSION' || _this.invenstemType === 'SPECIFIC_ORG_ORDINARY') {
          if (val === '否') {
            _this.$vux.alert.show({
              title: '提示',
              content: '根据《证券期货投资者适当性管理办法》第十四条“一定时期”的规定，私募基金合格投资者必须满足该条件，若您确认选否，该投资者则不符合私募基金购买条件，我们将终止本投资者信息表的填写',
              onHide: function onHide() {
                _this.data.orgAssetsScale.checked = oldVal;
              }
            });
          }
        }

        if (_this.invenstemType === 'SPECIFIC_ORG_ORG') {

          if (val === '否') {
            this.$vux.alert.show({
              title: '提示',
              content: '据《私募投资基金监督管理暂行办法》13条、《私募投资基金募集行为管理办法》32条规定，此项选“否”，将标记该投资者为“产品类投资者”，即当然合格投资者，后续无需签署合格投资者承诺函。且仅能用该机构管理的产品作为投资主体进行签约。'
            });
          } else {
            this.$vux.alert.show({
              title: '提示',
              content: '此项选“是”，将标记该投资者为“金融机构投资者”。后续可用该机构及机构管理的产品作为投资主体进行签约。'
            });
          }
        }
      }
    }
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_api_investor__ = __webpack_require__(61);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default.a,
    Selector: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default.a,
    XNumber: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default.a,
    Datetime: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default.a,
    PopupRadio: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue___default.a
  },
  data: function data() {
    return {
      localValidity: '存在有效期',
      loading: true,
      type: 0,
      data: {
        managersName: '',
        managersSex: '',
        managersAge: '',
        managersDocumentsType: '身份证',
        managersIdCardNo: '',
        managersDocumentsValidity: '',
        managersPosition: '',
        managersLanline: '',
        managersMobile: '',
        managersEmail: '',
        managersZip: '',
        managersAddress: '',
        relationshipWithOrg: ''
      },
      isIdCard: function isIdCard(value) {
        return {
          valid: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(value),
          msg: '身份证号码格式不正确'
        };
      },
      isPhone: function isPhone(value) {
        return {
          valid: /\d{1,20}/.test(value),
          msg: '号码格式不正确'
        };
      },
      valid: {
        managersName: false,
        managersSex: false,
        managersAge: false,
        managersDocumentsType: false,
        managersIdCardNo: false,
        managersDocumentsValidity: false,
        managersPosition: false,
        managersLanline: false,
        managersMobile: false,
        managersEmail: false,
        managersZip: false,
        managersAddress: false,
        relationshipWithOrg: false
      }
    };
  },

  watch: {
    localValidity: function localValidity(val, oldVal) {
      if (val === '永久有效') {
        this.data.managersDocumentsValidity = val;
      } else {
        this.data.managersDocumentsValidity = '';
      }
    }
  },
  created: function created() {
    this.$vux.loading.show({ text: '加载中' });
    this.$bridge.registerHandler('getUpdate', this.$_agency_update);
    this.$_agency_init();
  },

  methods: {
    $_agency_update: function $_agency_update() {
      this.type = 1;
    },
    $_agency_init: function $_agency_init() {
      var _this2 = this;

      var _this = this;
      setTimeout(function () {
        _this.type = parseInt(_this2.$route.query.type);
        if (_this.$route.query.oldInfo) {
          var res = JSON.parse(_this2.$route.query.oldInfo);
          _this.data = {
            managersName: res.managersName,
            managersSex: res.managersSex,
            managersAge: res.managersAge,
            managersDocumentsType: res.managersDocumentsType,
            managersIdCardNo: res.managersIdCardNo,
            managersDocumentsValidity: res.managersDocumentsValidity,
            managersPosition: res.managersPosition,
            managersLanline: res.managersLanline,
            managersMobile: res.managersMobile,
            managersEmail: res.managersEmail,
            managersZip: res.managersZip,
            managersAddress: res.managersAddress,
            relationshipWithOrg: res.relationshipWithOrg
          };
        } else if (_this.$route.query.isThree) {
          _this.data = {
            managersName: _this.$route.query.representativeName,
            managersSex: _this.$route.query.representativeSex,
            managersAge: _this.$route.query.representativeAge,
            managersDocumentsType: _this.$route.query.representativeDocumentsType,
            managersIdCardNo: _this.$route.query.representativeIdCardNo,
            managersDocumentsValidity: _this.$route.query.representativeDocumentsValidity,
            managersPosition: _this.$route.query.representativePosition,
            managersLanline: _this.$route.query.representativeLanline,
            managersMobile: _this.$route.query.representativeMobile,
            managersEmail: _this.$route.query.representativeEmail,
            managersZip: _this.$route.query.representativeZip,
            managersAddress: _this.$route.query.representativeAddress,
            relationshipWithOrg: ''
          };
        }
        _this.loading = false;
        _this.$vux.loading.hide();
      }, 500);
    },
    idcardChange: function idcardChange(val) {
      if (this.type === 1) {
        if (val && val.length === 18) {
          var year = parseInt(val.substring(6, 10));
          var Year = new Date().getFullYear();
          this.data.managersAge = Year - year;
          var sex = parseInt(val.substr(16, 1));
          this.data.managersSex = sex % 2 === 0 ? '女' : '男';
        }
      }
    },
    $_agency_auth: function $_agency_auth() {
      if (this.type === 0) {
        this.$_agency_next();
      } else {
        for (var item in this.valid) {
          console.log(this.data[item]);
          if (this.data[item] === '') {
            this.$vux.toast.show({ type: 'warn', text: this.$refs[item].title + '为空或输入不合规范' });
            return;
          }
        }
        this.$_handle_auth();
      }
    },
    $_handle_auth: function $_handle_auth() {
      var _this3 = this;

      this.$vux.loading.show({ text: '加载中' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_api_investor__["f" /* getInvestorOtherAuth */])({ userId: this.$route.query.userId, invenstemType: this.$route.query.invenstemType, orgName: this.$route.query.orgName, invenstemUserId: this.$route.query.invenstemUserId, name: this.data.managersName, idCard: this.data.managersIdCardNo }, this.$route.query.au).then(function (res) {
        _this3.$vux.loading.hide();
        if (res.code === 0) {
          _this3.$_agency_next();
        } else {
          _this3.$vux.alert.show({
            title: '提示',
            content: res.msg
          });
        }
      });
    },
    $_agency_next: function $_agency_next() {
      this.$route.query.type = this.type;
      this.$router.push({ path: '/investor/agency/four', query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.data, this.$route.query) });
    }
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_check_icon_index_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_check_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_check_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_popup_radio_index_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_popup_radio_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vux_src_components_popup_radio_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_api_investor__ = __webpack_require__(61);














/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default.a,
    Selector: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default.a,
    XNumber: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default.a,
    Datetime: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default.a,
    CheckIcon: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_check_icon_index_vue___default.a,
    PopupRadio: __WEBPACK_IMPORTED_MODULE_10_vux_src_components_popup_radio_index_vue___default.a
  },
  data: function data() {
    return {
      localValidity: '存在有效期',
      loading: true,
      type: 0,
      isThree: false,
      check: true,
      data: {
        representativeName: '',
        representativeSex: '',
        representativeAge: '',
        representativeDocumentsType: '身份证',
        representativeIdCardNo: '',
        representativeDocumentsValidity: '',
        representativePosition: '',
        representativeLanline: '',
        representativeMobile: '',
        representativeEmail: '',
        representativeZip: '',
        representativeAddress: ''
      },
      isIdCard: function isIdCard(value) {
        return {
          valid: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(value),
          msg: '身份证号码格式不正确'
        };
      },
      isPhone: function isPhone(value) {
        return {
          valid: /\d{1,20}/.test(value),
          msg: '号码格式不正确'
        };
      },
      valid: {
        representativeName: false,
        representativeSex: false,
        representativeAge: false,
        representativeDocumentsType: false,
        representativeIdCardNo: false,
        representativeDocumentsValidity: false,
        representativePosition: false,
        representativeLanline: false,
        representativeMobile: false,
        representativeEmail: false,
        representativeZip: false,
        representativeAddress: false
      }
    };
  },

  watch: {
    localValidity: function localValidity(val, oldVal) {
      if (val === '永久有效') {
        this.data.representativeDocumentsValidity = val;
      } else {
        this.data.representativeDocumentsValidity = '';
      }
    }
  },
  created: function created() {
    this.$vux.loading.show({ text: '加载中' });
    this.$bridge.registerHandler('getUpdate', this.$_agency_update);
    this.$_agency_init();
  },

  methods: {
    $_agency_update: function $_agency_update() {
      this.type = 1;
      this.check = false;
    },
    $_agency_init: function $_agency_init() {
      var _this2 = this;

      var _this = this;
      setTimeout(function () {
        _this2.type = parseInt(_this2.$route.query.type);
        if (_this2.$route.query.oldInfo) {
          var res = JSON.parse(_this2.$route.query.oldInfo);
          _this2.data = {
            representativeName: res.representativeName,
            representativeSex: res.representativeSex,
            representativeAge: res.representativeAge,
            representativeDocumentsType: res.representativeDocumentsType,
            representativeIdCardNo: res.representativeIdCardNo,
            representativeDocumentsValidity: res.representativeDocumentsValidity,
            representativePosition: res.representativePosition,
            representativeLanline: res.representativeLanline,
            representativeMobile: res.representativeMobile,
            representativeEmail: res.representativeEmail,
            representativeZip: res.representativeZip,
            representativeAddress: res.representativeAddress
          };
        }
        _this2.loading = false;
        _this.$vux.loading.hide();
      }, 500);
    },
    idcardChange: function idcardChange(val) {
      if (this.type === 1) {
        if (val && val.length === 18) {
          var year = parseInt(val.substring(6, 10));
          var Year = new Date().getFullYear();
          this.data.representativeAge = Year - year;
          var sex = parseInt(val.substr(16, 1));
          this.data.representativeSex = sex % 2 === 0 ? '女' : '男';
        }
      }
    },
    $_agency_auth: function $_agency_auth() {
      if (this.type === 0) {
        this.$_agency_next();
      } else {
        for (var item in this.valid) {
          console.log(this.data[item]);
          if (this.data[item] === '') {
            this.$vux.toast.show({ type: 'warn', text: this.$refs[item].title + '为空或输入不合规范' });
            return;
          }
        }
        this.$_handle_auth();
      }
    },
    $_handle_auth: function $_handle_auth() {
      var _this3 = this;

      this.$vux.loading.show({ text: '加载中' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_api_investor__["c" /* getInvestorAuth */])({ userId: 0, name: this.data.representativeName, idcard: this.data.representativeIdCardNo }, this.$route.query.au).then(function (res) {
        console.log('而要素认证返回', res);
        _this3.$vux.loading.hide();
        if (res.code === 0) {
          _this3.$_agency_next();
        } else {
          _this3.$vux.alert.show({
            title: '提示',
            content: res.msg
          });
        }
      });
    },
    $_agency_next: function $_agency_next() {
      this.$route.query.type = this.type;
      this.$route.query.isThree = this.isThree;
      this.$router.push({ path: '/investor/agency/three', query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.data, this.$route.query) });
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_check_icon_index_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_check_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_check_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_switch_index_vue__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_switch_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_switch_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_api_investor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_InvestorInfo_common_investorConfig__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OneLook_vue__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OneLook_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__OneLook_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default.a,
    Selector: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default.a,
    XNumber: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default.a,
    Datetime: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default.a,
    OneLook: __WEBPACK_IMPORTED_MODULE_13__OneLook_vue___default.a,
    CheckIcon: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_check_icon_index_vue___default.a,
    XSwitch: __WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_switch_index_vue___default.a
  },
  data: function data() {
    return {
      demo01: '',
      list: ['广东', '广西'],
      isEdit: false, // 是否修改
      loading: true,
      hasResp: false,
      baseInfo: {
        type: 1, // 1新增 0 查看
        isNormal: 1,
        invenstemType: 'SPECIFIC_PERSONAL_ORDINARY',
        isShowBtn: false,
        userId: 1755,
        managerId: 1673,
        invenstemUserId: 2023,
        stepCurrent: 0,
        stepTotal: 0,
        au: 'eUJpWXhmNTJZMWtya0NDNDF5QjlwTThJcnFPWTdzMUhxdEc0dktXdHl3ZUtGSW4vZmVSaERDS0N4aWJreWl1Tw==',
        orgType: 'fund'
      },
      isYJ: false,
      data: {
        userName: '',
        userSex: '',
        userAge: '',
        documentsType: '身份证',
        idCardNo: '',
        userCountry: '中国',
        userOccupation: '党政机关、事业单位',
        userPosition: '',
        userLandline: '',
        userMobile: '',
        documentsValidity: '',
        zip: '',
        userEmail: '',
        userAddress: ''
      },
      isIdCard: function isIdCard(value) {
        return {
          valid: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(value),
          msg: '身份证号码格式不正确'
        };
      },
      isPhone: function isPhone(value) {
        return {
          valid: /\d{1,20}/.test(value),
          msg: '号码格式不正确'
        };
      },
      valid: {
        userName: false,
        userAge: false,
        documentsType: false,
        idCardNo: false,
        userCountry: false,
        userOccupation: false,
        userSex: false,
        userPosition: false,
        userLandline: false,
        userMobile: false,
        zip: false,
        userEmail: false,
        userAddress: false
      }
    };
  },
  created: function created() {
    var _this2 = this;

    this.$vux.loading.show({ text: '加载中' });
    setTimeout(function () {
      _this2.$bridge.registerHandler('getUpdate', _this2.$_personal_update);
      _this2.$_personal_init();
    }, this.initTime);
  },

  watch: {
    isYJ: function isYJ(val, oldVal) {
      if (val) {
        console.log('2222');
        this.data.documentsValidity = '永久有效';
      } else {
        this.data.documentsValidity = '';
      }
    }
  },
  methods: {
    $_personal_update: function $_personal_update() {
      this.isEdit = true;
      this.baseInfo.type = 1;
    },
    $_personal_init: function $_personal_init() {
      var _this = this;
      console.log(_this.isDev, _this.baseInfo.type);

      if (_this.isDev) {
        _this.loading = false;
        _this.$vux.loading.hide();
        if (_this.baseInfo.type === 0) {
          _this.$_personal_info(this.baseInfo.userId, this.baseInfo.invenstemUserId, _this.baseInfo.au);
        }
      } else {
        var info = '\u65B0\u589E/\u67E5\u770B\u6295\u8D44\u8005\u4FE1\u606F,\n\u53C2\u6570\ntype\uFF081 \u65B0\u589E, 0 \u67E5\u770B),\nisNormal(1\u662F 0 \u5426\uFF0Cstring\u7C7B\u578B),\nuserId(\u7528\u6237Id),\ninvenstemUserId(\u7406\u8D22\u5E08\u62E5\u6709\u7684\u6295\u8D44\u8005ID,\u65B0\u589E\u4E0D\u4F20),\ninvenstemType(\u6295\u8D44\u8005\u7279\u5B9A\u5BF9\u8C61\u8BA4\u8BC1\u7C7B\u578B),\nau';
        _this.$bridge.callHandler('getUserInfo', { message: info }, function (data) {
          _this.loading = false;
          _this.$vux.loading.hide();
          var res = JSON.parse(data);
          console.log('psersonal', res);
          if (res.type && res.isNormal && res.userId && res.invenstemType && res.au) {
            _this.baseInfo.isShowBtn = parseInt(res.isShowBtn || 0);
            _this.baseInfo.type = parseInt(res.type);
            _this.baseInfo.isNormal = parseInt(res.isNormal);
            _this.baseInfo.userId = res.userId;
            _this.baseInfo.invenstemType = res.invenstemType;
            _this.baseInfo.invenstemUserId = res.invenstemUserId;
            _this.baseInfo.au = res.au;
            _this.baseInfo.stepCurrent = parseInt(res.stepCurrent);
            _this.baseInfo.stepTotal = parseInt(res.stepTotal);
            _this.baseInfo.orgType = res.orgType;
            console.log(res.stepCurrent, res.stepTotal, _this.baseInfo);
            if (parseInt(res.type) === 0) {
              _this.$_personal_info(res.userId, res.invenstemUserId, res.globalVersion, res.au);
            }
          } else {
            _this.$vux.toast.show({
              type: 'warn',
              text: '信息获取失败'
            });
          }
        });
      }
    },
    idcardChange: function idcardChange(val) {
      if (this.baseInfo.type === 1) {
        if (val && val.length === 18) {
          var year = parseInt(val.substring(6, 10));
          var Year = new Date().getFullYear();
          this.data.userAge = Year - year;
          var sex = parseInt(val.substr(16, 1));
          this.data.userSex = sex % 2 === 0 ? '女' : '男';
        }
      }
    },
    $_personal_info: function $_personal_info(userId, invenstemUserId, globalVersion, au) {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_api_investor__["e" /* getInvestorPersonal */])({ userId: userId, invenstemUserId: invenstemUserId, globalVersion: globalVersion }, au).then(function (res) {
        if (res.code === 0) {
          var resBean = res.data.bean;
          console.log('person-one:', resBean);
          _this3.data = {
            userName: resBean.userName,
            userSex: resBean.userSex,
            userAge: resBean.userAge,
            documentsType: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_components_InvestorInfo_common_investorConfig__["a" /* formatOldCatType */])(resBean.documentsType || '身份证'),
            idCardNo: resBean.idCardNo,
            userCountry: resBean.userCountry,
            userOccupation: resBean.userOccupation,
            userPosition: resBean.userPosition,
            userLandline: resBean.userLandline,
            userMobile: resBean.userMobile,
            zip: resBean.zip,
            documentsValidity: resBean.documentsValidity,
            userEmail: resBean.userEmail,
            userAddress: resBean.userAddress,
            oldInfo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resBean)
          };
          _this3.hasResp = true;
        } else {
          _this3.$vux.toast.show({
            type: 'warn',
            text: res.msg
          });
        }
      });
    },
    $_personal_auth: function $_personal_auth() {
      if (this.baseInfo.type === 0) {
        this.$_personal_next();
      } else {
        for (var item in this.valid) {
          if (this.data[item] === '') {
            this.$vux.toast.show({ type: 'warn', text: this.$refs[item].title + '为空或输入不合规范' });
            return;
          }
        }
        this.$_handle_auth();
      }
    },
    $_handle_auth: function $_handle_auth() {
      var _this4 = this;

      this.$vux.loading.show({ text: '加载中' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_api_investor__["f" /* getInvestorOtherAuth */])({
        userId: this.baseInfo.userId,
        invenstemType: this.baseInfo.invenstemType,
        invenstemUserId: this.baseInfo.invenstemUserId,
        name: this.data.userName,
        idCard: this.data.idCardNo
      }, this.baseInfo.au).then(function (res) {
        _this4.$vux.loading.hide();
        if (res.code === 0) {
          _this4.$_personal_next();
        } else {
          _this4.$vux.alert.show({
            title: '提示',
            content: res.msg
          });
        }
      });
    },
    $_personal_next: function $_personal_next() {
      this.data.type = this.baseInfo.type;
      this.data.isNormal = this.baseInfo.isNormal;
      this.$router.push({ path: '/investor/personal/question', query: this.data });
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_number_index_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_number_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_number_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_selector_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_selector_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_selector_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_datetime_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_icon_index_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vux_src_components_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vux_src_components_checker_checker_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vux_src_components_checker_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vux_src_components_checker_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vux_src_components_checker_checker_item_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vux_src_components_checker_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vux_src_components_checker_checker_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vux_src_components_x_textarea_index_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vux_src_components_x_textarea_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vux_src_components_x_textarea_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_common_investorConfig__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_js_isReachBottom__ = __webpack_require__(234);


















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    propData: {
      type: [Object]
    },
    baseInfo: {
      type: [Object]
    },
    hasResp: {
      type: [Boolean],
      default: false
    }
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_input_index_vue___default.a,
    Selector: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_selector_index_vue___default.a,
    XNumber: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_x_number_index_vue___default.a,
    Datetime: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_datetime_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_x_button_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_10_vux_src_components_icon_index_vue___default.a,
    Checker: __WEBPACK_IMPORTED_MODULE_11_vux_src_components_checker_checker_vue___default.a,
    CheckerItem: __WEBPACK_IMPORTED_MODULE_12_vux_src_components_checker_checker_item_vue___default.a,
    XTextarea: __WEBPACK_IMPORTED_MODULE_13_vux_src_components_x_textarea_index_vue___default.a
  },
  data: function data() {
    return {
      isReady: true,
      data: {
        userInvestmentExperience: {
          checked: ''
        },
        userAssetsScale: {
          checked: ''
        },
        isControllingShareholder: {
          checked: '',
          description: ''
        },
        transactionActualBeneficiary: {
          checked: '',
          description: ''
        },
        isBadFaith: {
          checked: '',
          description: ''
        }
      }
    };
  },

  computed: {
    isFund: function isFund() {
      return this.baseInfo.orgType !== 'futures';
    }
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common_js_isReachBottom__["a" /* default */])(this);
  },
  mounted: function mounted() {},

  watch: {
    hasResp: function hasResp(bool) {
      if (bool) {
        this.$_personal_init();
      }
    }
  },
  methods: {
    isForeign: __WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_common_investorConfig__["b" /* isForeign */],
    iDCardTypesLabel: __WEBPACK_IMPORTED_MODULE_14_components_InvestorInfo_common_investorConfig__["c" /* iDCardTypesLabel */],
    $_personal_init: function $_personal_init() {
      this.data.userInvestmentExperience.checked = parseInt(this.baseInfo.isNormal) === 1 ? '否' : '是';
      if (this.propData.oldInfo) {
        var res = JSON.parse(this.propData.oldInfo);
        this.data = {
          userInvestmentExperience: {
            checked: JSON.parse(res.userInvestmentExperience).checked
          },
          userAssetsScale: {
            checked: JSON.parse(res.userAssetsScale).checked
          },
          isControllingShareholder: {
            checked: JSON.parse(res.isControllingShareholder).checked,
            description: JSON.parse(res.isControllingShareholder).description
          },
          transactionActualBeneficiary: {
            checked: JSON.parse(res.transactionActualBeneficiary).checked,
            description: JSON.parse(res.transactionActualBeneficiary).description
          },
          isBadFaith: {
            checked: JSON.parse(res.isBadFaith).checked,
            description: JSON.parse(res.isBadFaith).description
          }
        };
      }
    },
    $_personal_submit: function $_personal_submit() {
      var subObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.data, this.propData);
      delete subObj.oldInfo;
      delete subObj.type;
      delete subObj.isNormal;
      this.$_personal_commit(subObj);
    },
    $_personal_commit: function $_personal_commit(json) {
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json));
      if (!this.isDev) {
        console.log('submit');
        this.$bridge.callHandler('getResult', { message: '最后确认', json: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json) }, function (data) {});
      }
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_check_icon_index_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_check_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vux_src_components_check_icon_index_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue___default.a,
    Checker: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue___default.a,
    CheckerItem: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue___default.a,
    XTextarea: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue___default.a,
    CheckIcon: __WEBPACK_IMPORTED_MODULE_10_vux_src_components_check_icon_index_vue___default.a
  },
  data: function data() {
    return {
      loading: true,
      text: '加载中',
      type: 0,
      invenstemType: '',
      data: {
        userInvestmentExperience: {
          checked: ''
        },
        userAssetsScale: {
          checked: ''
        },
        isControllingShareholder: {
          checked: '',
          description: ''
        },
        transactionActualBeneficiary: {
          checked: '',
          description: ''
        },
        isBadFaith: {
          checked: '',
          description: ''
        }
      }
    };
  },

  watch: {
    'data.userAssetsScale.checked': function dataUserAssetsScaleChecked(val, oldVal) {
      if (val === '否') {
        this.$_personal_toast(oldVal);
      }
    }
  },
  created: function created() {
    this.$vux.loading.show({ text: '加载中' });
    this.$bridge.registerHandler('getUpdate', this.$_personal_update);
    this.$_personal_init();
  },
  mounted: function mounted() {
    var _this = this;
    _this.$bridge.callHandler('getUserInfo', { message: '获取投资者类型' }, function (res) {
      var data = JSON.parse(res);
      if (data.invenstemType) {
        _this.invenstemType = data.invenstemType;
      }
    });
  },

  methods: {
    $_personal_update: function $_personal_update() {
      this.type = 1;
    },
    $_personal_init: function $_personal_init() {
      var _this2 = this;

      var _this = this;
      setTimeout(function () {
        _this.type = parseInt(_this2.$route.query.type);
        _this.data.userInvestmentExperience.checked = parseInt(_this2.$route.query.isNormal) === 1 ? '否' : '是';
        if (_this.$route.query.oldInfo) {
          var res = JSON.parse(_this2.$route.query.oldInfo);
          _this2.data = {
            userInvestmentExperience: {
              checked: JSON.parse(res.userInvestmentExperience).checked
            },
            userAssetsScale: {
              checked: JSON.parse(res.userAssetsScale).checked
            },
            isControllingShareholder: {
              checked: JSON.parse(res.isControllingShareholder).checked,
              description: JSON.parse(res.isControllingShareholder).description
            },
            transactionActualBeneficiary: {
              checked: JSON.parse(res.transactionActualBeneficiary).checked,
              description: JSON.parse(res.transactionActualBeneficiary).description
            },
            isBadFaith: {
              checked: JSON.parse(res.isBadFaith).checked,
              description: JSON.parse(res.isBadFaith).description
            }
          };
        }
        _this.loading = false;
        _this.$vux.loading.hide();
      }, 500);
    },
    $_personal_submit: function $_personal_submit() {
      for (var item in this.data) {
        if (this.data[item].checked === '') {
          this.$vux.toast.show({
            type: 'warn',
            text: '选择为空或输入不合规范'
          });
          return;
        }
        var isControllingShareholder = item === 'isControllingShareholder' && this.data[item].checked === '是' && this.data[item].description === '';
        var transactionActualBeneficiary = item === 'transactionActualBeneficiary' && this.data[item].checked === '他人' && this.data[item].description === '';
        var isBadFaith = item === 'isBadFaith' && this.data[item].checked === '是' && this.data[item].description === '';
        if (isControllingShareholder || transactionActualBeneficiary || isBadFaith) {
          this.$vux.toast.show({
            type: 'warn',
            text: '请输入说明内容'
          });
          return;
        }
      }
      this.$_personal_commit(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.data, this.$route.query));
    },
    $_personal_commit: function $_personal_commit(json) {
      delete json.oldInfo;
      delete json.type;
      delete json.isNormal;
      if (this.isDev) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json));
      } else {
        this.$bridge.callHandler('getResult', { message: '最后确认', json: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json) }, function (data) {
          console.log('submit');
        });
      }
    },
    $_personal_toast: function $_personal_toast(oldVal) {
      var _this = this;
      var str = '';
      if (this.type === 1) {

        if (_this.invenstemType === 'SPECIFIC_PERSONAL_PRACTITIONERS') {
          str = '据《私募投资基金募集行为管理办法》32条规定，此项选“否”，将标记该投资者为“投资于所管理私募基金的私募基金管理人的从业人员”，即当然合格投资者，后续无需签署合格投资者承诺函';
        } else {
          str = '根据《证券期货投资者适当性管理办法》第十四条“一定时期”的规定，私募基金合格投资者必须满足该条件，若您确认选否，该投资者则不符合私募基金购买条件，我们将终止本投资者信息表的填写';
        }
        this.$vux.alert.show({
          title: '提示',
          content: str,
          onHide: function onHide() {

            if (_this.invenstemType !== 'SPECIFIC_PERSONAL_PRACTITIONERS') {
              _this.data.userAssetsScale.checked = oldVal;
            }
          }
        });
      }
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_datetime_view_index_vue__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_datetime_view_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_datetime_view_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_popup_index_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_api_investor__ = __webpack_require__(61);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default.a,
    Selector: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default.a,
    XNumber: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default.a,
    Datetime: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default.a,
    Popup: __WEBPACK_IMPORTED_MODULE_10_vux_src_components_popup_index_vue___default.a,
    DatetimeView: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_datetime_view_index_vue___default.a
  },
  data: function data() {
    return {
      au: 'VS8rOW5LdmM2aVE2WFp3M1VtTHBiL0ZUWWEwZmVCWUp4S0hVVmlxbWZWbjc0aUkxcTkrNE9iT3FHMFU0RElNMQ==',
      orgInfoType: 'fund', // 募集机构类型 orgType，fund:基金，futures：期货资管
      loading: true,
      type: 0,
      isNormal: 1,
      showPopup: false,
      showCheckPopup: false,
      todayDate: this.$util.getFormatDate(),
      proTypeArry: ['银行理财产品', '保险产品', '信托计划', '私募投资基金', '开放式公募基金产品', '封闭式公募基金产品', '基金公司专户', '基金子公司产品', '保险公司及其子公司的资产管理计划', '证券公司集合理财产品', '证券公司专项资管计划', '证券公司定向资管计划', '期货公司及其子公司的资产管理计划', '政府引导基金', '全国社保基金', '地方社保基金', '基本养老保险', '养老金产品', '企业年金及职业年金', '境外资金（QFII）', '境外资金（RQFII）', '其它境外资金', '社会公益基金（慈善基金、捐赠基金等）', '其他产品'],

      data: {
        productName: '111',
        productType: '银行理财产品',
        productRecordCode: '',
        productFoundingDate: '',
        productRecordDate: '',
        productRecordNo: '',
        productSurvivalPeriod: '',
        productCategory: '私募证券投资基金',
        productScale: '',
        productManager: '',
        productDeposit: '',
        extendC: '',
        extendD: ''
      },
      valid: {
        productName: { code: '产品名称', is_success: '' },
        productFoundingDate: { code: '成立时间', is_success: '' },
        productSurvivalPeriod: { code: '存续期', is_success: '' },
        productScale: { code: '产品规模', is_success: '' },
        productManager: { code: '管理人', is_success: '' },
        productDeposit: { code: '托管人', is_success: '' },

        productRecordNo: { code: '备案编号', is_success: '' },
        productRecordDate: { code: '备案时间', is_success: '' }
      }
    };
  },

  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_11_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  computed: {},
  created: function created() {
    var _this2 = this;

    setTimeout(function () {
      _this2.$vux.loading.show({ text: '加载中' });
      _this2.$bridge.registerHandler('getUpdate', _this2.$_product_update);
      _this2.$_product_init();
    }, this.initTime);
  },

  methods: {
    $_product_update: function $_product_update() {
      this.type = 1;
    },
    $_product_init: function $_product_init() {
      var _this = this;

      if (_this.isDev) {
        if (_this.type === 0) {
          _this.$_product_info(3, this.au);
        }
        _this.loading = false;
        _this.$vux.loading.hide();
      } else {
        _this.$bridge.callHandler('getUserInfo', { message: '新增/查看投资者信息, 参数type（1新增,0查看),isNormal(1是 0 否，string类型),extendC(管理员ID),extendD(投资者ID),productDealId(产品ID,查看时传入),au' }, function (data) {
          _this.loading = false;
          _this.$vux.loading.hide();
          var res = JSON.parse(data);
          if (res.type && res.isNormal && res.au && res.extendD && res.extendC) {
            _this.type = parseInt(res.type);
            _this.isNormal = parseInt(res.isNormal);
            _this.au = res.au;
            _this.data.extendC = res.extendC;
            _this.data.extendD = res.extendD;
            _this.orgInfoType = res.orgType;
            if (_this.type === 0) {
              _this.$_product_info(res.productDealId, res.au);
            } else {
              _this.data.productName = res.productName;
              _this.data.productManager = res.productManager;
            }
          } else {
            _this.$vux.toast.show({
              type: 'warn',
              text: '信息获取失败'
            });
          }
        });
      }
    },
    $_product_info: function $_product_info(productDealId, au) {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_api_investor__["d" /* getInvestorProduct */])({ productDealId: productDealId }, au).then(function (res) {
        if (res.code === 0) {
          _this3.data = {
            productName: res.data.bean.productInvenstement.productName,
            productType: res.data.bean.productInvenstement.productType,
            productRecordCode: res.data.bean.productInvenstement.productRecordCode,
            productFoundingDate: res.data.bean.productInvenstement.productFoundingDate,
            productRecordDate: res.data.bean.productInvenstement.productRecordDate,
            productRecordNo: res.data.bean.productInvenstement.productRecordNo,
            productSurvivalPeriod: res.data.bean.productInvenstement.productSurvivalPeriod,
            productCategory: res.data.bean.productInvenstement.productCategory,
            productScale: res.data.bean.productInvenstement.productScale,
            productManager: res.data.bean.productInvenstement.productManager,
            productDeposit: res.data.bean.productInvenstement.productDeposit,
            extendC: res.data.bean.extendC,
            extendD: res.data.bean.extendD,
            oldInfo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.bean.productInvenstement)
          };
        } else {
          _this3.$vux.toast.show({
            type: 'warn',
            text: '信息获取失败'
          });
        }
      });
    },
    $_product_next: function $_product_next() {
      if (this.type === 0) {
        this.data.type = this.type;
        this.data.isNormal = this.isNormal;
        this.data.au = this.au;
        this.data.orgInfoType = this.orgType;
        this.$router.push({ path: '/investor/product/two', query: this.data });
      } else {
        for (var item in this.valid) {
          if (this.data[item] === '') {
            console.log(this.data[item]);
            this.$vux.toast.show({
              type: 'warn',
              text: this.valid[item].code + '不能为空或输入不合规范'
            });
            return;
          }
        }
        this.data.type = this.type;
        this.data.isNormal = this.isNormal;
        this.data.au = this.au;
        this.data.orgInfoType = this.orgType;
        this.$router.push({ path: '/investor/product/two', query: this.data });
      }
    }
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_loading_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_group_index_vue___default.a,
    Checker: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_checker_checker_vue___default.a,
    CheckerItem: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_checker_checker_item_vue___default.a,
    XTextarea: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_icon_index_vue___default.a
  },
  data: function data() {
    return {
      loading: true,
      type: 0,
      orgInfoType: 'fund', // 募集机构类型 orgType，fund:基金，futures：期货资管
      data: {
        isFollowProduct: {
          checked: ''
        },
        orgAssetSize: {
          checked: ''
        },
        isControllingShareholder: {
          checked: '',
          description: ''
        },
        transactionActualBeneficiary: {
          checked: '',
          description: ''
        },
        isBadFaith: {
          checked: '',
          description: ''
        }
      }
    };
  },

  computed: {
    isFund: function isFund() {
      return this.orgInfoType !== 'futures';
    }
  },
  created: function created() {
    this.$vux.loading.show({ text: '加载中' });
    this.$bridge.registerHandler('getUpdate', this.$_product_update);
    this.$_product_init();
  },

  methods: {
    $_product_update: function $_product_update() {
      this.type = 1;
    },
    $_product_init: function $_product_init() {
      var _this2 = this;

      var _this = this;
      setTimeout(function () {
        _this.data.isFollowProduct.checked = parseInt(_this2.$route.query.isNormal) === 1 ? '否' : '是';
        _this.type = parseInt(_this2.$route.query.type);
        _this.orgInfoType = _this2.$route.query.orgInfoType;
        if (_this.$route.query.oldInfo) {
          var res = JSON.parse(_this2.$route.query.oldInfo);
          _this.data = {
            isFollowProduct: {
              checked: JSON.parse(res.isFollowProduct).checked
            },
            orgAssetSize: {
              checked: JSON.parse(res.orgAssetSize).checked
            },
            isControllingShareholder: {
              checked: JSON.parse(res.isControllingShareholder).checked,
              description: JSON.parse(res.isControllingShareholder).description
            },
            transactionActualBeneficiary: {
              checked: JSON.parse(res.transactionActualBeneficiary).checked,
              description: JSON.parse(res.transactionActualBeneficiary).description
            },
            isBadFaith: {
              checked: JSON.parse(res.isBadFaith).checked,
              description: JSON.parse(res.isBadFaith).description
            }
          };
        }
        _this.loading = false;
        _this.$vux.loading.hide();
      }, 500);
    },
    $_product_submit: function $_product_submit() {
      for (var item in this.data) {
        if (this.data[item].checked === '') {
          this.$vux.toast.show({
            type: 'warn',
            text: '选择为空或输入不合规范'
          });
          return;
        }
        var isControllingShareholder = item === 'isControllingShareholder' && this.data[item].checked === '是' && this.data[item].description === '';
        var transactionActualBeneficiary = item === 'transactionActualBeneficiary' && this.data[item].checked === '其他机构或个人' && this.data[item].description === '';
        var isBadFaith = item === 'isBadFaith' && this.data[item].checked === '是' && this.data[item].description === '';
        if (isControllingShareholder || transactionActualBeneficiary || isBadFaith) {
          this.$vux.toast.show({
            type: 'warn',
            text: '请输入说明内容'
          });
          return;
        }
      }
      this.$_product_commit(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.data, this.$route.query));
    },
    $_product_commit: function $_product_commit(json) {
      delete json.oldInfo;
      delete json.type;
      delete json.isNormal;
      if (this.isDev) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json));
      } else {
        this.$bridge.callHandler('getResult', { message: '最后确认', json: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json) }, function (data) {
          console.log('submit');
        });
      }
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_api_investor__ = __webpack_require__(61);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default.a,
    Selector: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default.a,
    XNumber: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default.a,
    Datetime: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default.a,
    PopupRadio: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue___default.a
  },
  data: function data() {
    return {
      localValidity: '存在有效期',
      orgTypeArry: ['保险机构', '上市公司', '信托公司', '证券公司', '期货公司', '基金管理公司', '基金管理公司子公司', '银行', '财务公司', '证券公司子公司', '期货公司子公司', '私募基金管理人', '非金融机构企业法人', '机关法人', '事业单位法人', '社会团体法人', '非金融类非法人机构', '其他境内金融机构', '境外代理人', '境外金融机构', '外国战略投资者', '境外非金融机构', '私募基金管理人', '其它'],

      loading: true,
      type: 0,
      data: {
        managerName: '',
        orgType: '',
        orgCertificateType: '',
        orgCertificateNo: '',
        orgValidity: '',
        orgQualificationProve: '',
        orgQualificationNo: '',
        orgBusinessScope: '',
        orgRegisterAddress: '',
        orgRegisterCapital: '',
        orgOfficeAddress: '',
        orgController: ''
      },
      valid: {
        managerName: false,
        orgType: false,
        orgCertificateType: false,
        orgCertificateNo: false,
        orgValidity: false,
        orgQualificationProve: false,
        orgQualificationNo: false,
        orgBusinessScope: false,
        orgRegisterAddress: false,
        orgRegisterCapital: false,
        orgOfficeAddress: false,
        orgController: false
      }
    };
  },

  watch: {
    localValidity: function localValidity(val, oldVal) {
      if (val === '永久有效') {
        this.data.orgValidity = val;
      } else {
        this.data.orgValidity = '';
      }
    }
  },
  created: function created() {
    this.$vux.loading.show({ text: '加载中' });
    this.$bridge.registerHandler('getUpdate', this.$_product_update);
    this.$_product_init();
  },

  methods: {
    $_product_update: function $_product_update() {
      this.type = 1;
    },
    $_product_init: function $_product_init() {
      var _this2 = this;

      var _this = this;
      setTimeout(function () {
        _this.type = parseInt(_this2.$route.query.type);
        if (_this.$route.query.oldInfo) {
          var res = JSON.parse(_this2.$route.query.oldInfo);
          _this.data = {
            managerName: res.managerName,
            orgType: res.orgType,
            orgCertificateType: res.orgCertificateType,
            orgCertificateNo: res.orgCertificateNo,
            orgValidity: res.orgValidity,
            orgQualificationProve: res.orgQualificationProve,
            orgQualificationNo: res.orgQualificationNo,
            orgBusinessScope: res.orgBusinessScope,
            orgRegisterAddress: res.orgRegisterAddress,
            orgRegisterCapital: res.orgRegisterCapital,
            orgOfficeAddress: res.orgOfficeAddress,
            orgController: res.orgController
          };
        } else {

          _this.$bridge.callHandler('getUserInfo', { msg: '获取产品ID和AU' }, function (res) {
            var data = JSON.parse(res);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_api_investor__["b" /* getInvestorAgency */])({ userId: data.extendC, invenstemUserId: data.extendD, globalVersion: data.globalVersion }, data.au).then(function (response) {
              if (response.code === 0) {
                var resInfo = response.data.bean;
                _this.data = {
                  managerName: resInfo.orgName,
                  orgType: resInfo.orgType,
                  orgCertificateType: resInfo.orgDocumentsType,
                  orgCertificateNo: resInfo.orgDocumentsNo,
                  orgValidity: resInfo.orgDocumentsValidity,
                  orgQualificationProve: resInfo.orgQualificationProve,
                  orgQualificationNo: resInfo.orgQualificationNo,
                  orgBusinessScope: resInfo.orgBusinessScope,
                  orgRegisterAddress: resInfo.orgRegisterAddress,
                  orgRegisterCapital: resInfo.orgRegisteredCapital,
                  orgOfficeAddress: resInfo.orgAddress,
                  orgController: resInfo.orgController
                };
              }
            });
          });
        }
        _this.loading = false;
        _this.$vux.loading.hide();
      }, 500);
    },
    $_product_auth: function $_product_auth() {
      this.$_product_next();
    },
    $_handle_auth: function $_handle_auth() {
      var _this3 = this;

      this.$vux.loading.show({ text: '加载中' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_api_investor__["c" /* getInvestorAuth */])({ userId: 0, name: this.data.managerName, idcard: this.data.orgCertificateNo }, this.$route.query.au).then(function (res) {
        _this3.$vux.loading.hide();
        if (res.code === 0) {
          _this3.$_product_next();
        } else {
          _this3.$vux.alert.show({
            title: '提示',
            content: res.msg
          });
        }
      });
    },
    $_product_next: function $_product_next() {
      this.$route.query.type = this.type;
      this.$router.push({ path: '/investor/product/four', query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.data, this.$route.query) });
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_api_investor__ = __webpack_require__(61);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_loading_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_group_index_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_input_index_vue___default.a,
    Selector: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_selector_index_vue___default.a,
    XNumber: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_number_index_vue___default.a,
    Datetime: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_datetime_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_button_index_vue___default.a,
    PopupRadio: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_popup_radio_index_vue___default.a
  },
  data: function data() {
    return {
      localValidity: '存在有效期',
      loading: true,
      type: 0,
      data: {
        transactorName: '',
        transactorSex: '',
        transactorAge: '',
        transactorCertigicateType: '身份证',
        transactorCertigicateNo: '',
        transactorCertificateValidity: '',
        transactorPosition: '',
        transactorLandline: '',
        transactorMobile: '',
        transactorEmail: '',
        transactorOfficeZip: '',
        transactorOfficeAddress: '',
        transactorProductRelation: ''
      },
      isIdCard: function isIdCard(value) {
        return {
          valid: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(value),
          msg: '身份证号码格式不正确'
        };
      },
      isPhone: function isPhone(value) {
        return {
          valid: /\d{1,20}/.test(value),
          msg: '号码格式不正确'
        };
      },
      valid: {
        transactorName: false,
        transactorAge: false,
        transactorCertigicateType: false,
        transactorCertigicateNo: false,
        transactorCertificateValidity: false,
        transactorPosition: false,
        transactorLandline: false,
        transactorMobile: false,
        transactorEmail: false,
        transactorOfficeZip: false,
        transactorOfficeAddress: false,
        transactorProductRelation: false
      }
    };
  },

  watch: {
    localValidity: function localValidity(val, oldVal) {
      if (val === '永久有效') {
        this.data.transactorCertificateValidity = val;
      } else {
        this.data.transactorCertificateValidity = '';
      }
    }
  },
  created: function created() {
    this.$vux.loading.show({ text: '加载中' });
    this.$bridge.registerHandler('getUpdate', this.$_product_update);
    this.$_product_init();
  },

  methods: {
    $_product_update: function $_product_update() {
      this.type = 1;
    },
    $_product_init: function $_product_init() {
      var _this2 = this;

      var _this = this;
      setTimeout(function () {
        _this.type = parseInt(_this2.$route.query.type);
        if (_this.$route.query.oldInfo) {
          var res = JSON.parse(_this2.$route.query.oldInfo);
          _this.data = {
            transactorName: res.transactorName,
            transactorSex: res.transactorSex,
            transactorAge: res.transactorAge,
            transactorCertigicateType: res.transactorCertigicateType,
            transactorCertigicateNo: res.transactorCertigicateNo,
            transactorCertificateValidity: res.transactorCertificateValidity,
            transactorPosition: res.transactorPosition,
            transactorLandline: res.transactorLandline,
            transactorMobile: res.transactorMobile,
            transactorEmail: res.transactorEmail,
            transactorOfficeZip: res.transactorOfficeZip,
            transactorOfficeAddress: res.transactorOfficeAddress,
            transactorProductRelation: res.transactorProductRelation
          };
        } else {

          _this.$bridge.callHandler('getUserInfo', { msg: '获取产品ID和AU' }, function (res) {
            var data = JSON.parse(res);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_api_investor__["b" /* getInvestorAgency */])({ userId: data.extendC, invenstemUserId: data.extendD, globalVersion: data.globalVersion }, data.au).then(function (response) {
              if (response.code === 0) {
                var resInfo = response.data.bean;
                _this.data = {
                  transactorName: resInfo.managersName,
                  transactorSex: resInfo.managersSex,
                  transactorAge: resInfo.managersAge,
                  transactorCertigicateType: resInfo.managersDocumentsType,
                  transactorCertigicateNo: resInfo.managersIdCardNo,
                  transactorCertificateValidity: resInfo.managersDocumentsValidity,
                  transactorPosition: resInfo.managersPosition,
                  transactorLandline: resInfo.managersLanline,
                  transactorMobile: resInfo.managersMobile,
                  transactorEmail: resInfo.managersEmail,
                  transactorOfficeZip: resInfo.managersZip,
                  transactorOfficeAddress: resInfo.managersAddress,
                  transactorProductRelation: resInfo.relationshipWithOrg
                };
              }
            });
          });
        }
        _this.loading = false;
        _this.$vux.loading.hide();
      }, 500);
    },
    idcardChange: function idcardChange(val) {
      if (this.type === 1) {
        if (val && val.length === 18) {
          var year = Number(val.substring(6, 10));
          var month = Number(val.substring(10, 12));
          var day = Number(val.substring(12, 14));
          var Year = new Date().getFullYear();
          var Month = new Date().getMonth() + 1;
          var Day = new Date().getDate();
          var Sex = Number(val.substring(16, 17));
          var birstday = Number('' + year + month + day);
          var Now = Number('' + Year + Month + Day);
          this.data.transactorAge = birstday - Now > -1 ? Year - year : Year - year - 1;
          this.data.transactorSex = Sex % 2 === 0 ? '女' : '男';
        } else {
          this.data.transactorAge = null;
          this.data.transactorSex = null;
        }
      }
    },
    $_product_auth: function $_product_auth() {
      if (this.type === 0) {
        this.$_product_next();
      } else {
        for (var item in this.valid) {
          console.log(this.data[item]);
          if (this.data[item] === '') {
            this.$refs[item].valid = false;
          }
          if (!this.$refs[item].valid) {
            this.$vux.toast.show({
              type: 'warn',
              text: '参数为空或输入不合规范'
            });
            return;
          }
        }
        this.$_handle_auth();
      }
    },
    $_handle_auth: function $_handle_auth() {
      var _this3 = this;

      this.$vux.loading.show({ text: '加载中' });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_api_investor__["c" /* getInvestorAuth */])({ userId: 0, name: this.data.transactorName, idcard: this.data.transactorCertigicateNo }, this.$route.query.au).then(function (res) {
        _this3.$vux.loading.hide();
        if (res.code === 0) {
          _this3.$_product_next();
        } else {
          _this3.$vux.alert.show({
            title: '提示',
            content: res.msg
          });
        }
      });
    },
    $_product_next: function $_product_next() {
      this.$route.query.type = this.type;
      this.$router.push({ path: '/investor/product/three', query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.data, this.$route.query) });
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    /**
     * SPECIFIC_PERSONAL_ORDINARY 个人-普通
     * SPECIFIC_PERSONAL_PROFESSION 个人-专业
     * SPECIFIC_PERSONAL_PRACTITIONERS 个人-从业人员
     * SPECIFIC_ORG_ORDINARY 机构-普通
     * SPECIFIC_ORG_PROFESSION 机构-专业
     * SPECIFIC_ORG_ORG 机构-金融机构
     * SPECIFIC_ORG_PRACTITIONERS 机构-本机构
     * SPECIFIC_ORG_PRODUCT 机构_产品
     * @return {[type]} [description]
     */
    $_format_type: function $_format_type(type) {
      var str = '';
      if (type === 'SPECIFIC_PERSONAL_ORDINARY') {
        str = '个人 - 普通';
      }
      if (type === 'SPECIFIC_PERSONAL_PROFESSION') {
        str = '个人 - 专业';
      }
      if (type === 'SPECIFIC_PERSONAL_PRACTITIONERS') {
        str = '个人 - 从业人员';
      }
      if (type === 'SPECIFIC_ORG_ORDINARY') {
        str = '机构 - 普通';
      }
      if (type === 'SPECIFIC_ORG_PROFESSION') {
        str = '机构 - 专业';
      }
      if (type === 'SPECIFIC_ORG_ORG') {
        str = '机构 - 金融机构';
      }
      if (type === 'SPECIFIC_ORG_PRACTITIONERS') {
        str = '机构 - 本机构';
      }
      if (type === 'SPECIFIC_ORG_PRODUCT') {
        str = '机构 - 产品';
      }
      return str;
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$vux.loading.show({ text: '加载中' });
    if (this.$route.query.type) {
      this.$_share_router(this.$route.query.type);
    } else {
      this.$vux.loading.hide();
      this.$vux.toast.show({
        type: 'warn',
        text: '未获取到用户类型'
      });
    }
  },

  methods: {
    /**
     * SPECIFIC_PERSONAL_ORDINARY 个人-普通
     * SPECIFIC_PERSONAL_PROFESSION 个人-专业
     * SPECIFIC_PERSONAL_PRACTITIONERS 个人-从业人员
     * SPECIFIC_ORG_ORDINARY 机构-普通
     * SPECIFIC_ORG_PROFESSION 机构-专业
     * SPECIFIC_ORG_ORG 机构-金融机构
     * SPECIFIC_ORG_PRACTITIONERS 机构-本机构
     * SPECIFIC_ORG_PRODUCT 机构_产品
     * @return {[type]} [description]
     */
    $_share_router: function $_share_router(type) {
      var _this = this;
      if (type === 'SPECIFIC_PERSONAL_ORDINARY') {
        // 个人-普通
        _this.$router.push({ path: '/share/one' });
      }
      if (type === 'SPECIFIC_PERSONAL_PROFESSION') {
        // 个人-专业
        _this.$router.push({ path: '/share/two' });
      }
      if (type === 'SPECIFIC_PERSONAL_PRACTITIONERS') {
        // 个人-从业人员
        _this.$router.push({ path: '/share/three' });
      }
      if (type === 'SPECIFIC_ORG_ORDINARY') {
        // 机构-普通
        _this.$router.push({ path: '/share/four' });
      }
      if (type === 'SPECIFIC_ORG_PROFESSION') {
        // 机构-专业
        _this.$router.push({ path: '/share/five' });
      }
      if (type === 'SPECIFIC_ORG_ORG') {
        // 机构-金融机构
        _this.$router.push({ path: '/share/six' });
      }
      if (type === 'SPECIFIC_ORG_PRACTITIONERS') {
        // 机构-本机构
        _this.$router.push({ path: '/share/seven' });
      }
      if (type === 'SPECIFIC_ORG_PRODUCT') {
        // 机构_产品
        _this.$router.push({ path: '/share/eight' });
      }
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },
  created: function created() {
    this.$vux.loading.hide();
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    disabled: {
      type: [Boolean],
      default: false
    }
  },
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue___default.a
  },
  data: function data() {
    return {};
  },

  methods: {
    checkEvent: function checkEvent() {
      if (this.disabled) {
        return;
      } else {
        this.$emit('click');
      }
    }
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    cellHeader: ''
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_index_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_input_index_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_input_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_input_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(158);





/* harmony default export */ __webpack_exports__["default"] = ({
  model: {
    prop: 'value',
    event: 'setValue'
  },
  props: {
    title: {
      type: [String]
    },
    disabled: {
      type: [Boolean],
      default: false
    },
    placeholder: {
      type: [String]
    },
    value: {
      type: [String, Number],
      default: ''
    },
    options: {
      type: [Array]
    }
  },
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_2_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  components: {
    Popup: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_popup_index_vue___default.a,
    XInput: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_x_input_index_vue___default.a
  },
  created: function created() {},
  mounted: function mounted() {
    this.$refs.content.style.height = window.innerHeight + 'px';
  },
  data: function data() {
    return {
      show: false
    };
  },

  methods: {
    isShow: function isShow() {
      if (this.disabled) {
        return;
      }
      this.show = true;
    },
    emitValue: function emitValue(item) {
      this.$emit('setValue', item);
      this.show = false;
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    step: {
      type: Number,
      default: 1
    },
    totalstep: {
      type: Number
    }
  },
  data: function data() {
    return {
      stepArry: [],
      stepwidth: 0,
      pad: 48
    };
  },
  created: function created() {
    for (var i = 0; i < this.totalstep; i++) {
      this.stepArry.push(i);
    }
  },
  mounted: function mounted() {
    var pad = parseInt(this.$refs.step.style.paddingLeft);
    var lineWidth = window.innerWidth - pad * 2;
    this.stepwidth = lineWidth / (this.totalstep - 1);
  },

  computed: {
    padStyle: function padStyle() {
      return {
        'padding-left': this.pad + 'px',
        'padding-right': this.pad + 'px'
      };
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    current_step: '',
    total_step: ''
  },
  methods: {
    leftCheckEvent: function leftCheckEvent() {
      if (Number(this.current_step) <= 1) {
        return;
      } else {
        this.$emit('leftClick');
      }
    },
    rightCheckEvent: function rightCheckEvent() {
      if (Number(this.current_step) >= Number(this.total_step)) {
        return;
      } else {
        this.$emit('rightClick');
      }
    },
    leftDisable: function leftDisable() {
      if (Number(this.current_step) <= 1) {
        return true;
      } else {
        return false;
      }
    },
    rightDisable: function rightDisable() {
      if (Number(this.current_step) >= Number(this.total_step)) {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_check_icon_index_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_check_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_check_icon_index_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    disabled: {
      type: [Boolean],
      default: false
    },
    investerType: {
      type: [Number],
      default: 1003
    }
  },
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue___default.a,
    CheckIcon: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_check_icon_index_vue___default.a
  },
  methods: {
    checkEvent: function checkEvent() {
      var isEmit = this.disabled;
      if (isEmit) {
        return;
      } else {
        this.$emit('click');
      }
    }
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_evaluation__ = __webpack_require__(53);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    baseInfo: {
      type: [Object]
    }
  },
  data: function data() {
    return {
      // list: [
      //   {
      //     productName: '大脑神经啊看了空间的拉萨健康拉夫黑德看了沙发经典福克斯啦荒废了大好时机咖喱和法令纹',
      //     productId: 113,
      //     state: 10001,
      //     newProductRisk: 'C4'
      //   }
      // ]
      list: []
    };
  },
  created: function created() {
    this.getProductList();
  },

  methods: {
    orderDetail: function orderDetail(orderId) {
      this.$bridge.callHandler('orderDetail', { message: '产品详情', orderId: orderId }, function (data) {});
    },
    getProductList: function getProductList() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_api_evaluation__["c" /* getResaultProductList */])({
        plannerInvesterId: this.baseInfo.invenstemUserId,
        investerRiskLevel: this.baseInfo.result
      }, this.baseInfo.au).then(function (res) {
        if (res.code === 0) {
          if (res.data.bean) {
            _this.list = res.data.bean.map(function (item) {
              return {
                orderId: item.orderId,
                productName: item.productName,
                state: item.state,
                newProductRisk: item.newProductRisk
              };
            });
          }
        } else {
          _this.$vux.toast.show({ type: 'warn', text: '获取不匹配产品异常：' + res.msg });
        }
      });
    }
  }
});

/***/ }),
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAAAwCAYAAAA7KGnHAAAABGdBTUEAALGPC/xhBQAABGpJREFUeAHtXNtu1DAQ7bJQLqWAeOEi/oX//wKekECCFqlAaaEUStvlnC2n9RpnnThO4mxmJNeO7RmPxyfjW7azxWLxesso1QILMP5GOETYm81mP1IFlch3G0qxg0bpFrgL1ucMeNH2EL8FSDbCpgaOdFCEOF8gcxsgebMJADFwhIa4Xd5TsL9E+NhOzPDcBMflGjVmKKOLZExSuspttq1/1crNX7+9pvJvJKWlmran+q/gPT7Be1ykNVsGV8xzCASKqbWb9nuhMsUp9atkurLqyvdlNX1WO4pdHUKyVO8WCh8jfA1VGkteDBxj6UeJej6AUgaOEkemAJ344o2azHOMevi6Vd7A0Z19tf7oroWOJRs4ujPweXei+5EscAjl2ooxJjFfeXxWuqqcddZRjD9W7suO1ffLff6m/fPl+fyu/FP3YYxpgsM95xBIFLNPoXQor07/xae4rXzJUVxHnq9niDeU58quKpdslh/rYayxPMdY9S9V7wMcgG3MtFKqkceoF6eT/TEq7utsnsO3SLvnE7C/h9dwp+p2EgfkNnDkMT69xReEbwCGux7JI30gKTNcEN1v0DbvDO4g7CI8QuDqvS/6hYaOEBiXMp/TQ5wDEKO+YEMfgpQ8uAAVQcKr6R0EyeFbo+0ektdplTPPpTr1OQD8yorAMOrRAlWDVksFAIT8BAhvILsgvpHvAAx+imfUswW45kgmzq8gfhpHL3IPQV5DoPM9Q6wtn/+DASNmsu7KuYZoRQQIBBwgMOYUoNhNM69OcHm+QzZX/0YDWaCV55DOHER4kD94ziLvn1xbY8jAA8U5B5PbuYcZ+zH6u4mMthhEVE5wcHvJqSMXbeT2MJdx+pCTExxcv+QExxzySjnP6GMsimsjJzi2M4OD8gwcA0ImCziwGOVA8k3nbmMd+VtVehrl+Xz8QPenn2nP/VkgCzig7hOEOlOK6ihmT900n0U7AN0RdkLcBRkNYAEdViU3jQHkHQvB0QVxWuGPg2IeqYu2Jy8zGRwABXl5bM5LuC6JAPlsHqRLE4dlNwIHAMEdCdcWPCrnmQbTfRHXHwycZi4BlqrpqC99Nr4dXo7w4qwRSDbeKtPoIF8uniXxE4gTvGz/7QwFjr7MQYUIRL31Sk8FnCX3/xgAWfnnM9ytcLGnwfGVR9Fa8gfX5/fLKUzAYFptVy04ff468ilX5NdXvuKYfNWrimP8fjnllNr/XcwiWy5A6DmeVfXc8idpgUMA5Iw9p+dwkTxJa1inVyzAjcbyvwMYOFbsYg+wwByzyRze48LAYXgIWYC4MHCELGN5VxsU8xyGhJAFlutQA0fINJY3CXCwkzpr4JArzXgKlNr/5WmpPMcSKbCWb7yYcL88ZvCY/Bh/Srn6Jl732dc/pl+sXG1UxW35q+Suy3f7y3ruc6j//AXf8lCSh2Bd36quU9zKyrPAKcCx4jnKU9E0GsICZwIGG9e0MoQi1mZZFiAwVr66M3CUNUB9a8M1B6/tr9cZrgJ/AS+AfwTYqhyBAAAAAElFTkSuQmCC"

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/confirm1.ce95828.png";

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/confirm2.119f57d.png";

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contact2.b305c13.png";

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contract0.595bae1.png";

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contract11.8c7924d.png";

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contract12.a0e8e09.png";

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contract13.cd8a40b.png";

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/create1.1ad2a74.png";

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/create2.b129243.png";

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/create3.264b935.png";

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download.cd5cb1f.png";

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/findPwd.b1952ec.png";

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/invite.d70dcdb.png";

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/invite1.aa926c6.png";

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/invite11.47b4da0.png";

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/invite2.36ec9ab.png";

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/invite22.40f39de.png";

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inviteTitle.938de9e.png";

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAAAXNSR0IArs4c6QAAATlJREFUWAnl2N0NgjAUBWAwTsLPAG7gq7qFcRpnMLzpACbqmys4gIFV8B4VAgFKL0E4xCbVAi39KiQ90XH+qaRp6nqet0ZFe4i1z7pOAqDv+wcZf0GV9qrrvTTjOoEL2K1msj76qsEN2CiO41sfoLZ7qN47A3bnum7aNlkf163BDFgs2ArMgrUCM2FbwWxYI5gR2whmxdaCmbEVMDu2BJ4CNgcDGwTBXb6XOIkiO9dD6vlzNPrnU8oJu+kcFMHui1ick+MFKtoMJQxDMI5Z+BkkB/Sx8PfWLL/kZF6JPEsA/Q3kxYyL2DhYErN5AjkYnaeALoGngK6A2dG1YGZ0I5gVbQQzolvBbGgrMBPaGsyCVoEZ0GqwAb1JkuSK678sWVpTzYFciowhgyLVwLE7I3sM/Xfr2GtWz/8CVXsUAD71xrEAAAAASUVORK5CYII="

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAAAXNSR0IArs4c6QAAAUNJREFUWAnV2N0NgjAQAGAqDkSZgFfjFsZpnMHwpgOYqG9uAOXdWQB7hBIMLVz5vTYxBazt13qkl3qeY4VN8ZZlybIsO0AfQRC8GWPllP4wv91hGunaADZN02ue50/4KLiu7ZzPRoEVVtanOTGYvqzBOqwMhRhCAjPg1DZWMWzChmF4XiN+YbJoMAUsGkwFiwJTwg6CqWF7wRSxRjBVrBZMGdsBU8f+gV3ANmDACiE+RVFE8LAuQu5eD3Wzcf2Vu+kddtM9QJIkucgqgutW4XIivHW/6aXMDGH8W5X8rJUHzDHjKpdwKSSa5Mepl079VS6gmxV2Bd0BA5zySmvBlNFGMFV0L5giehBMDY0CU0KjwVTQVmAKaGuwCe37/pFz/oLvlyzWR1WAgeyuPu2Jl8Tp+h61wqoj2BHVqeVax61qbGfqH8scZTkA7ltuAAAAAElFTkSuQmCC"

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/record1.db794e2.png";

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/record2.a6a0298.png";

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/record_local1.633f1b0.png";

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/record_local2.1d3482f.png";

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/relation.0cbfd96.png";

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAAAXNSR0IArs4c6QAAATFJREFUWAnt2N0JwjAQAODGUfozgCv4pg8OoG/FGVzCFaRPriC+Oki7SuNdIRAsaJK73kUwEBrKpflyhCakKP5lngFrrSnLcocV2/OI8Der8ND0yKqqttD7jhXaVwpaBPw21ZaCFgEPw/AAdOfBk9Gk9eQBvjZxGWBmIbD1gjuYzMkYY713H5tiYFRwoEXBHGhxMBWtAqag1cCpaFVwClodHIvOAhyDzgYcip7A+ENvmuYAnRrsqF3As4e6dg7YCZ99329wR5zAdV0fx3G8uYAcn4C9wDZ+Fjn8cCbgN5cEZwYo3wo5HGXzlwjBYjKyAIdiswDHYNXBsVhVcApWDZyKVQFTsOJgKlYUzIEVA3NhxcB4CQiD4d2aK9EXKK6jxmktGevQiz9xSXBdty6O5R7gBRIHD1tKWjreAAAAAElFTkSuQmCC"

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAAAXNSR0IArs4c6QAAATRJREFUWAnV2EsOwiAQANDCXdyX9gbudOEBdGc8g5fwCqYrr2DceoF+LtQgU0vSJczQGUrSsGE6DzqhhKLYWFMcXmutGobhALnKsvwopSw2r8YGxsQBdhzHNzxd1z1hAjHxy7Es4GVCh71S0CzguQwaD6eg0Z/GJw/toQzmlb36GFfLTVVVt5iaZgMDMgWaFZwCzQ6mokXAFLQYGIsWBWPQ4uBYdBbgGHQ24FD0BJ439LML2kGgdHOekzMY79Baf40xe/gjTuC2bS9u0MsPyLF32Edd13eWw0/KBdhmSaRcAcq7Qg5H2ewSIVhYjCzAodgswDFYcXAsVhSMwYqBsVgRMAXLDqZiWcEpsGzgVFg2cN/3R7hXg4TQMBco/8iiYD+tUbDTZL18zR5KItV165rOVd79A7g0XJW8yHORAAAAAElFTkSuQmCC"

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/risk_nor1.3e32c2b.png";

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/risk_nor2.9c8b286.png";

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/risk_sp1.61c3703.png";

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/risk_sp2.072047d.png";

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/risk_sp3.a1b2663.png";

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAACwCAYAAACvt+ReAAAABGdBTUEAALGPC/xhBQAADiRJREFUeAHtnT1vGzkQhrmSLFzOlq8I3ARBCrcpL0DuEBdx4Sa9/Xv8e+I+jQunSHAXwCnTugiCNEYKf8WBvJKOQ2l1kiztcobL3ZH1EjD0sfzadx7RlDgcJgapVAUG+/tN8+1b2zQaLfPrV8NV/ttvfdPvp+bp025ydNQrtcEVryxZ8fsv7fYHg0FiXrx4ZCtcK6j0zpye3iZJMijIh8seCgxHCI+MyLJYgcHhYcPs7GzYHEXwUiVrlNeVWVwlrngqgBHYU6hF2RyIx8fr4+nCooyz79O0Ym/vJjk87M9ewmt/BQCwv1b3corhzWoCxJkS4kcALJQuGN6sXUCcKSF6BMAC2UqDN2sbEGdKsB8BMFOy0uHN2gfEmRKsRwDMkCsavFkfAHGmhPcjAPaUKjq8WT8AcaaE1+PSAuyAev++Ya6uErO93Tdv3/ZjLQ5UBm9mssgQu0WXg4OGOTtrmE5nYF6/7i/rz3lLBbAT/s2btrm8bM/93fXx49Q0m6nZ2EjLWrKtHN5IELsl7uvrlun1WubHj1bWzPiRPjSbm13z7l031kAwbqvEJ0sDsDPA9++/zwV3niCt1sCkaWpH59Q8f55KRpja4M3uJ2Akdn3/8qVlR9mWabVaVgs/W1ObT578LGsAyG4l1qPfTcVq3bNeB+/Xr+veRphXLxmGHGq63dT6IqRFo0zt8Gb34AnxyBejZdrt1pQjUVYP55E+/M+e3SwDxOoBdobZ3V23c90mxwaFeTsd8gpL3d/JSW8SaDXwZjcxB+KRLqQJTQdaUfQ5ObmZ1CXrjqZH/QDv77ftv0Hy8oqXJqcbxvQMZ6oSr1fTNY/+tds3m+xpwXRN/q+2t2/tKNz1L1B9zvuT+er7kN/i+Xk7P0MJV4fzwzULho83WQkNCqog3+KzM/J4GyY7vY+ehtqrBli1O6X7N1n21CG61R9QA1Z7ZwPFt6QaYOsgrv8/hGLjltI15TbQDTB9o0aqVwHlNtANMO0rQ6pXAeU2UAuw+ykr2xRZrwlXu3VrA2cLpSqoBdjQKhKSDgUU20IvwLQEiqRDAcW20Aswrd8j6VBAsS1UAux8H3ydT3SY+GH3wtrC2UThXaoE2JDbH5IuBZTaRCfA5LOKpEsBpTZRB7BbupzncK3LnKvXG2sTjcvK6gA2u7vluk2uHmrx7lihbfQBPPRvjWcE1ByigLqpHQAOMefqlQXAeTaH+2SeOgquKXSv1DUCK3fdU4BQ/V1QZiNdACt33aufHgU9UGaj2vfEuWkDfapJmH5/LWjnsQL7Pvgu0P7BRuPOd3d3bD0qB9gBO/w5hr4QlL+bNrZiqH9agZzd3dMZ47yqBGC3jp4XFSbOvaHWOhSIEB0p7zaiAOwcoCVRYfJ6imvLp8BkuAJhdKSimy4F4Kl57OTxUkWt4/pqKcCMjuQjjhhgB+3BwZqh2AHY+u6jNfLMKkDz562tro0seieNACQC2M1pz88fAdxZi+C1SIEhyBQFiH0IJBtgB29ooD3RXaLQg1ZAGFCQtZDhpg0UNwy7JR40S7XcHDFl2XKMMTrAAthQcGlsdWfIi6wsBYgtYoyReABTZHQkKBBTASZj3gAj0EhMq6HusQLMQCreABs6UAUJClShAIM1fyjpNCAkKFCFAgzW/AGmo6yQoEAVCjBY8x5VR8vFm1X0H22suAKnp5e+K3PeI7CrkDyNkKBATAUsY77wUje8AXZ9pkMEkaBATAWYjPEAtidgxuw76oYCdMoqRwXvOXBW6eDly00sJWdq4LFUBaw/RPLp0yWnTt4ITDXT8a1IUCCGAgK2+ADT2cNIUCCGAgK2+ADbrSEx+o46oQAdys5VgT0HpgYGr1514JXGlRr5cxWw242Sjx+vcvPMucgfgakSOvUdCQqUqYCQKRnA3S4ALtN4qMu4QCkCHWQAn54CYIHYKJKjgJApEcBuqW8YkSWnR7gEBTwVsCxxlo8naxUBPKoAo/CkkngeooCYJQAcIjvKlqWAGGDRz2jUa+de+ddfHSwrl2XDFa2HttP/++9V5VMI16Bg6W9FzYTbXqSAZUgKL1UZMoUwRrD0t+g+8P6KKhDIUBjAxrBDAa2omXDbixUIYkgMsNtmT1F6kKBAiAIUjefwUMyh6Euca/D4eB3+ECGWQ9mxAhR2dW/vJjk8ZG8cZgMMeMey40mZCgghZgEMeMu0GOq6p4AAYm+AAe89ufFGDAWYEHsBDHhjWAp1LlSAAXEhwIB3ocy4EFMBT4hzAQa8MS2EugsV8IB4IcCAt1BeZKhCgQKI5wIMeKuwDNrwViAH4nsAA15vWZGxSgUWQDwFMOCt0iJoi63AHIjHAANetpwoUIcCMxA7gJ1z+s7OBnwb6rAI2mQrQBB/+HBNfsRDgP/8k7zK1tgVoQAUqE+Bu+Tz55+JO3nz7Gyjvn6gZSggVGB7+7phvn3D2W9C/VCsZgUsuw3TaLRq7gaahwIyBSy7DXxxk2mHUgoUsIciirdyKOg+ugAF7K5k+kkCCQosowKW3QZCpS6j5dBnp4ANydowT592IQcUWEoFLLtYyFhKy6HTVgG3kDH8End6eou5MKBYGgXoexsxa5MD2MWmsvvyAfHSmHB1O0rwUgwJ6wdBIoy90egFPNJIBSS1CmTwTgRAmQKYOg6I1ZpvtTs2B14S5B7A9CYgJhWQ1CiwAF7q31yA6QIgJhWQalcgB17q20KA6SIgJhWQalOgAF7qVy7AlAEQkwpIlSvgAS/1qRBgygSISQWkyhTwhJf64wUwZQTEpAJSdAUY8FJfvAGmzICYVECKpgATXuoHC2AqAIhJBaTSFRDAS31gA0yFADGpgFSaAkJ4qX0RwFQQEJMKSMEKBMBLbYsBpsLYkk8qIAUpYLfGJ0dH4qO2QvfENYM6j8JQwJgghsIAvrhANB8gGKZAIENigF08tYuLoE9P2J2j9INQwDLkWBLejBhgs7vbxEn1QtVR7H8F7FnfjqX/32E9kwNsDCL6sKRG5hwFxCwB4BxVcakyBaoF2M1Zrq4w/63Mvg+8IcuSdB4sG4FfvBB/Yh64KXB7UgWETMkAbrcBsNRQKDdfASFTMoARknW+EfCuXAEhU2yAnQ+EDWsp7ylKQoE5ClimHFtzLuW9xQfxyxdMH/IUxTW5AgK2+ACfnQFguYlQMk8BAVt8gFstAJxnBFyTKyBgiwWwc5+kpT8kKBBDAcuWY4xRNwtgc32N0ZchLrIKFGAyxgO41wPAApugCEMBJmPeALulvh8/ADDDFsgqUMAyxllW9gbYHBz45xX0G0WgwFgBBmv+UJ6d+ecd9wRPoIBAAQZr/lB2Oi4itqA7KAIFeAowWPMH+PVrnCfHMwNySxVgsMb6TXfw6lUHR9NKrYJyXgrYOBHJx49XXnltJv8RmGrc3MSZcr7KIp9MASZjvBF4MEjMzs4GRmGZbVCqQAGK0vPhw3V2AlFBbneZNQK7ip88+WlaLXyh81EXefwVIKYsWxx4qXLWCJz1xq1Xn58/MtgXl0mCxxAFOp2e2dq6lYSYEgFMfXWrJQcHa+b8vA2QQ6y3wmWH4HbN27d33JE3U00McFYBPTqYaVMe7WuirSHYsTEpD55nCtAc154wb7rd1B4Vm0qhzaqjx1IAnqyQnrutIeRdTw7K5OMJF8xZiVbjNc1r0zQ129upef48TSZO2CxLgCgAz3bOzZnJTY48jeAQNCvPw3r9+HFqms3UbGykkjktV4xKAJ7slJtuUFy1YWiqFubPk+os4XOaxxqTur+Tk14Z0wKOCpUDPNu5qflzv7+G6casQspe07Sg0bgrcx4bcoe1+/eOPrF39ibuBn//TffSDrkhlI2sgIU3+eefW9dKUvv4x1xKjqyN+1THbgP1hylAvyAoSqyVuOj9tj+tRG8DDYQpoMxGqgB204nhl4IwkVE6jgLWNlV/SSu6EVUAjzqLUbjIavVdV2cbAFwfDMvYsjqA6/8aOWPG0c9qmzNv46UGBU5PLzGFKDCEE4hWc5B0KWBtog1eEkjjFMIefWeXIpF0KaDUJjoBtuvouqyH3pBvg0YV1M2BM5EGL19uYlk5U6PmR7t8nHz6dFlzL+Y2r3MEpq6SGx6SDgUU20IvwORDiqRDAcW20AuwdYDWYT30gpzRtaqgdg5MgiGQigJsmIFGqu6x3hGYlKD9U0j1KqDcBroBVua6Vy9JNbWu3Aa6AVbmulcTQvU2q9wGqgF2S5dwr6wPYIXuk7Ni1L6laLZD915vbXXtxs9H994v8w3a5/XHHz37R1ubeub799/VxbagmAoU1ssutJuLizX714y+0EPaK0+qf4Ug7Ua7mNdL3708HNnpS2JqZnbTurgWx8fraiAmePf2bibjKkTf3U36nJzcaHTgmfxMqQfYQby/3zRfv64HjTjMqDBqIJ4D76QBs+dTu7tDoyPRf6Rnz26qiOuQ9V/6uBQA08254Cicf+1khMCoMLVD7AnvPOOLoyNRmxQl8uiI4j2oT0sDMCnpRpk3b9rm8rI99997hKgwtUEcAO886gqjI1F7FFz63buu9mnD5P0tFcCTHXdgvX/fsHPjxMbe6tsIh/1YwlcOccnwTupGz91AQEdZ0WlAdKCKPZNicn49m1/z66UFuGpRK4M4MrxV6xa7PQDMUDg6xICXYY1hVgDMlCwaxICXaQkALBKMCpUOMeAV2wIjsFC60iAGvEILDIsB4AD5giEGvAHqA+Bg8agCMcSAtxT9MQKXICMbYsBbgurDKgBwSVKOfBHIa26toMo7e0LPbaxFl4K2H9xl1f7Ay6Q2AZl8/vzTrgpe2+PGuoZG2SzRc3rPXqM8gDcTJvzxP/fy1fRkMDf/AAAAAElFTkSuQmCC"

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox-item",
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "app-content"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(301)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.appName))]), _vm._v(" "), (_vm.notMatch) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("请选择版本")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toDownload(1)
      }
    }
  }, [_vm._v("安卓版")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toDownload(2)
      }
    }
  }, [_vm._v("苹果版")])], 1) : _vm._e()]), _vm._v(" "), (_vm.isWeiXin) ? _c('div', {
    staticClass: "poper"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": __webpack_require__(300)
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-switch weui-cell weui-cell_switch"
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('label', {
    staticClass: "weui-label",
    class: _vm.labelClass,
    style: (_vm.labelStyle),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui-switch",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, null) > -1 : (_vm.currentValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.currentValue = $$c
        }
      }
    }
  }), _vm._v(" "), (_vm.preventDefault) ? _c('div', {
    staticClass: "vux-x-switch-overlay",
    on: {
      "click": _vm.onClick
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('x-header', {
    staticClass: "header-define",
    attrs: {
      "title": "风险测评",
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.$_evaluation_back
    },
    slot: "left"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "evaluation"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "evaluation-main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stepCurrent),
      expression: "stepCurrent"
    }],
    staticClass: "propress-line"
  }, [_c('my-step', {
    attrs: {
      "step": _vm.stepCurrent,
      "totalstep": _vm.stepTotal
    }
  })], 1), _vm._v(" "), _c('card', {
    staticStyle: {
      "position": "absolute",
      "left": "0",
      "top": "45px",
      "right": "0",
      "bottom": "70px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "card-padding",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "height": "1px",
      "background-color": "#ebecf5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "evaluation-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.params.userName))]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v("测评时间：" + _vm._s(_vm.time))])]), _vm._v(" "), _c('div', {
    staticClass: "tip-info"
  }, [_vm._v("\n            " + _vm._s(_vm.question.questionHead) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "evaluation-btn"
  }, [_c('submit-button', {
    on: {
      "click": _vm.$_evaluation_test
    }
  }, [_vm._v("开始测评")])], 1)])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t\t双录：\n\t\t")]), _vm._v("\n\t\t双录根据产品配置确定是否需要双录，若需要参照双录说明\n\t\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(901),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep1,
      "total_step": "01"
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1), _vm._v(" "), _c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t\t风险揭示书签署：\n\t\t")]), _vm._v("\n\t\t投资者需要对风险揭示书查看阅读并进行投资者声明确认，确认后进行签名、签章。\n\t\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(903),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(904),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(900),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "03"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message1))])], 1), _vm._v(" "), _c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t\t合同文件签署：\n\t\t")]), _vm._v("\n\t\t投资者签署完风险揭示可直接签署合同文件，查看阅读合同文件，并进行签字、签章。\n\t\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(902),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep1,
      "total_step": "01"
    }
  }, [_vm._v(_vm._s(_vm.message2))])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v(" 合同签署包含：双录、风险揭示书签署、合同文件签署\n\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })])
}]}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "product-main"
  }, [_c('group', {
    attrs: {
      "title": "管理人基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managerName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "管理人名称",
      "placeholder": "请输入管理人名称",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.managerName),
      callback: function($$v) {
        _vm.$set(_vm.data, "managerName", $$v)
      },
      expression: "data.managerName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "机构类型",
      "placeholder": "请输入机构类型",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgType),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgType", $$v)
      },
      expression: "data.orgType"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "orgCertificateType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "text-align": "right",
      "placeholder": "请输入证件类型",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgCertificateType),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgCertificateType", $$v)
      },
      expression: "data.orgCertificateType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgCertificateNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件编号",
      "placeholder": "请输入证件编号",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgCertificateNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgCertificateNo", $$v)
      },
      expression: "data.orgCertificateNo"
    }
  }), _vm._v(" "), _c('popup-radio', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "text-align": _vm.type === 0 ? 'right' : '',
      "title": "证件有效期",
      "options": ['永久有效', '存在有效期']
    },
    model: {
      value: (_vm.localValidity),
      callback: function($$v) {
        _vm.localValidity = $$v
      },
      expression: "localValidity"
    }
  }), _vm._v(" "), (_vm.localValidity === '存在有效期') ? _c('datetime', {
    ref: "orgValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效期",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "readonly": _vm.type === 0
    },
    model: {
      value: (_vm.data.orgValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgValidity", $$v)
      },
      expression: "data.orgValidity"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "orgQualificationProve",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "资质证明",
      "placeholder": "请输入机构资质证明名称,若无则填\"无\"",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": "",
      "max": 20
    },
    model: {
      value: (_vm.data.orgQualificationProve),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgQualificationProve", $$v)
      },
      expression: "data.orgQualificationProve"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgQualificationNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证书编号",
      "placeholder": "请输入证书编号,若无则填\"无\"",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgQualificationNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgQualificationNo", $$v)
      },
      expression: "data.orgQualificationNo"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgBusinessScope",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "经营范围",
      "placeholder": "请输入经营范围",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgBusinessScope),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgBusinessScope", $$v)
      },
      expression: "data.orgBusinessScope"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgRegisterAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "注册地址",
      "placeholder": "请输入注册地址",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgRegisterAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgRegisterAddress", $$v)
      },
      expression: "data.orgRegisterAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgOfficeAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公地址",
      "placeholder": "请输入办公地址",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgOfficeAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgOfficeAddress", $$v)
      },
      expression: "data.orgOfficeAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgRegisterCapital",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "注册资本",
      "placeholder": "请输入注册资本（万元）",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgRegisterCapital),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgRegisterCapital", $$v)
      },
      expression: "data.orgRegisterCapital"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgController",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "股东或实际控股人",
      "placeholder": "请输入股东或实际控股人",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgController),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgController", $$v)
      },
      expression: "data.orgController"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_product_auth
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('cell', {
    attrs: {
      "title": _vm.title,
      "value": _vm.currentValue,
      "is-link": !_vm.readonly,
      "value-align": _vm.valueAlign,
      "border-intent": _vm.borderIntent
    },
    nativeOn: {
      "click": function($event) {
        return _vm.show($event)
      }
    }
  }, [(!_vm.displayValue && _vm.placeholder) ? _c('span', {
    staticClass: "vux-cell-placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), (_vm.displayValue) ? _c('span', {
    staticClass: "vux-cell-value"
  }, [_vm._v(_vm._s(_vm.displayValue))]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    staticStyle: {
      "background-color": "#fff"
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showPopup),
      callback: function($$v) {
        _vm.showPopup = $$v
      },
      expression: "showPopup"
    }
  }, [_vm._t("popup-header", null, {
    options: _vm.options,
    value: _vm.currentValue
  }), _vm._v(" "), _c('radio', {
    attrs: {
      "options": _vm.options,
      "fill-mode": false
    },
    on: {
      "on-change": _vm.onValueChange
    },
    scopedSlots: _vm._u([{
      key: "each-item",
      fn: function(props) {
        return [_vm._t("each-item", [_c('p', [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.icon),
            expression: "props.icon"
          }],
          staticClass: "vux-radio-icon",
          attrs: {
            "src": props.icon
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "vux-radio-label"
        }, [_vm._v(_vm._s(props.label))])])], {
          icon: props.icon,
          label: props.label,
          index: props.index
        })]
      }
    }]),
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(71),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      自然人投资者中的本机构从业人员需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n        1、身份证正反面照片（或扫描件）；\n        "), _c('br'), _vm._v("\n        2、在职证明，或者社保证明，或者劳动合同扫描件；\n        "), _c('br'), _vm._v("\n        3、投资者基本信息表（自然人）相关信息；\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": __webpack_require__(72),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
}]}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t风险承受力测评\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者根据实际情况对风险承受能力进行测评\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t数字证书申请表上传\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者上传签署盖章的数字证书申请表\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])])])
}]}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-panel weui-panel_access"
  }, [(_vm.header && _vm.header.title) ? _c('div', {
    staticClass: "weui-panel__hd",
    domProps: {
      "innerHTML": _vm._s(_vm.header.title)
    },
    on: {
      "click": function($event) {
        _vm.$emit('on-click-header')
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('div', {
    staticClass: "weui-panel__bd"
  }, [_c('div', {
    staticClass: "vux-card-content"
  }, [_vm._t("content")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "weui-panel__ft"
  }, [(_vm.footer && _vm.footer.title) ? _c('a', {
    staticClass: "weui-cell weui-cell_access weui-cell_link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.onClickFooter
    }
  }, [_c('div', {
    staticClass: "weui-cell__bd",
    domProps: {
      "innerHTML": _vm._s(_vm.footer.title)
    }
  })]) : _vm._e()]), _vm._v(" "), _vm._t("footer")], 2)
},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cells_radio",
    class: _vm.disabled ? 'vux-radio-disabled' : ''
  }, [_vm._l((_vm.options), function(one, index) {
    return _c('label', {
      staticClass: "weui-cell weui-cell_radio weui-check__label",
      attrs: {
        "for": ("radio_" + _vm.uuid + "_" + index)
      }
    }, [_c('div', {
      staticClass: "weui-cell__bd"
    }, [_vm._t("each-item", [_c('p', [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (one && one.icon),
        expression: "one && one.icon"
      }],
      staticClass: "vux-radio-icon",
      attrs: {
        "src": one.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "vux-radio-label",
      style: (_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')
    }, [_vm._v(_vm._s(_vm._f("getValue")(one)))])])], {
      icon: one.icon,
      label: _vm.getValue(one),
      index: index,
      selected: _vm.currentValue === _vm.getKey(one)
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "weui-cell__ft"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentValue),
        expression: "currentValue"
      }],
      staticClass: "weui-check",
      attrs: {
        "type": "radio",
        "id": _vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)
      },
      domProps: {
        "value": _vm.getKey(one),
        "checked": _vm._q(_vm.currentValue, _vm.getKey(one))
      },
      on: {
        "change": function($event) {
          _vm.currentValue = _vm.getKey(one)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "weui-icon-checked"
    })])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fillMode),
      expression: "fillMode"
    }],
    staticClass: "weui-cell"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.fillLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fillValue),
      expression: "fillValue"
    }],
    staticClass: "weui-input needsclick",
    attrs: {
      "type": "text",
      "placeholder": _vm.fillPlaceholder
    },
    domProps: {
      "value": (_vm.fillValue)
    },
    on: {
      "blur": function($event) {
        _vm.isFocus = false
      },
      "focus": function($event) {
        _vm.onFocus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fillValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value === '' && !_vm.isFocus),
      expression: "value==='' && !isFocus"
    }],
    staticClass: "weui-cell__ft"
  }, [_c('i', {
    staticClass: "weui-icon-warn"
  })])])], 2)
},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepper-fixed"
  }, [(_vm.leftDisable() == false) ? _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (Number(this.total_step) !== 1),
      expression: "Number(this.total_step) !== 1"
    }],
    staticClass: "left-button",
    on: {
      "click": _vm.leftCheckEvent
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(918),
      "width": "20px",
      "height": "14px"
    }
  })])]) : _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (Number(this.total_step) !== 1),
      expression: "Number(this.total_step) !== 1"
    }],
    staticClass: "left-button",
    on: {
      "click": _vm.leftCheckEvent
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(919),
      "width": "20px",
      "height": "14px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pageNum"
  }, [_c('div', {
    staticClass: "current-step"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.current_step) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "total-step"
  }, [_vm._v("\n\t\t\t/ " + _vm._s(_vm.total_step) + "\n\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "stepper-text"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.rightDisable() == false) ? _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (Number(this.total_step) !== 1),
      expression: "Number(this.total_step) !== 1"
    }],
    staticClass: "left-button",
    on: {
      "click": _vm.rightCheckEvent
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(925),
      "width": "20px",
      "height": "14px"
    }
  })])]) : _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (Number(this.total_step) !== 1),
      expression: "Number(this.total_step) !== 1"
    }],
    staticClass: "left-button",
    on: {
      "click": _vm.rightCheckEvent
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(926),
      "width": "20px",
      "height": "14px"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    staticClass: "agency-main",
    staticStyle: {
      "padding-bottom": "70px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasResp && _vm.baseInfo.stepCurrent),
      expression: "hasResp && baseInfo.stepCurrent"
    }],
    staticClass: "propress-line",
    staticStyle: {
      "padding": "32px 0",
      "background": "#fff"
    }
  }, [_c('my-step', {
    attrs: {
      "step": _vm.baseInfo.stepCurrent,
      "totalstep": _vm.baseInfo.stepTotal
    }
  })], 1), _vm._v(" "), _c('div', [_c('group', {
    attrs: {
      "title": "投资者基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "orgName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "机构名称",
      "placeholder": "请输入机构名称",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgName),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgName", $$v)
      },
      expression: "propData.orgName"
    }
  }), _vm._v(" "), _c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "机构类型",
      "options": [],
      "placeholder": "请选择机构类型",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.orgType),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgType", $$v)
      },
      expression: "propData.orgType"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "证件类型",
      "options": [],
      "placeholder": "请选择证件类型",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.orgDocumentsType),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgDocumentsType", $$v)
      },
      expression: "propData.orgDocumentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgDocumentsNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件编号",
      "placeholder": "请输入证件编号",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgDocumentsNo),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgDocumentsNo", $$v)
      },
      expression: "propData.orgDocumentsNo"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效期",
      "max": 10,
      "keyboard": "number",
      "placeholder": "请输入有效期,如:2018-01-01",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.orgDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgDocumentsValidity", $$v)
      },
      expression: "propData.orgDocumentsValidity"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgQualificationProve",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "资质证书",
      "placeholder": "请输入资质证书",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgQualificationProve),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgQualificationProve", $$v)
      },
      expression: "propData.orgQualificationProve"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgQualificationNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证书编号",
      "keyboard": "number",
      "placeholder": "请输入证书编号",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgQualificationNo),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgQualificationNo", $$v)
      },
      expression: "propData.orgQualificationNo"
    }
  }), _vm._v(" "), _c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "经营范围",
      "options": [],
      "placeholder": "请选择经营范围",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.orgBusinessScope),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgBusinessScope", $$v)
      },
      expression: "propData.orgBusinessScope"
    }
  }), _vm._v(" "), _c('x-textarea', {
    ref: "orgRegisterAddress",
    attrs: {
      "title": "注册地址",
      "autosize": "",
      "placeholder": "请输入办公地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgRegisterAddress),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgRegisterAddress", $$v)
      },
      expression: "propData.orgRegisterAddress"
    }
  }), _vm._v(" "), _c('x-textarea', {
    ref: "orgAddress",
    attrs: {
      "title": "办公地址",
      "autosize": "",
      "placeholder": "请输入办公地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgAddress),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgAddress", $$v)
      },
      expression: "propData.orgAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgRegisteredCapital",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "注册资本",
      "placeholder": "请输入注册资本（万元）",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgRegisteredCapital),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgRegisteredCapital", $$v)
      },
      expression: "propData.orgRegisteredCapital"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgController",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "股东或实际控股人",
      "placeholder": "请输入股东或实际控股人",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgController),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgController", $$v)
      },
      expression: "propData.orgController"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('group', {
    attrs: {
      "title": "法定代表人或负责人",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativeName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "placeholder": "请输入姓名",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeName),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeName", $$v)
      },
      expression: "twoData.representativeName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeDocumentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "value": _vm.iDCardTypesLabel(_vm.twoData.representativeDocumentsType),
      "placeholder": "请输入证件类型",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeIdCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "placeholder": "请输入证件号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeIdCardNo),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeIdCardNo", $$v)
      },
      expression: "twoData.representativeIdCardNo"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效期",
      "max": 10,
      "keyboard": "number",
      "placeholder": "请输入有效期,如:2018-01-01",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeDocumentsValidity", $$v)
      },
      expression: "twoData.representativeDocumentsValidity"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [(_vm.isForeign(_vm.propData.representativeDocumentsType)) ? _c('x-input', {
    ref: "legalCountry",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "国籍",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.propData.legalCountry),
      callback: function($$v) {
        _vm.$set(_vm.propData, "legalCountry", $$v)
      },
      expression: "propData.legalCountry"
    }
  }) : _vm._e(), _vm._v(" "), _c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0, 0.3)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.twoData.representativeSex),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeSex", $$v)
      },
      expression: "twoData.representativeSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeAge),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeAge", $$v)
      },
      expression: "twoData.representativeAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativePosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativePosition),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativePosition", $$v)
      },
      expression: "twoData.representativePosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeLanline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "placeholder": "格式：区号+座机号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeLanline),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeLanline", $$v)
      },
      expression: "twoData.representativeLanline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "placeholder": "请输入手机号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeMobile),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeMobile", $$v)
      },
      expression: "twoData.representativeMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeEmail),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeEmail", $$v)
      },
      expression: "twoData.representativeEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativeZip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公邮编",
      "max": 6,
      "type": "number",
      "placeholder": "请输入办公邮编",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeZip),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeZip", $$v)
      },
      expression: "twoData.representativeZip"
    }
  }), _vm._v(" "), _c('x-textarea', {
    ref: "representativeAddress",
    attrs: {
      "title": "办公地址",
      "autosize": "",
      "placeholder": "请输入办公地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeAddress),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeAddress", $$v)
      },
      expression: "twoData.representativeAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('group', {
    attrs: {
      "title": "指定授权经办人",
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "placeholder": "请输入姓名",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersName),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersName", $$v)
      },
      expression: "threeData.managersName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersDocumentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "text-align": "right",
      "placeholder": "请输入证件类型",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersDocumentsType),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersDocumentsType", $$v)
      },
      expression: "threeData.managersDocumentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersIdCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "placeholder": "请输入证件号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersIdCardNo),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersIdCardNo", $$v)
      },
      expression: "threeData.managersIdCardNo"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效期",
      "max": 10,
      "keyboard": "number",
      "placeholder": "请输入有效期,如:2018-01-01",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersDocumentsValidity", $$v)
      },
      expression: "threeData.managersDocumentsValidity"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0, 0.3)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.threeData.managersSex),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersSex", $$v)
      },
      expression: "threeData.managersSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersAge),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersAge", $$v)
      },
      expression: "threeData.managersAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersPosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersPosition),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersPosition", $$v)
      },
      expression: "threeData.managersPosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersLanline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "placeholder": "格式：区号+座机号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersLanline),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersLanline", $$v)
      },
      expression: "threeData.managersLanline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "placeholder": "请输入手机号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersMobile),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersMobile", $$v)
      },
      expression: "threeData.managersMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersEmail),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersEmail", $$v)
      },
      expression: "threeData.managersEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersZip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公邮编",
      "max": 6,
      "type": "number",
      "placeholder": "请输入办公邮编",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersZip),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersZip", $$v)
      },
      expression: "threeData.managersZip"
    }
  }), _vm._v(" "), _c('x-textarea', {
    ref: "managersAddress",
    attrs: {
      "title": "办公地址",
      "autosize": "",
      "placeholder": "请输入办公地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersAddress),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersAddress", $$v)
      },
      expression: "threeData.managersAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "relationshipWithOrg",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "与该机构关系",
      "placeholder": "请输入与该机构关系",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.relationshipWithOrg),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "relationshipWithOrg", $$v)
      },
      expression: "threeData.relationshipWithOrg"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-con"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isFund ? '一、私募基金投资者，最近20个交易日金融资产均不得低于人民币300万元，或者最近3年个人年均收入不低于人民币50万元' :
    '一、资产管理计划投资者，具有2年以上投资经历，且满足以下条件之一：家庭金融净资产不低于300万元，家庭金融资产不低于500万元，或者近3年本人年均收入不低于40万元') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.question.orgAssetsScale.checked))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("二、是否为下列机构")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px"
    }
  }, [_vm._v("\n          符合《证券期货投资者适当性管理办法》第八章第（一）款所规定的证券公司、期货公司、基金管理公司及其子公司、商业银行、保险公司、信托公司、财务公司；\n          或在中国证券投资基金业协会登记或者备案的证券公司子公司、期货公司子公司、私募基金管理人；或者第（三）款所规定的合格境外机构投资者（QFII），人名币合格境外机构投资者（RQFII）\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.question.isProfessionalInvestors.checked))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("三、是否存在实际控制关系？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.question.isControllingShareholder.checked))]), _vm._v(" "), (_vm.question.isControllingShareholder.checked === '是') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.question.isControllingShareholder.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("四、交易实际受益人？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.question.transactionActualBeneficiary.checked))]), _vm._v(" "), (_vm.question.transactionActualBeneficiary.checked === '其他机构或个人') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.question.transactionActualBeneficiary.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("五、是否有不良诚信记录？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.question.isBadFaith.checked))]), _vm._v(" "), (_vm.question.isBadFaith.checked === '是') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.question.isBadFaith.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "notice-text"
  }, [_vm._v("\n        以上资料为您的理财师在特定对象确认程序时向您获取并上传至系统用于适当性管理留痕，经您本人在线确认视为您对该材料真实、完整、准确、有效性的认可。若以上资料与您实际资料不符，请您联系理财师进行修改，确保您提供给理财师的资料真实、有效、准确、完整，并对您提供的资料承担责任。\n      ")])]), _vm._v(" "), (_vm.baseInfo.isShowBtn) ? _c('submit-button', {
    on: {
      "click": _vm.$_agency_submit
    }
  }, [_vm._v("确认")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(71),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      机构的专业投资者中的本机构需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n        1、营业执照扫描件、组织机构代码证扫描件、税务登记证扫描件（三证合一机构提供营业执照扫描件即可）；\n        "), _c('br'), _vm._v("\n        2、开户许可证扫描件；\n        "), _c('br'), _vm._v("\n        3、开展金融业务相关资格证明；\n        "), _c('br'), _vm._v("\n        4、法定代表人身份证正反面扫描件；\n        "), _c('br'), _vm._v("\n        5、经办人身份证正反面扫描件；\n        "), _c('br'), _vm._v("\n        6、投资者基本信息表（机构）相关信息；\n        "), _c('br'), _vm._v("\n        7、经办人授权函\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": __webpack_require__(72),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
}]}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t预约审核中\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t\t投资者发起预约申请订单，等待管理人后台审核阶段，投资者可以“取消订单”和“查看订单详情”\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t待托管人审核\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t\tUKEY模式下，等待托管人对合同进行确认签署，投资者可以“查看订单详情”\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t待合同签署\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t\t投资者在待合同签署阶段，需要对订单进行双录（若配置）、风险揭示书签署、合同文件签署\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t待理财师签署\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t\t私募基金管理人配置了理财师需要签署风险揭示书，等待理财师对风险揭示书签署，投资者可以“上传打款资料”或者“查看订单详情”\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t签约成功\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t\t三方协议签署成功，投资者可以“查看订单详情”\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t合同信息审核失败\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t\t管理人预约审核未通过，投资者可以\"查看订单详情\"\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t订单已取消\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t\t管理人预约审核未通过，投资者可以\"查看订单详情\"\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t补充协议确认\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t\t投资者购买的产品订单有新的补充协议的情况下，投资者需要签署补充协议（签署补充协议、征询意见函）\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t确认中\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t\t管理人上传生效告知函、托管人确认生效告知函阶段，补充协议状态显示为“确认中”，投资者可查看订单详情\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t公告告知函有效\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t\t投资者购买的产品订单有新的公告告知，①管理人首页强提示公告信息，投资者需要确认知晓。②订单列表可“查看公告”。\n\t\t\t\t")])])])])
}]}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: [_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']
  })
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation com-mar-btm"
  }, [_c('x-header', {
    staticClass: "header-define",
    attrs: {
      "title": _vm.title,
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    },
    slot: "left"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "evaluation-main"
  }, [_c('div', {
    staticClass: "page-index"
  }, [_c('div', {
    staticClass: "result-item"
  }, [_c('p', {
    staticClass: "res-one"
  }, [_vm._v("\n          " + _vm._s(_vm.params.result) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "res-two",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n          您本次风险测评问卷为C1\n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "8px",
      "background": "#F5F5F5",
      "margin": "0 -20px"
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('choose-button', [_c('template', {
    slot: "left"
  }, [_c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.$_evaluation_confirm(0)
      }
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('template', {
    slot: "right"
  }, [_c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.$_evaluation_confirm(1)
      }
    }
  }, [_vm._v("是")])], 1)], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "production-item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#222222",
      "margin-bottom": "10px"
    }
  }, [_vm._v("需确认您是否为最低风险承受能力的投资者（符合下列条件之一）")]), _vm._v(" "), _c('div', [_vm._v("1、不具有完全民事行为能力；")]), _vm._v(" "), _c('div', [_vm._v("2、没有风险容忍度或者不愿承受任何投资损失；")]), _vm._v(" "), _c('div', [_vm._v("3、法律、行政法规规定的其他情形")])])
}]}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t风险承受力测评\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者根据实际情况对风险承受能力进行测评\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])])])
}]}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "product-main"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("一、是否为下列机构")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px"
    }
  }, [_vm._v("\n          为《证券期货投资者适当性管理办法》第八条第（一）款机构面向投资者发行的证券公司资产管理产品、基金管理公司及其子公司产品、期货公司资产管理产品、银行理财产品、保险产品、信托产品、经行业协会备案的私募基金，及第（一）款规定机构发行的其它理财产品；\n          或者为第（三）款规定的社会保障基金、企业年金等养老基金、慈善基金等社会公益基金\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isFollowProduct.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isFollowProduct, "checked", $$v)
      },
      expression: "data.isFollowProduct.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": "",
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": "",
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isFund ? '二、私募基金投资者，最近三个月月末资产均超过（含）人民币1000万元' :
    '二、资产管理计划投资者，为最近 1 年末净资产不低于 1000 万元的法人单位') + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.orgAssetSize.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.orgAssetSize, "checked", $$v)
      },
      expression: "data.orgAssetSize.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("三、是否存在实际控制关系？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isControllingShareholder.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "checked", $$v)
      },
      expression: "data.isControllingShareholder.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isControllingShareholder.checked === '是'),
      expression: "data.isControllingShareholder.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isControllingShareholder.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "description", $$v)
      },
      expression: "data.isControllingShareholder.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("四、交易实际受益人？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "checked", $$v)
      },
      expression: "data.transactionActualBeneficiary.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "本机构"
    }
  }, [_c('my-check-style', [_vm._v("本机构")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "其他机构或个人"
    }
  }, [_c('my-check-style', [_vm._v("其他机构或个人")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.transactionActualBeneficiary.checked === '其他机构或个人'),
      expression: "data.transactionActualBeneficiary.checked === '其他机构或个人'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.description),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "description", $$v)
      },
      expression: "data.transactionActualBeneficiary.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("五、是否有不良诚信记录？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isBadFaith.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "checked", $$v)
      },
      expression: "data.isBadFaith.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isBadFaith.checked === '是'),
      expression: "data.isBadFaith.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isBadFaith.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "description", $$v)
      },
      expression: "data.isBadFaith.description"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('submit-button', {
    attrs: {
      "disabled": _vm.type === 0
    },
    on: {
      "click": _vm.$_product_submit
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(71),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 0 0 0",
      "overflow": "hidden"
    },
    style: ({
      height: _vm.isExpand ? '' : '25px'
    })
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "absolute",
      "bottom": "-25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    style: ({
      transform: _vm.isExpand ? '' : 'rotate(180deg)'
    }),
    attrs: {
      "src": __webpack_require__(202),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isExpand = !_vm.isExpand
      }
    }
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      机构投资者中的专业投资者需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n        1、营业执照扫描件、组织机构代码证扫描件、税务登记证扫描件（三证合一机构提供营业执照扫描件即可）；\n        "), _c('br'), _vm._v("\n        2、开户许可证扫描件；\n        "), _c('br'), _vm._v("\n        3、法定代表人身份证正反面扫描件；\n        "), _c('br'), _vm._v("\n        4、经办人身份证正反面扫描件；\n        "), _c('br'), _vm._v("\n        5、最近 1 年末不低于 2000 万元的净资产证明；\n        "), _c('br'), _vm._v("\n        6、最近 1 年末不低于 1000 万元的金融资产*证明；\n        "), _c('br'), _vm._v("\n        7、2 年以上证券、基金、期货、黄金、外汇等的投资经历证明；\n        "), _c('br'), _vm._v("\n        8、投资者基本信息表（机构）相关信息；\n        "), _c('br'), _vm._v("\n        9、经办人授权函\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n          金融资产证明文件可以参考以下证明: "), _c('br'), _vm._v("\n          ①银行存款，银行出具的存款证明；  "), _c('br'), _vm._v("\n          ②股票，证券账户内股票市值；"), _c('br'), _vm._v("\n          ③债券，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ④基金份额，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ⑤资产管理计划，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ⑥银行理财产品，银行出具的资产证明；"), _c('br'), _vm._v("\n          ⑦信托计划，购买合同；"), _c('br'), _vm._v("\n          ⑧保险产品，购买合同；"), _c('br'), _vm._v("\n          ⑨期货，申请日前一交易日客户权益；"), _c('br'), _vm._v("\n          ⑩其他衍生品，购买凭证；"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": __webpack_require__(72),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("\n\t\t\t情况一：添加投资者时，投资者信息表问卷第二题选择“是”特定对象确认流程如下：\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码\n\t\t\t\t"), _c('br'), _vm._v("四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.数字证书申请表上传\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者上传签署盖章的数字证书申请表\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t风险测评完成后，特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("\n\t\t\t情况二：添加投资者时，投资者信息表问卷第二题选择“否”特定对象确认流程如下：\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码\n\t\t\t\t"), _c('br'), _vm._v("四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.投资者信息确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.数字证书申请表上传\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者上传签署盖章的数字证书申请表\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t风险测评完成后，特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])])])
}]}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    class: {
      'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask",
    style: (_vm.maskStyle),
    on: {
      "click": _vm.hide
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.dialogClass,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation com-mar-btm"
  }, [_c('x-header', {
    staticClass: "header-define",
    attrs: {
      "title": _vm.title,
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    },
    slot: "left"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#222222"
    },
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.$_view_quesDetail
    },
    slot: "right"
  }, [_vm._v("问卷明细")])]), _vm._v(" "), _c('div', {
    staticClass: "evaluation-main"
  }, [_c('div', {
    staticClass: "page-index"
  }, [_c('div', {
    staticClass: "result-item"
  }, [_c('p', {
    staticClass: "res-one"
  }, [_vm._v("\n          " + _vm._s(_vm.params.result) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "com-again-test",
    on: {
      "click": _vm.$_evaluation_again
    }
  }, [_vm._v("\n          重新测评\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "res-two"
  }, [_vm._v("\n          您适合购买的产品风险等级为"), _c('span', [_vm._v(_vm._s(_vm.level))]), _vm._v("的基金\n        ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.params.specialObj) ? _c('table-list', {
    attrs: {
      "baseInfo": _vm.params
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('submit-button', {
    attrs: {
      "invester-type": _vm.params.sysCode
    },
    on: {
      "click": _vm.$_evaluation_checkSubmit
    }
  }, [_vm._v("提 交")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "production-item"
  }, [_c('h4', [_vm._v("重要声明")]), _vm._v(" "), _c('p', [_vm._v("\n          您的风险承受能力评估结果是根据您填写的《风险测评问卷》以及其他相关信息综合评估得出，旨在协助您选择合适的产品或服务类别，并不能取代您自己的投资判断，也不会降低产品或服务的固有风险。建议您在产品购买过程中结合自身投资行为，并做出审慎的投资判断。\n        ")])])
}]}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-checker-box"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("一、是否满足下列条件")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px 0"
    }
  }, [_vm._v("\n          （1）金融资产不低于500万元人民币，或者最近3年个人年均收入不低于50万元人民币；\n          （2）具有2年以上证券、基金、期货、黄金、外汇等投资经历，或 者具有2年以上金融产品设计、投资、风险管理及相关工作经 历的自然人投资者，或者属于《证券提货投资者适当性管理 办法》第八条第(一)款所规定的专业投资者的高级管理人 员、获得职业资格认证的从事金融相关业务的注册会计师和 律师。\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "disabled": "",
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.userInvestmentExperience.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.userInvestmentExperience, "checked", $$v)
      },
      expression: "data.userInvestmentExperience.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0 || _vm.invenstemType !== 'SPECIFIC_PERSONAL_PRACTITIONERS',
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0 || _vm.invenstemType !== 'SPECIFIC_PERSONAL_PRACTITIONERS',
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("二、私募基金或者资产管理计划投资者，最近20个交易日金融资产均不得低于人民币300万元，或者最近三年个人年均收入不 低于人民币50万元")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.userAssetsScale.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.userAssetsScale, "checked", $$v)
      },
      expression: "data.userAssetsScale.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("三、是否存在实际控制关系？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isControllingShareholder.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "checked", $$v)
      },
      expression: "data.isControllingShareholder.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isControllingShareholder.checked === '是'),
      expression: "data.isControllingShareholder.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isControllingShareholder.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "description", $$v)
      },
      expression: "data.isControllingShareholder.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("四、交易实际受益人？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "checked", $$v)
      },
      expression: "data.transactionActualBeneficiary.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "本人"
    }
  }, [_c('my-check-style', [_vm._v("本人")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "他人"
    }
  }, [_c('my-check-style', [_vm._v("他人")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.transactionActualBeneficiary.checked === '他人'),
      expression: "data.transactionActualBeneficiary.checked === '他人'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.description),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "description", $$v)
      },
      expression: "data.transactionActualBeneficiary.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("五、是否有不良诚信记录？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isBadFaith.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "checked", $$v)
      },
      expression: "data.isBadFaith.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isBadFaith.checked === '是'),
      expression: "data.isBadFaith.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isBadFaith.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "description", $$v)
      },
      expression: "data.isBadFaith.description"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_personal_submit
    }
  }, [_vm._v("提 交")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("\n\t\t\t情况一：添加投资者时，投资者信息表问卷第二题选择“是”特定对象确认流程如下：\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码\n\t\t\t\t"), _c('br'), _vm._v("四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t风险测评完成后，特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("\n\t\t\t情况二：添加投资者时，投资者信息表问卷第二题选择“否”特定对象确认流程如下：\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码\n\t\t\t\t"), _c('br'), _vm._v("四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.投资者信息确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t风险测评完成后，特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])])])
}]}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-header"
  }, [_c('div', {
    staticClass: "vux-header-left"
  }, [_vm._t("overwrite-left", [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._leftOptions.showBack),
      expression: "_leftOptions.showBack"
    }],
    staticClass: "vux-header-back",
    on: {
      "click": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "preventDefault", undefined, $event.key, undefined)) { return null; }
      }, _vm.onClickBack]
    }
  }, [_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._leftOptions.showBack),
      expression: "_leftOptions.showBack"
    }],
    staticClass: "left-arrow",
    on: {
      "click": _vm.onClickBack
    }
  })])]), _vm._v(" "), _vm._t("left")], 2), _vm._v(" "), (!_vm.shouldOverWriteTitle) ? _c('h1', {
    staticClass: "vux-header-title",
    on: {
      "click": function($event) {
        _vm.$emit('on-click-title')
      }
    }
  }, [_vm._t("default", [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title),
      expression: "title"
    }]
  }, [_vm._v(_vm._s(_vm.title))])])])], 2) : _vm._e(), _vm._v(" "), (_vm.shouldOverWriteTitle) ? _c('div', {
    staticClass: "vux-header-title-area"
  }, [_vm._t("overwrite-title")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vux-header-right"
  }, [(_vm.rightOptions.showMore) ? _c('a', {
    staticClass: "vux-header-more",
    on: {
      "click": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "preventDefault", undefined, $event.key, undefined)) { return null; }
      }, function($event) {
        _vm.$emit('on-click-more')
      }]
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("right")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list.length) ? _c('div', {
    staticClass: "table-list"
  }, [_c('div', {
    staticClass: "split-area"
  }), _vm._v(" "), _c('h4', [_vm._v("风险不匹配产品订单")]), _vm._v(" "), (_vm.list.length) ? _c('div', {
    staticClass: "table-view"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-item",
      on: {
        "click": function($event) {
          _vm.orderDetail(item.orderId)
        }
      }
    }, [_c('div', {
      staticClass: "list-left",
      staticStyle: {
        "flex": "1"
      }
    }, [_c('div', {
      staticClass: "list-left-name"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "list-left-state"
    }, [_vm._v(_vm._s(_vm.$util.formatOrderState(item.state)))])]), _vm._v(" "), _c('div', {
      staticClass: "list-right"
    }, [_c('span', {
      staticClass: "list-right-risk"
    }, [_vm._v(_vm._s(item.newProductRisk))]), _vm._v(" "), _c('span', {
      staticClass: "list-right-look"
    }, [_c('svg', {
      staticClass: "vux-x-icon vux-x-icon-ios-arrow-right arrow-right",
      staticStyle: {
        "margin-top": "12px"
      },
      attrs: {
        "type": "ios-arrow-right",
        "size": "24",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "d": "M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"
      }
    })])])])])
  })) : _c('div', {
    staticClass: "no-data"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("暂无数据")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(909)
    }
  })])
}]}

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t投资者特定对象确认，第一步需要投资者做身份认证。投资者需要填写真实的四要输包括姓名、身份证号码、银行卡号、银行预留手机号码、短信验证码（机构填写经办人姓名、经办人身份证号、对公银行账户、银行预留手机号码、短信验证码）\n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(899),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "01"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v("四要素认证")])], 1), _vm._v("\n\t若四要素没通过，需要进行人脸识别，相关信息发送到基金管理人后台审核\n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(898),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "01"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v("人脸识别")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-selector weui-cell",
    class: {
      'weui-cell_select': !_vm.readonly,
      'weui-cell_select-after': _vm.title
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label",
    class: _vm.labelClass,
    style: (_vm.cleanStyle({
      width: _vm.$parent.labelWidth,
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    })),
    attrs: {
      "for": ("vux-selector-" + _vm.uuid)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui-select",
    style: (_vm.cleanStyle({
      direction: _vm.direction,
      color: _vm.color
    })),
    attrs: {
      "id": ("vux-selector-" + _vm.uuid),
      "name": _vm.name
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showPlaceholder) ? _c('option', {
    domProps: {
      "value": _vm.value === null ? 'null' : '',
      "selected": _vm.isEmptyValue(_vm.value) && !!_vm.placeholder
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), (_vm.fixIos) ? _c('option', {
    attrs: {
      "disabled": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.processOptions), function(one) {
    return _c('option', {
      domProps: {
        "value": one.key
      }
    }, [_vm._v(_vm._s(_vm.direction === 'rtl' ? one.value + '‎' : one.value))])
  })], 2)]) : _c('div', {
    staticClass: "weui-cell__ft vux-selector-readonly"
  }, [_vm._v("\n    " + _vm._s(_vm._f("findByKey")(_vm.value, _vm.processOptions)) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "product-main"
  }, [_c('group', {
    attrs: {
      "title": "产品基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "productName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "产品名称",
      "placeholder": "请输入产品名称",
      "text-align": "right",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.productName),
      callback: function($$v) {
        _vm.$set(_vm.data, "productName", $$v)
      },
      expression: "data.productName"
    }
  }), _vm._v(" "), _c('my-selector', {
    ref: "orgType",
    attrs: {
      "title": "产品类型",
      "disabled": _vm.type === 0,
      "options": _vm.proTypeArry,
      "placeholder": "请选择产品类型"
    },
    model: {
      value: (_vm.data.productType),
      callback: function($$v) {
        _vm.$set(_vm.data, "productType", $$v)
      },
      expression: "data.productType"
    }
  }), _vm._v(" "), _c('datetime', {
    ref: "productFoundingDate",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "成立时间",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "readonly": _vm.type === 0
    },
    model: {
      value: (_vm.data.productFoundingDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "productFoundingDate", $$v)
      },
      expression: "data.productFoundingDate"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "productSurvivalPeriod",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "存续期",
      "placeholder": "请输入存续期（年）",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.productSurvivalPeriod),
      callback: function($$v) {
        _vm.$set(_vm.data, "productSurvivalPeriod", $$v)
      },
      expression: "data.productSurvivalPeriod"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "productScale",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "产品规模",
      "type": "tel",
      "placeholder": "请输入产品规模（万元）",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.productScale),
      callback: function($$v) {
        _vm.$set(_vm.data, "productScale", $$v)
      },
      expression: "data.productScale"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "productManager",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "管理人",
      "placeholder": "请输入管理人",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.productManager),
      callback: function($$v) {
        _vm.$set(_vm.data, "productManager", $$v)
      },
      expression: "data.productManager"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "productDeposit",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "托管人",
      "placeholder": "请输入托管人,若无托管则填\"无\"",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.productDeposit),
      callback: function($$v) {
        _vm.$set(_vm.data, "productDeposit", $$v)
      },
      expression: "data.productDeposit"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "productRecordCode",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "备案机构",
      "placeholder": "请输入备案机构",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.productRecordCode),
      callback: function($$v) {
        _vm.$set(_vm.data, "productRecordCode", $$v)
      },
      expression: "data.productRecordCode"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "productRecordNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "备案编号",
      "placeholder": "请填写编码中心分配的编码或协会备案产品编码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.productRecordNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "productRecordNo", $$v)
      },
      expression: "data.productRecordNo"
    }
  }), _vm._v(" "), _c('datetime', {
    ref: "productRecordDate",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "备案时间",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.productRecordDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "productRecordDate", $$v)
      },
      expression: "data.productRecordDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    model: {
      value: (_vm.showCheckPopup),
      callback: function($$v) {
        _vm.showCheckPopup = $$v
      },
      expression: "showCheckPopup"
    }
  }, [_c('datetime-view', {
    attrs: {
      "end-date": _vm.todayDate
    },
    model: {
      value: (_vm.data.productFoundingDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "productFoundingDate", $$v)
      },
      expression: "data.productFoundingDate"
    }
  })], 1), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showPopup),
      callback: function($$v) {
        _vm.showPopup = $$v
      },
      expression: "showPopup"
    }
  }, [_c('datetime-view', {
    attrs: {
      "end-date": _vm.todayDate
    },
    model: {
      value: (_vm.data.productRecordDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "productRecordDate", $$v)
      },
      expression: "data.productRecordDate"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_product_next
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-check-icon",
    on: {
      "click": _vm.updateValue
    }
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'default' && _vm.value),
      expression: "type === 'default' && value"
    }],
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'plain' && _vm.value),
      expression: "type === 'plain' && value"
    }],
    attrs: {
      "type": "success_circle"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.value),
      expression: "!value"
    }],
    attrs: {
      "type": "circle"
    }
  }), _vm._v(" "), _c('span', [_vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t投资者第一次登录APP，可直接在妥妥递首页输入邀请码进行管理\n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(912),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "01"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1), _vm._v("\n\t已有关联管理人时，点击右上角关联管理人，输入邀请码进行关联 \n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe1",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange1
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(914),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(916),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep1,
      "total_step": "02"
    },
    on: {
      "leftClick": _vm.leftClick1,
      "rightClick": _vm.rightClick1
    }
  }, [_vm._v(_vm._s(_vm.message1))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "weui-btn",
    class: _vm.classes,
    style: (_vm.buttonStyle),
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.actionType
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.showLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])])])
}]}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell",
    class: {
      'vux-tap-active': _vm.isLink || !!_vm.link,
        'weui-cell_access': _vm.isLink || !!_vm.link,
        'vux-cell-no-border-intent': !_vm.borderIntent,
        'vux-cell-disabled': _vm.disabled
    },
    style: (_vm.style),
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-cell-bd",
    class: {
      'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'
    }
  }, [_c('p', [(_vm.title || _vm.hasTitleSlot) ? _c('label', {
    staticClass: "vux-label",
    class: _vm.labelClass,
    style: (_vm.labelStyles)
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2) : _vm._e(), _vm._v(" "), _vm._t("after-title")], 2), _vm._v(" "), _c('inline-desc', [_vm._t("inline-desc", [_vm._v(_vm._s(_vm.inlineDesc))])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft",
    class: _vm.valueClass
  }, [_vm._t("value"), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), (_vm.isLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e()], 2), _vm._v(" "), _vm._t("child")], 2)
},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.baseInfo.type !== 0 && !_vm.loading) ? _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('group', {
    attrs: {
      "title": "投资者基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "orgName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "机构名称",
      "placeholder": "请输入机构名称",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgName),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgName", $$v)
      },
      expression: "data.orgName"
    }
  }), _vm._v(" "), _c('my-selector', {
    ref: "orgType",
    attrs: {
      "title": "机构类型",
      "disabled": _vm.baseInfo.type === 0,
      "options": _vm.orgTypeArry,
      "placeholder": "请选择机构类型"
    },
    model: {
      value: (_vm.data.orgType),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgType", $$v)
      },
      expression: "data.orgType"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('my-selector', {
    ref: "orgDocumentsType",
    attrs: {
      "title": "证件类型",
      "disabled": _vm.baseInfo.type === 0,
      "options": _vm.orgCardArry,
      "placeholder": "请选择证件类型"
    },
    model: {
      value: (_vm.data.orgDocumentsType),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgDocumentsType", $$v)
      },
      expression: "data.orgDocumentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgDocumentsNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件编号",
      "placeholder": "请输入证件编号",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgDocumentsNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgDocumentsNo", $$v)
      },
      expression: "data.orgDocumentsNo"
    }
  }), _vm._v(" "), _c('popup-radio', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "title": "证件有效期",
      "options": ['永久有效', '存在有效期']
    },
    model: {
      value: (_vm.localValidity),
      callback: function($$v) {
        _vm.localValidity = $$v
      },
      expression: "localValidity"
    }
  }), _vm._v(" "), (_vm.localValidity === '存在有效期') ? _c('datetime', {
    ref: "orgDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效日期",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.data.orgDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgDocumentsValidity", $$v)
      },
      expression: "data.orgDocumentsValidity"
    }
  }) : _vm._e(), _vm._v(" "), _c('x-input', {
    ref: "orgQualificationProve",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "资质证书",
      "placeholder": "请输入资质证书",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgQualificationProve),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgQualificationProve", $$v)
      },
      expression: "data.orgQualificationProve"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgQualificationNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证书编号",
      "keyboard": "number",
      "placeholder": "请输入证书编号",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgQualificationNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgQualificationNo", $$v)
      },
      expression: "data.orgQualificationNo"
    }
  }), _vm._v(" "), _c('my-selector', {
    ref: "orgBusinessScope",
    attrs: {
      "title": "经营范围",
      "disabled": _vm.baseInfo.type === 0,
      "options": _vm.BusinessScope,
      "placeholder": "请选择经营范围"
    },
    model: {
      value: (_vm.data.orgBusinessScope),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgBusinessScope", $$v)
      },
      expression: "data.orgBusinessScope"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgRegisterAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "注册地址",
      "placeholder": "请输入注册地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgRegisterAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgRegisterAddress", $$v)
      },
      expression: "data.orgRegisterAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公地址",
      "placeholder": "请输入办公地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgAddress", $$v)
      },
      expression: "data.orgAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgRegisteredCapital",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "注册资本(万元)",
      "placeholder": "请输入注册资本（万元）",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgRegisteredCapital),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgRegisteredCapital", $$v)
      },
      expression: "data.orgRegisteredCapital"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgController",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "股东或实际控股人",
      "placeholder": "请输入股东或实际控股人",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgController),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgController", $$v)
      },
      expression: "data.orgController"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_agency_next
    }
  }, [_vm._v("下一步")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.type === 0 && !_vm.loading) ? _c('one-look', {
    attrs: {
      "baseInfo": _vm.baseInfo,
      "propData": _vm.data,
      "hasResp": _vm.hasResp
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t数字证书申请表上传\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者上传签署盖章的数字证书申请表\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])])])
}]}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-footer-fixed-btn"
  }, [_c('x-button', {
    staticClass: "com-btn-submit-radius",
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.checkEvent($event)
      }
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading",
    class: !_vm.text ? 'vux-loading-no-text' : ''
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('my-cell-header', {
    attrs: {
      "cellHeader": "自然人"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "普通投资者",
      "is-link": ""
    },
    on: {
      "click": _vm.perNor
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "专业投资者",
      "is-link": ""
    },
    on: {
      "click": _vm.perPro
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "从业人员",
      "is-link": ""
    },
    on: {
      "click": _vm.perEmp
    }
  })], 1)], 1), _vm._v(" "), _c('my-cell-header', {
    attrs: {
      "cellHeader": "机构"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "普通投资者",
      "is-link": ""
    },
    on: {
      "click": _vm.orgNor
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "专业投资者（法人及其他组织）",
      "is-link": ""
    },
    on: {
      "click": _vm.orgPro
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "金融机构",
      "is-link": ""
    },
    on: {
      "click": _vm.orgFin
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "本机构",
      "is-link": ""
    },
    on: {
      "click": _vm.orgSelf
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title) ? _c('div', {
    staticClass: "weui-cells__title",
    style: (_vm.cleanStyle({
      color: _vm.titleColor
    })),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title"), _vm._v(" "), _c('div', {
    staticClass: "weui-cells",
    class: {
      'vux-no-group-title': !_vm.title
    },
    style: (_vm.cleanStyle({
      marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
    }))
  }, [_vm._t("after-title"), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.footerTitle) ? _c('div', {
    staticClass: "weui-cells__title vux-group-footer-title",
    style: (_vm.cleanStyle({
      color: _vm.footerTitleColor
    })),
    domProps: {
      "innerHTML": _vm._s(_vm.footerTitle)
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "product-main"
  }, [_c('group', {
    attrs: {
      "title": "指定授权经办人",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "transactorName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "is-type": "china-name",
      "placeholder": "请输入姓名",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.transactorName),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorName", $$v)
      },
      expression: "data.transactorName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorCertigicateType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "text-align": _vm.type === 0 ? 'right' : '',
      "placeholder": "请输入证件类型",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.transactorCertigicateType),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorCertigicateType", $$v)
      },
      expression: "data.transactorCertigicateType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorCertigicateNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "is-type": _vm.isIdCard,
      "placeholder": "请输入证件号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    on: {
      "on-change": _vm.idcardChange
    },
    model: {
      value: (_vm.data.transactorCertigicateNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorCertigicateNo", $$v)
      },
      expression: "data.transactorCertigicateNo"
    }
  }), _vm._v(" "), _c('popup-radio', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "text-align": _vm.type === 0 ? 'right' : '',
      "title": "证件有效期",
      "options": ['永久有效', '存在有效期']
    },
    model: {
      value: (_vm.localValidity),
      callback: function($$v) {
        _vm.localValidity = $$v
      },
      expression: "localValidity"
    }
  }), _vm._v(" "), (_vm.localValidity === '存在有效期') ? _c('datetime', {
    ref: "transactorCertificateValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效期",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "readonly": _vm.type === 0
    },
    model: {
      value: (_vm.data.transactorCertificateValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorCertificateValidity", $$v)
      },
      expression: "data.transactorCertificateValidity"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    style: ({
      color: _vm.type === 0 ? 'rgba(0, 0, 0, 0.3)' : '',
      height: _vm.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": ""
    },
    model: {
      value: (_vm.data.transactorSex),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorSex", $$v)
      },
      expression: "data.transactorSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.transactorAge),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorAge", $$v)
      },
      expression: "data.transactorAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "transactorPosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.transactorPosition),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorPosition", $$v)
      },
      expression: "data.transactorPosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorLandline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "is-type": _vm.isPhone,
      "placeholder": "请输入座机",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.transactorLandline),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorLandline", $$v)
      },
      expression: "data.transactorLandline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "is-type": "china-mobile",
      "placeholder": "请输入手机号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.transactorMobile),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorMobile", $$v)
      },
      expression: "data.transactorMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "is-type": "email",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.transactorEmail),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorEmail", $$v)
      },
      expression: "data.transactorEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "transactorOfficeZip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公邮编",
      "max": 6,
      "type": "number",
      "placeholder": "请输入办公邮编",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.transactorOfficeZip),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorOfficeZip", $$v)
      },
      expression: "data.transactorOfficeZip"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorOfficeAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公地址",
      "placeholder": "请输入办公地址",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.transactorOfficeAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorOfficeAddress", $$v)
      },
      expression: "data.transactorOfficeAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "transactorProductRelation",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "与该机构/产品的关系",
      "placeholder": "请输入与该机构/产品的关系",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.transactorProductRelation),
      callback: function($$v) {
        _vm.$set(_vm.data, "transactorProductRelation", $$v)
      },
      expression: "data.transactorProductRelation"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_product_auth
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-tabs', {
    attrs: {
      "line-width": "24"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "理财师发起"
    }
  }, [_c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("\n\t\t\t情况一：套印模式下，理财师发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约确定\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对理财师预约的产品进行预约确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("\n\t\t\t情况二：UKEY托管人先签，理财师发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约确定\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对理财师预约的产品进行预约确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.托管人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t等待托管人对合同进行确认签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("\n\t\t\t情况三：UKEY托管人后签，理财师发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约确定\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对理财师预约的产品进行预约确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.托管人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t等待托管人对合同进行确认签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])])])]), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "投资者发起"
    }
  }, [_c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("\n\t\t\t情况一：套印模式下，投资者发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约申请\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者发起预约订单申请\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("\n\t\t\t情况二：UKEY托管人先签，投资者发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约申请\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者发起预约订单申请\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.托管人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t等待托管人对合同进行确认签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v("\n\t\t\t情况三：UKEY托管人后签，投资者发起的订单\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约申请\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者发起预约订单申请\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.合同签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.托管人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t等待托管人对合同进行确认签署\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.理财师签署\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者签署完成后，进入理财师签署风险揭示书\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.签约成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t三方协议签署成功\n\t\t\t")])])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-input weui-cell",
    class: {
      'weui-cell_warn': _vm.showWarn,
      'disabled': _vm.disabled,
      'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [(_vm.hasRestrictedLabel) ? _c('div', {
    style: (_vm.labelStyles)
  }, [_vm._t("restricted-label")], 2) : _vm._e(), _vm._v(" "), _vm._t("label", [(_vm.title) ? _c('label', {
    staticClass: "weui-label",
    class: _vm.labelClass,
    style: ({
      width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed,
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    attrs: {
      "for": ("vux-x-input-" + _vm.uuid)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd weui-cell__primary",
    class: _vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''
  }, [(!_vm.type || _vm.type === 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "text",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "number",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "email",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "password",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'tel') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "input",
    staticClass: "weui-input",
    style: (_vm.inputStyle),
    attrs: {
      "id": ("vux-x-input-" + _vm.uuid),
      "maxlength": _vm.max,
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "type": "tel",
      "name": _vm.name,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),
      expression: "!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"
    }],
    attrs: {
      "type": "clear"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clear($event)
      }
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWarn),
      expression: "showWarn"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn",
      "title": !_vm.valid ? _vm.firstError : ''
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClickErrorIcon($event)
      }
    }
  }), _vm._v(" "), (!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid) ? _c('icon', {
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClickErrorIcon($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),
      expression: "!novalidate && equalWith && equalWith === currentValue && valid"
    }],
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.novalidate && _vm.iconType === 'success'),
      expression: "novalidate && iconType === 'success'"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.novalidate && _vm.iconType === 'error'),
      expression: "novalidate && iconType === 'error'"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn"
    }
  }), _vm._v(" "), _vm._t("right"), _vm._v(" "), (_vm.hasRightFullHeightSlot) ? _c('div', {
    staticClass: "vux-x-input-right-full"
  }, [_vm._t("right-full-height")], 2) : _vm._e()], 2), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "width": "auto",
      "time": 600
    },
    model: {
      value: (_vm.showErrorToast),
      callback: function($$v) {
        _vm.showErrorToast = $$v
      },
      expression: "showErrorToast"
    }
  }, [_vm._v(_vm._s(_vm.firstError))])], 1)
},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('group', {
    attrs: {
      "title": "指定授权经办人",
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "is-type": "china-name",
      "placeholder": "请输入姓名",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersName),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersName", $$v)
      },
      expression: "data.managersName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersDocumentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "text-align": "right",
      "placeholder": "请输入证件类型",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.managersDocumentsType),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersDocumentsType", $$v)
      },
      expression: "data.managersDocumentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersIdCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "is-type": _vm.isIdCard,
      "placeholder": "请输入证件号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    on: {
      "on-change": _vm.idcardChange
    },
    model: {
      value: (_vm.data.managersIdCardNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersIdCardNo", $$v)
      },
      expression: "data.managersIdCardNo"
    }
  }), _vm._v(" "), _c('popup-radio', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "text-align": _vm.type === 0 ? 'right' : '',
      "title": "证件有效期",
      "options": ['永久有效', '存在有效期']
    },
    model: {
      value: (_vm.localValidity),
      callback: function($$v) {
        _vm.localValidity = $$v
      },
      expression: "localValidity"
    }
  }), _vm._v(" "), (_vm.localValidity === '存在有效期') ? _c('datetime', {
    ref: "managersDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效日期",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.managersDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersDocumentsValidity", $$v)
      },
      expression: "data.managersDocumentsValidity"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    ref: "managersSex",
    style: ({
      color: _vm.type === 0 ? 'rgba(0, 0, 0, 0.3)' : '',
      height: _vm.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.type === 0
    },
    model: {
      value: (_vm.data.managersSex),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersSex", $$v)
      },
      expression: "data.managersSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.managersAge),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersAge", $$v)
      },
      expression: "data.managersAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersPosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersPosition),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersPosition", $$v)
      },
      expression: "data.managersPosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersLanline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "is-type": _vm.isPhone,
      "placeholder": "格式：区号+座机号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersLanline),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersLanline", $$v)
      },
      expression: "data.managersLanline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "is-type": "china-mobile",
      "placeholder": "请输入手机号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersMobile),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersMobile", $$v)
      },
      expression: "data.managersMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "is-type": "email",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersEmail),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersEmail", $$v)
      },
      expression: "data.managersEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersZip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公邮编",
      "max": 6,
      "type": "tel",
      "placeholder": "请输入办公邮编",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersZip),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersZip", $$v)
      },
      expression: "data.managersZip"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公地址",
      "placeholder": "请输入办公地址",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.managersAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "managersAddress", $$v)
      },
      expression: "data.managersAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "relationshipWithOrg",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "与该机构关系",
      "placeholder": "请输入与该机构关系",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.relationshipWithOrg),
      callback: function($$v) {
        _vm.$set(_vm.data, "relationshipWithOrg", $$v)
      },
      expression: "data.relationshipWithOrg"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_agency_auth
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "step",
    staticClass: "my-step",
    style: (_vm.padStyle)
  }, [_c('div', {
    staticClass: "line"
  }, _vm._l((_vm.stepArry), function(i) {
    return _c('i', {
      key: i,
      style: ({
        'left': _vm.stepwidth * i - 5 + 'px',
        backgroundColor: (_vm.step >= i) ? '#3d82f7' : '#E0E0E0'
      })
    }, [(i === _vm.step) ? _c('em', [_c('img', {
      attrs: {
        "src": __webpack_require__(934)
      }
    })]) : _vm._e()])
  }))])
},staticRenderFns: []}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t普通投资者：\n\t")]), _vm._v("\n\t普通投资者特定对象确认需要做风险承受能力测评，个人中心也可以重新测评\n\t"), _c('br'), _vm._v("\n\t投资者阅读风险提示，点击“开始测评”可以开始风险测评，预计2-3分钟完成私募基金管理人的测评模板，提交后可查看风险承受能力等级，等级有： "), _c('span', {
    staticClass: "stress-content"
  }, [_vm._v("C1(风险承受能力最低)、C1、C2、C3、C4、C5")]), _vm._v(" "), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(927),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(928),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "02"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1), _vm._v(" "), _c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t专业投资者：\n\t")]), _vm._v("\n\t个人中心可以进行风险承受能力测评 \n\t"), _c('br'), _vm._v("\n\t投资者阅读风险提示，点击“开始测评”可以开始风险测评，预计2-3分钟完成私募基金管理人的测评模板，提交后可查看风险承受能力等级，等级有："), _c('span', {
    staticClass: "stress-content"
  }, [_vm._v("C1(风险承受能力最低)、C1、C2、C3、C4、C5")]), _vm._v(" "), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe1",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange1
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(929),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(930),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(931),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep1,
      "total_step": "03"
    },
    on: {
      "leftClick": _vm.leftClick1,
      "rightClick": _vm.rightClick1
    }
  }, [_vm._v(_vm._s(_vm.message1))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_vm._t("default")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i')])
}]}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(71),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 0 0 0",
      "overflow": "hidden"
    },
    style: ({
      height: _vm.isExpand ? '' : '25px'
    })
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "absolute",
      "bottom": "-25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    style: ({
      transform: _vm.isExpand ? '' : 'rotate(180deg)'
    }),
    attrs: {
      "src": __webpack_require__(202),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isExpand = !_vm.isExpand
      }
    }
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      自然人投资者中的专业投资者需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n        1、身份证正反面照片（或扫描件）；\n        "), _c('br'), _vm._v("\n        2、最近3年个人年均收入不低于50万元的个人收入证明，或者不低于500万元的金融资产*证明；\n        "), _c('br'), _vm._v("\n        3、2 年以上证券、基金、期货、黄金、外汇等投资经历证明，或者或属于经有关金融监管部门批准设立的金融机构（包括证券公司、期货公司、基金管理公司及其子公司、商业银行、保险公司、信托公司、财务公司等），经行业协会备案或者登记的证券公司子公司、期货公司子公司、私募基金管理人的高级管理人员、获得职业资格认证的从事金融相关业务的注册会计师和律师等的资格证明；\n        "), _c('br'), _vm._v("\n        4、投资者基本信息表（自然人）相关信息；\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n          金融资产证明文件可以参考以下证明: "), _c('br'), _vm._v("\n          ①银行存款，银行出具的存款证明；  "), _c('br'), _vm._v("\n          ②股票，证券账户内股票市值；"), _c('br'), _vm._v("\n          ③债券，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ④基金份额，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ⑤资产管理计划，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ⑥银行理财产品，银行出具的资产证明；"), _c('br'), _vm._v("\n          ⑦信托计划，购买合同；"), _c('br'), _vm._v("\n          ⑧保险产品，购买合同；"), _c('br'), _vm._v("\n          ⑨期货，申请日前一交易日客户权益；"), _c('br'), _vm._v("\n          ⑩其他衍生品，购买凭证；"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": __webpack_require__(72),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('group', {
    attrs: {
      "title": "法定代表人或负责人",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativeName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "is-type": "china-name",
      "placeholder": "请输入姓名",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeName),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeName", $$v)
      },
      expression: "data.representativeName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeDocumentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "placeholder": "请输入证件类型",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.representativeDocumentsType),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeDocumentsType", $$v)
      },
      expression: "data.representativeDocumentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeIdCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "is-type": _vm.isIdCard,
      "placeholder": "请输入证件号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    on: {
      "on-change": _vm.idcardChange
    },
    model: {
      value: (_vm.data.representativeIdCardNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeIdCardNo", $$v)
      },
      expression: "data.representativeIdCardNo"
    }
  }), _vm._v(" "), _c('popup-radio', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "text-align": _vm.type === 0 ? 'right' : '',
      "title": "证件有效期",
      "options": ['永久有效', '存在有效期']
    },
    model: {
      value: (_vm.localValidity),
      callback: function($$v) {
        _vm.localValidity = $$v
      },
      expression: "localValidity"
    }
  }), _vm._v(" "), (_vm.localValidity === '存在有效期') ? _c('datetime', {
    ref: "representativeDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效日期",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.representativeDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeDocumentsValidity", $$v)
      },
      expression: "data.representativeDocumentsValidity"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    style: ({
      color: _vm.type === 0 ? 'rgba(0, 0, 0, 0.3)' : '',
      height: _vm.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.type === 0
    },
    model: {
      value: (_vm.data.representativeSex),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeSex", $$v)
      },
      expression: "data.representativeSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.representativeAge),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeAge", $$v)
      },
      expression: "data.representativeAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativePosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativePosition),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativePosition", $$v)
      },
      expression: "data.representativePosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeLanline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "is-type": _vm.isPhone,
      "placeholder": "格式：区号+座机号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeLanline),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeLanline", $$v)
      },
      expression: "data.representativeLanline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "is-type": "china-mobile",
      "placeholder": "请输入手机号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeMobile),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeMobile", $$v)
      },
      expression: "data.representativeMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "is-type": "email",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeEmail),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeEmail", $$v)
      },
      expression: "data.representativeEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativeZip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公邮编",
      "max": 6,
      "type": "tel",
      "placeholder": "请输入办公邮编",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeZip),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeZip", $$v)
      },
      expression: "data.representativeZip"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公地址",
      "placeholder": "请输入办公地址",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeAddress", $$v)
      },
      expression: "data.representativeAddress"
    }
  })], 1), _vm._v(" "), (_vm.check && _vm.type === 1) ? _c('div', {
    staticStyle: {
      "text-align": "right",
      "padding": "5px 20px",
      "background-color": "#fff"
    }
  }, [_c('check-icon', {
    attrs: {
      "value": _vm.isThree
    },
    on: {
      "update:value": function($event) {
        _vm.isThree = $event
      }
    }
  }, [_vm._v("本人是授权经办人")])], 1) : _vm._e()], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_agency_auth
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(71),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      机构投资者中的普通投资者需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n        1、营业执照扫描件、组织机构代码证扫描件、税务登记证扫描件（三证合一机构提供营业执照扫描件即可）；\n        "), _c('br'), _vm._v("\n        2、开户许可证扫描件；\n        "), _c('br'), _vm._v("\n        3、法定代表人身份证正反面扫描件；\n        "), _c('br'), _vm._v("\n        4、经办人身份证正反面扫描件；\n        "), _c('br'), _vm._v("\n        5、不低于1000万元的净资产证明；\n        "), _c('br'), _vm._v("\n        6、投资者基本信息表（机构）相关信息；\n        "), _c('br'), _vm._v("\n        7、经办人授权函\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": __webpack_require__(72),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
}]}

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t远程双录：\n\t")]), _vm._v("\n\t投资者在待合同签署阶段发起远程双录，对和理财师视频对话进行录音录像。双录结束后进行提交上传双录文件。可以投资者自己结束双体提交，也可理财师进行结束提交。\n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(920),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(921),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "02"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1), _vm._v(" "), _c('div', {
    staticClass: "head-text"
  }, [_vm._v("\n\t\t本地双录：\n\t")]), _vm._v("\n\t在待投资者合同签署阶段，由理财师发起本地双录，投资者和理财师同框进行录音、录像。由理财师结束录制上传双录文件 \n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe1",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange1
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(922),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(923),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep1,
      "total_step": "02"
    },
    on: {
      "leftClick": _vm.leftClick1,
      "rightClick": _vm.rightClick1
    }
  }, [_vm._v(_vm._s(_vm.message1))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-confirm"
  }, [_c('x-dialog', {
    attrs: {
      "dialog-class": _vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [(!!_vm.title) ? _c('div', {
    staticClass: "weui-dialog__hd",
    class: {
      'with-no-content': !_vm.showContent
    }
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.showContent) ? [(!_vm.showInput) ? _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2) : _c('div', {
    staticClass: "vux-prompt"
  }, [(((_vm.getInputAttrs()).type) === 'checkbox') ? _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.msg) ? _vm._i(_vm.msg, null) > -1 : (_vm.msg)
    },
    on: {
      "touchend": _vm.setInputFocus,
      "change": function($event) {
        var $$a = _vm.msg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.msg = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.msg = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.msg = $$c
        }
      }
    }
  }, 'input', _vm.getInputAttrs(), false)) : (((_vm.getInputAttrs()).type) === 'radio') ? _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.msg, null)
    },
    on: {
      "touchend": _vm.setInputFocus,
      "change": function($event) {
        _vm.msg = null
      }
    }
  }, 'input', _vm.getInputAttrs(), false)) : _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    ref: "input",
    staticClass: "vux-prompt-msgbox",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": (_vm.getInputAttrs()).type
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "touchend": _vm.setInputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  }, 'input', _vm.getInputAttrs(), false))])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [(_vm.showCancelButton) ? _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))]) : _vm._e(), _vm._v(" "), (_vm.showConfirmButton) ? _c('a', {
    staticClass: "weui-dialog__btn",
    class: ("weui-dialog__btn_" + _vm.confirmType),
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText || '确定'))]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t投资者选择想要购买的产品，输入预约金额，对投资者信息、风险承受能力、经办人授权函（如有）、投资者主体（如有）进行确认，并同意采用以上信息进行数字证书申请。\n\t"), _c('div', {
    staticClass: "stress-content"
  }, [_vm._v("\n\t\t界面提示有3秒的强阅读时间，防止投资者误点出错。\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    attrs: {
      "show-indicators": _vm.showindicators
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(913),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(915),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "02"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell vux-x-textarea"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [(_vm.hasRestrictedLabel) ? _c('div', {
    style: (_vm.labelStyles)
  }, [_vm._t("restricted-label")], 2) : _vm._e(), _vm._v(" "), _vm._t("label", [(_vm.title) ? _c('label', {
    staticClass: "weui-label",
    class: _vm.labelClass,
    style: ({
      width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'),
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "textarea",
    staticClass: "weui-textarea",
    style: (_vm.textareaStyle),
    attrs: {
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "name": _vm.name,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "maxlength": _vm.max
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": function($event) {
        _vm.$emit('on-focus')
      },
      "blur": function($event) {
        _vm.$emit('on-blur')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCounter && _vm.max),
      expression: "showCounter && max"
    }],
    staticClass: "weui-textarea-counter",
    on: {
      "click": _vm.focus
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.count))]), _vm._v("/" + _vm._s(_vm.max) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "cell-section"
  }, [_c('div', {
    staticClass: "cell-header"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.cellHeader) + "\n\t\t")]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('my-cell-header', {
    attrs: {
      "cellHeader": "投资者操作流程说明"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "账户注册流程",
      "is-link": ""
    },
    on: {
      "click": _vm.reigsterProcess
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "特定对象确认流程",
      "is-link": ""
    },
    on: {
      "click": _vm.confirmProcess
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "预约申请流程",
      "is-link": ""
    },
    on: {
      "click": _vm.appointmentProcess
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "预约确认流程",
      "is-link": ""
    },
    on: {
      "click": _vm.appointmentconfirmProcess
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "合同签署流程说明",
      "is-link": ""
    },
    on: {
      "click": _vm.contractProcess
    }
  })], 1)], 1), _vm._v(" "), _c('my-cell-header', {
    attrs: {
      "cellHeader": "重要功能点说明"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "邀请码关联",
      "is-link": ""
    },
    on: {
      "click": _vm.invite
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "身份认证",
      "is-link": ""
    },
    on: {
      "click": _vm.confirm
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "风险承受能力测评",
      "is-link": ""
    },
    on: {
      "click": _vm.riskTest
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "预约申请",
      "is-link": ""
    },
    on: {
      "click": _vm.appointment
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "创建产品（产品买产品）",
      "is-link": ""
    },
    on: {
      "click": _vm.createProduct
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "双录",
      "is-link": ""
    },
    on: {
      "click": _vm.record
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "合同签署",
      "is-link": ""
    },
    on: {
      "click": _vm.contract
    }
  })], 1)], 1), _vm._v(" "), _c('my-cell-header', {
    attrs: {
      "cellHeader": "其他说明"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "订单状态说明",
      "is-link": ""
    },
    on: {
      "click": _vm.orderState
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "如何找回密码",
      "is-link": ""
    },
    on: {
      "click": _vm.findPwd
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style)
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "topTitle"
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(38)
    }
  }), _vm._v(" 投资者如何找回密码？\n\t\t\t"), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "14px"
    },
    attrs: {
      "src": __webpack_require__(37)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reminder-text"
  }, [_vm._v("\n\t\t\t登录页面点击忘记密码\n\t\t")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-left": "5%"
    },
    attrs: {
      "src": __webpack_require__(910),
      "width": "90%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t自然人\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t填写注册手机号码，获取短信验证码，重新设置密码即可\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t机构\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t填写注册机构名称、注册手机号码、短信验证码，重新设置密码即可\n\t\t\t")])])])])
}]}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation"
  }, [_c('x-header', {
    staticClass: "header-define",
    attrs: {
      "title": _vm.title,
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.$_evaluation_back
    },
    slot: "left"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#222222"
    },
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.$_view_quesDetail
    },
    slot: "right"
  }, [_vm._v("问卷明细")])]), _vm._v(" "), _c('div', {
    staticClass: "evaluation-main"
  }, [_c('div', {
    staticClass: "evaluation-main"
  }, [_c('div', {
    staticClass: "page-index"
  }, [_c('div', {
    staticClass: "result-item"
  }, [_c('p', {
    staticClass: "res-one",
    style: (_vm.imgStyle)
  }, [_c('span', [_vm._v(_vm._s(_vm.params.result))])]), _vm._v(" "), _c('p', {
    staticClass: "com-again-test",
    on: {
      "click": _vm.$_evaluation_again
    }
  }, [_vm._v("\n            重新测评\n          ")]), _vm._v(" "), (_vm.params.isLowAccept == 0) ? _c('p', {
    staticClass: "res-two"
  }, [_vm._v("\n            您适合购买的产品风险等级为"), _c('span', [_vm._v(_vm._s(_vm.level))]), _vm._v("的基金\n          ")]) : _vm._e(), _vm._v(" "), (_vm.params.isLowAccept == 1) ? _c('p', {
    staticClass: "res-two"
  }, [_c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("风险承受最低类别")]), _vm._v("，您不可购买风险等级高于"), _c('span', [_vm._v("R1")]), _vm._v(" 的基金\n          ")]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.params.specialObj) ? _c('table-list', {
    attrs: {
      "baseInfo": _vm.params
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "com-footer-fixed-btn"
  }, [_c('button', {
    staticClass: "com-btn-submit-radius weui-btn weui-btn_primary",
    on: {
      "click": _vm.$_evaluation_checkSubmit
    }
  }, [_vm._v("提 交")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "production-item"
  }, [_c('h4', [_vm._v("重要声明")]), _vm._v(" "), _c('p', [_vm._v("\n            您的风险承受能力评估结果是根据您填写的《风险测评问卷》以及其他相关信息综合评估得出，旨在协助您选择合适的产品或服务类别，并不能取代您自己的投资判断，也不会降低产品或服务的固有风险。建议您在产品购买过程中结合自身投资行为，并做出审慎的投资判断。\n          ")])])
}]}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("一、是否为下列机构")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px"
    }
  }, [_vm._v("\n          符合《证券期货投资者适当性管理办法》第八章第（一）款所规定的证券公司、期货公司、基金管理公司及其子公司、商业银行、保险公司、信托公司、财务公司；\n          或在中国证券投资基金业协会登记或者备案的证券公司子公司、期货公司子公司、私募基金管理人；或者第（三）款所规定的合格境外机构投资者（QFII），人名币合格境外机构投资者（RQFII）\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isProfessionalInvestors.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isProfessionalInvestors, "checked", $$v)
      },
      expression: "data.isProfessionalInvestors.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": "",
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": "",
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("二、机构资产规模？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px"
    }
  }, [_vm._v("\n          私募基金或者资产管理计划投资者，最近三个月月末资产均超过（含）人名币1000万元\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.orgAssetsScale.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.orgAssetsScale, "checked", $$v)
      },
      expression: "data.orgAssetsScale.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("三、是否存在实际控制关系？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isControllingShareholder.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "checked", $$v)
      },
      expression: "data.isControllingShareholder.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isControllingShareholder.checked === '是'),
      expression: "data.isControllingShareholder.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isControllingShareholder.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "description", $$v)
      },
      expression: "data.isControllingShareholder.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("四、交易实际受益人？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "checked", $$v)
      },
      expression: "data.transactionActualBeneficiary.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "本机构"
    }
  }, [_c('my-check-style', [_vm._v("本机构")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "其他机构或个人"
    }
  }, [_c('my-check-style', [_vm._v("其他机构或个人")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.transactionActualBeneficiary.checked === '其他机构或个人'),
      expression: "data.transactionActualBeneficiary.checked === '其他机构或个人'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.description),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "description", $$v)
      },
      expression: "data.transactionActualBeneficiary.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("五、是否有不良诚信记录？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isBadFaith.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "checked", $$v)
      },
      expression: "data.isBadFaith.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isBadFaith.checked === '是'),
      expression: "data.isBadFaith.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isBadFaith.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "description", $$v)
      },
      expression: "data.isBadFaith.description"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_agency_submit
    }
  }, [_vm._v("提 交")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-checker-item",
    class: _vm.classNames,
    on: {
      "click": _vm.select
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "vux-label-desc"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "index-main"
  }, [_c('x-button', {
    attrs: {
      "link": "/evaluation/one",
      "type": "primary"
    }
  }, [_vm._v("风险测评")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/investor/personal/one",
      "type": "primary"
    }
  }, [_vm._v("投资者信息-个人")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/investor/agency/one",
      "type": "primary"
    }
  }, [_vm._v("投资者信息-机构")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/investor/product/one",
      "type": "primary"
    }
  }, [_vm._v("投资者信息-产品")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/agreeupdate/index",
      "type": "primary"
    }
  }, [_vm._v("服务协议及隐私变更通知")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/manager/login",
      "type": "primary"
    }
  }, [_vm._v("管理人-登录与注册")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/share/index?type=SPECIFIC_PERSONAL_PRACTITIONERS",
      "type": "primary"
    }
  }, [_vm._v("投资者分享")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/relation?name=杨老五杨老五杨老五杨老五杨老五&type=SPECIFIC_PERSONAL_PRACTITIONERS&code=123456",
      "type": "primary"
    }
  }, [_vm._v("关联成功分享")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/download",
      "type": "primary"
    }
  }, [_vm._v("app下载")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/guide/list",
      "type": "primary"
    }
  }, [_vm._v("app操作手册")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('my-step', {
    attrs: {
      "step": 2,
      "totalstep": 3
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "AU"
    },
    model: {
      value: (_vm.au),
      callback: function($$v) {
        _vm.au = $$v
      },
      expression: "au"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.baseInfo.type !== 0 && !_vm.loading) ? _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('group', {
    attrs: {
      "title": "投资者基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "userName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "placeholder": "请输入姓名",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.isEdit || _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userName),
      callback: function($$v) {
        _vm.$set(_vm.data, "userName", $$v)
      },
      expression: "data.userName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "documentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "placeholder": "请输入证件类型",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.documentsType),
      callback: function($$v) {
        _vm.$set(_vm.data, "documentsType", $$v)
      },
      expression: "data.documentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "idCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "is-type": _vm.isIdCard,
      "placeholder": "请输入证件号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.isEdit || _vm.baseInfo.type === 0,
      "required": ""
    },
    on: {
      "on-change": _vm.idcardChange
    },
    model: {
      value: (_vm.data.idCardNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "idCardNo", $$v)
      },
      expression: "data.idCardNo"
    }
  }), _vm._v(" "), _c('datetime', {
    ref: "documentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件有效期",
      "placeholder": "证件号码有效期",
      "disabled": _vm.isEdit || _vm.baseInfo.type === 0,
      "required": "",
      "start-date": "2019-07-18",
      "end-date": "2099-12-31"
    },
    model: {
      value: (_vm.data.documentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "documentsValidity", $$v)
      },
      expression: "data.documentsValidity"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "forever weui-cell"
  }, [_c('check-icon', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "value": _vm.isYJ,
      "type": "plain"
    },
    on: {
      "update:value": function($event) {
        _vm.isYJ = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#999999"
    }
  }, [_vm._v("若为永久有效，请勾选")])])], 1)], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "userCountry",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "国籍",
      "placeholder": "请输入国籍",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.userCountry),
      callback: function($$v) {
        _vm.$set(_vm.data, "userCountry", $$v)
      },
      expression: "data.userCountry"
    }
  }), _vm._v(" "), _c('selector', {
    ref: "userSex",
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.isEdit || _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userSex),
      callback: function($$v) {
        _vm.$set(_vm.data, "userSex", $$v)
      },
      expression: "data.userSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.userAge),
      callback: function($$v) {
        _vm.$set(_vm.data, "userAge", $$v)
      },
      expression: "data.userAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('my-selector', {
    ref: "userOccupation",
    attrs: {
      "title": "职业",
      "placeholder": "请选择职业",
      "disabled": _vm.baseInfo.type === 0,
      "options": ['党政机关、事业单位', '企业单位', '自由业主', '学生', '军人', '其他']
    },
    model: {
      value: (_vm.data.userOccupation),
      callback: function($$v) {
        _vm.$set(_vm.data, "userOccupation", $$v)
      },
      expression: "data.userOccupation"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userPosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userPosition),
      callback: function($$v) {
        _vm.$set(_vm.data, "userPosition", $$v)
      },
      expression: "data.userPosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userLandline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "is-type": _vm.isPhone,
      "placeholder": "请输入座机",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userLandline),
      callback: function($$v) {
        _vm.$set(_vm.data, "userLandline", $$v)
      },
      expression: "data.userLandline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "is-type": "china-mobile",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "placeholder": "请输入手机",
      "required": ""
    },
    model: {
      value: (_vm.data.userMobile),
      callback: function($$v) {
        _vm.$set(_vm.data, "userMobile", $$v)
      },
      expression: "data.userMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "is-type": "email",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userEmail),
      callback: function($$v) {
        _vm.$set(_vm.data, "userEmail", $$v)
      },
      expression: "data.userEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "zip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "邮编",
      "max": 6,
      "type": "tel",
      "keyboard": "number",
      "placeholder": "请输入邮编",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.zip),
      callback: function($$v) {
        _vm.$set(_vm.data, "zip", $$v)
      },
      expression: "data.zip"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "住址",
      "placeholder": "请输入住址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.userAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "userAddress", $$v)
      },
      expression: "data.userAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_personal_auth
    }
  }, [_vm._v("下一步")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.type === 0 && !_vm.loading) ? _c('one-look', {
    attrs: {
      "propData": _vm.data,
      "baseInfo": _vm.baseInfo,
      "hasResp": _vm.hasResp
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": ("vux-popup-animate-" + _vm.position)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.initialShow),
      expression: "show && !initialShow"
    }],
    staticClass: "vux-popup-dialog",
    class: [("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],
    style: (_vm.styles)
  }, [(_vm.shouldRenderBody) ? _vm._t("default") : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(71),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px 0 0 0",
      "overflow": "hidden"
    },
    style: ({
      height: _vm.isExpand ? '' : '25px'
    })
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "absolute",
      "bottom": "-25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    style: ({
      transform: _vm.isExpand ? '' : 'rotate(180deg)'
    }),
    attrs: {
      "src": __webpack_require__(202),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isExpand = !_vm.isExpand
      }
    }
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      自然人投资者中的普通投资者需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n          1、身份证正反面照片（或扫描件）;\n          "), _c('br'), _vm._v("\n          2、最近3年个人年均收入不低于50万元个人收入证明，或者不低于300万元金融资产证明;\n          "), _c('br'), _vm._v("\n          3、投资者基本信息表（自然人）相关信息;\n          "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n          金融资产证明文件可以参考以下证明: "), _c('br'), _vm._v("\n          ①银行存款，银行出具的存款证明；  "), _c('br'), _vm._v("\n          ②股票，证券账户内股票市值；"), _c('br'), _vm._v("\n          ③债券，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ④基金份额，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ⑤资产管理计划，发行人或代销机构盖章的对账单；"), _c('br'), _vm._v("\n          ⑥银行理财产品，银行出具的资产证明；"), _c('br'), _vm._v("\n          ⑦信托计划，购买合同；"), _c('br'), _vm._v("\n          ⑧保险产品，购买合同；"), _c('br'), _vm._v("\n          ⑨期货，申请日前一交易日客户权益；"), _c('br'), _vm._v("\n          ⑩其他衍生品，购买凭证；"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": __webpack_require__(72),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-body"
  }, [_c('div', {
    ref: "content",
    staticClass: "content"
  })]), _vm._v(" "), (_vm.noticeType === '2') ? _c('div', {
    staticClass: "page-foot"
  }, [_c('flexbox', [_c('flexbox-item', [_c('x-button', {
    staticClass: "my-primary",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.agree($event)
      }
    }
  }, [_vm._v("同意")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.noticeType === '3') ? _c('div', {
    staticClass: "page-foot"
  }, [_c('flexbox', [_c('flexbox-item', [_c('x-button', {
    staticClass: "my-primary",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.agree($event)
      }
    }
  }, [_vm._v("同意")])], 1), _vm._v(" "), _c('flexbox-item', [_c('x-button', {
    staticClass: "my-warn",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.notAgree($event)
      }
    }
  }, [_vm._v("不同意")])], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    staticClass: "agency-main",
    staticStyle: {
      "padding-bottom": "70px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasResp && _vm.baseInfo.stepCurrent),
      expression: "hasResp && baseInfo.stepCurrent"
    }],
    staticClass: "propress-line",
    staticStyle: {
      "padding": "32px 0",
      "background": "#fff"
    }
  }, [_c('my-step', {
    attrs: {
      "step": _vm.baseInfo.stepCurrent,
      "totalstep": _vm.baseInfo.stepTotal
    }
  })], 1), _vm._v(" "), _c('div', [_c('group', {
    attrs: {
      "title": "投资者基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "userName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "placeholder": "请输入姓名",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.userName),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userName", $$v)
      },
      expression: "propData.userName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "documentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "value": _vm.iDCardTypesLabel(_vm.propData.documentsType),
      "placeholder": "请输入证件类型",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "idCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "placeholder": "请输入证件号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.idCardNo),
      callback: function($$v) {
        _vm.$set(_vm.propData, "idCardNo", $$v)
      },
      expression: "propData.idCardNo"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "documentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件有效期",
      "placeholder": "证件号码有效期",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.documentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.propData, "documentsValidity", $$v)
      },
      expression: "propData.documentsValidity"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [(_vm.isForeign(_vm.propData.documentsType)) ? _c('x-input', {
    ref: "userCountry",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "国籍",
      "placeholder": "请输入国籍",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.propData.userCountry),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userCountry", $$v)
      },
      expression: "propData.userCountry"
    }
  }) : _vm._e(), _vm._v(" "), _c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.userSex),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userSex", $$v)
      },
      expression: "propData.userSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.propData.userAge),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userAge", $$v)
      },
      expression: "propData.userAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "职业",
      "options": ['党政机关、事业单位', '企业单位', '自由业主', '学生', '军人', '其他'],
      "placeholder": '请选择职业',
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.userOccupation),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userOccupation", $$v)
      },
      expression: "propData.userOccupation"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userPosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.userPosition),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userPosition", $$v)
      },
      expression: "propData.userPosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userLandline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "placeholder": "请输入座机",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.userLandline),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userLandline", $$v)
      },
      expression: "propData.userLandline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "placeholder": "请输入手机",
      "required": ""
    },
    model: {
      value: (_vm.propData.userMobile),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userMobile", $$v)
      },
      expression: "propData.userMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "userEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.userEmail),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userEmail", $$v)
      },
      expression: "propData.userEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "zip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "邮编",
      "max": 6,
      "type": "number",
      "keyboard": "number",
      "placeholder": "请输入邮编",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.zip),
      callback: function($$v) {
        _vm.$set(_vm.propData, "zip", $$v)
      },
      expression: "propData.zip"
    }
  }), _vm._v(" "), _c('x-textarea', {
    ref: "userAddress",
    attrs: {
      "title": "住址",
      "autosize": "",
      "placeholder": "请输入住址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.userAddress),
      callback: function($$v) {
        _vm.$set(_vm.propData, "userAddress", $$v)
      },
      expression: "propData.userAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-con"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isFund ? '一、私募基金投资者，最近20个交易日金融资产均不得低于人民币300万元，或者最近3年个人年均收入不低于人民币50万元' :
    '一、资产管理计划投资者，具有2年以上投资经历，且满足以下条件之一：家庭金融净资产不低于300万元，家庭金融资产不低于500万元，或者近3年本人年均收入不低于40万元') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.userAssetsScale.checked))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("二、是否满足下列条件")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px 0"
    }
  }, [_vm._v("\n          （1）金融资产不低于500万元人民币，或者最近3年个人年均收入不低于50万元人民币；\n          （2）具有2年以上证券、基金、期货、黄金、外汇等投资经历，或 者具有2年以上金融产品设计、投资、风险管理及相关工作经 历的自然人投资者，或者属于《证券提货投资者适当性管理 办法》第八条第(一)款所规定的专业投资者的高级管理人 员、获得职业资格认证的从事金融相关业务的注册会计师和 律师。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.userInvestmentExperience.checked))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("三、是否存在实际控制关系？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.isControllingShareholder.checked))]), _vm._v(" "), (_vm.data.isControllingShareholder.checked === '是') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.data.isControllingShareholder.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("四、交易实际受益人？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.transactionActualBeneficiary.checked))]), _vm._v(" "), (_vm.data.transactionActualBeneficiary.checked === '他人') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.data.transactionActualBeneficiary.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("五、是否有不良诚信记录？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.isBadFaith.checked))]), _vm._v(" "), (_vm.data.isBadFaith.checked === '是') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.data.isBadFaith.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "notice-text"
  }, [_vm._v("\n        以上资料为您的理财师在特定对象确认程序时向您获取并上传至系统用于适当性管理留痕，经您本人在线确认视为您对该材料真实、完整、准确、有效性的认可。若以上资料与您实际资料不符，请您联系理财师进行修改，确保您提供给理财师的资料真实、有效、准确、完整，并对您提供的资料承担责任。\n      ")])]), _vm._v(" "), (_vm.baseInfo.isShowBtn) ? _c('submit-button', {
    on: {
      "click": _vm.$_personal_submit
    }
  }, [_vm._v("确定")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t投资者：金融机构投资者预约订单时可以创建产品，填写产品名称、产品投资者基本信息表、产品证明资料即可添加产品，需要管理人后台审核\n\t"), _c('br'), _vm._v("\n\t理财师：理财师为金融机构投资者创建产品订单时，可以帮助金融机构创建产品。填写产品名称、产品投资者基本信息表、产品证明资料即可添加产品。需要管理人后台审核\n\t"), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    attrs: {
      "show-indicators": _vm.showindicators,
      "loop": _vm.loopenable
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(905),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(906),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(907),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "03"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.信息确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对产品信息、订单信息、投资者信息、风险承受能力、经办人授权函（如有）、产品主体（如有）进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.风险匹配\\不匹配警示函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者风险承受能力和产品匹配\\不匹配警示函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.投资者确认函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者确认函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者发起的预约订单申请，需要等待管理人后台进行审核\n\t\t\t")])])])])
}]}

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox",
    class: {
      'vux-flex-col': _vm.orient === 'vertical',
        'vux-flex-row': _vm.orient === 'horizontal'
    },
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relation"
  }, [(_vm.$route.query.logo && _vm.$route.query.logo !== 'null') ? _c('div', {
    staticClass: "relation-logo"
  }, [_c('img', {
    staticStyle: {
      "width": "14rem",
      "height": "5rem"
    },
    attrs: {
      "src": _vm.$route.query.logo,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "relation-name"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "relation-name-main"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(_vm.$route.query.name))]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "relation-code"
  }, [_c('div', [_vm._v("\n      " + _vm._s(_vm.$route.query.code) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "relation-text"
  }, [_vm._v("\n    复制邀请码，下载投资者APP注册时输入\n  ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": __webpack_require__(917),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    staticStyle: {
      "width": "38px"
    },
    attrs: {
      "src": __webpack_require__(935),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "opacity": "0.3",
      "padding": "0 10px 0 30px"
    }
  }, [_c('p', {
    staticStyle: {
      "border": "1px solid",
      "width": "30%",
      "float": "right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "opacity": "0.3",
      "padding": "0 30px 0 10px"
    }
  }, [_c('p', {
    staticStyle: {
      "border": "1px solid",
      "width": "30%",
      "float": "left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "64px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "58px"
    },
    attrs: {
      "src": __webpack_require__(897),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "src": __webpack_require__(911),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(924),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0 15px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(908),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relation-foot"
  }, [_c('div', {
    staticClass: "foot-btn"
  }, [_c('div', {
    staticClass: "foot-text"
  }, [_vm._v("\n        为了顺利完成线上签约，请识别二维码下载APP\n      ")])])])
}]}

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation com-mar-btm"
  }, [_c('x-header', {
    staticClass: "header-define",
    attrs: {
      "title": _vm.title,
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    },
    slot: "left"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#222222"
    },
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.$_view_quesDetail
    },
    slot: "right"
  }, [_vm._v("问卷明细")])]), _vm._v(" "), _c('div', {
    staticClass: "evaluation-main"
  }, [_c('div', {
    staticClass: "page-index"
  }, [_c('div', {
    staticClass: "result-item"
  }, [_c('p', {
    staticClass: "res-one"
  }, [_vm._v("\n          " + _vm._s(_vm.params.result) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "com-again-test",
    on: {
      "click": _vm.$_evaluation_again
    }
  }, [_vm._v("\n          重新测评\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "res-two"
  }, [_vm._v("\n          您适合购买的产品风险等级为"), _c('span', [_vm._v(_vm._s(_vm.level))]), _vm._v("的基金\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-que"
  }, [_c('i', {
    staticClass: "left"
  }, [_vm._v("“")]), _c('i', {
    staticClass: "right"
  }, [_vm._v("”")]), _vm._v("\n        尊敬的投资者，根据本次风险测评结果，您属于" + _vm._s(_vm.params.result) + "等级，将导致您原先部分订单风险匹配状况将发生变更，您是否确认本次风险测评结果？\n      ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.params.specialObj) ? _c('table-list', {
    attrs: {
      "baseInfo": _vm.params
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "com-footer-fixed-btn"
  }, [_c('button', {
    staticClass: "com-btn-submit-radius weui-btn weui-btn_primary",
    on: {
      "click": _vm.$_evaluation_checkSubmit
    }
  }, [_vm._v("提 交")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "production-item"
  }, [_c('h4', [_vm._v("重要声明")]), _vm._v(" "), _c('p', [_vm._v("\n          您的风险承受能力评估结果是根据您填写的《风险测评问卷》以及其他相关信息综合评估得出，旨在协助您选择合适的产品或服务类别，并不能取代您自己的投资判断，也不会降低产品或服务的固有风险。建议您在产品购买过程中结合自身投资行为，并做出审慎的投资判断。\n        ")])])
}]}

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "app-content"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(301)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.appName))]), _vm._v(" "), (_vm.notMatch) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("请选择版本")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toDownload(1)
      }
    }
  }, [_vm._v("安卓版")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toDownload(2)
      }
    }
  }, [_vm._v("苹果版")])], 1) : _vm._e()]), _vm._v(" "), (_vm.isWeiXin) ? _c('div', {
    staticClass: "poper"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": __webpack_require__(300)
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "vux-datetime weui-cell",
    class: {
      'weui-cell_access': !_vm.readonly
    },
    attrs: {
      "data-cancel-text": '取消',
      "data-confirm-text": '确定',
      "href": "javascript:"
    }
  }, [_vm._t("default", [_c('div', [_vm._t("title", [_c('p', {
    class: _vm.labelClass,
    style: (_vm.styles),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft vux-cell-primary vux-datetime-value",
    style: ({
      textAlign: _vm.valueTextAlign
    })
  }, [(!_vm.currentValue && _vm.placeholder) ? _c('span', {
    staticClass: "vux-cell-placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), (_vm.currentValue) ? _c('span', {
    staticClass: "vux-cell-value"
  }, [_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]) : _vm._e(), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.valid),
      expression: "!valid"
    }],
    staticClass: "vux-input-icon",
    attrs: {
      "type": "warn",
      "title": _vm.firstError
    }
  })], 1)])], 2)
},staticRenderFns: []}

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "evaluation com-mar-btm"
  }, [_c('x-header', {
    staticClass: "header-define",
    attrs: {
      "title": "风险测评",
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.$_evaluation_back
    },
    slot: "left"
  }, [_c('svg', {
    staticClass: "vux-x-icon vux-x-icon-ios-arrow-back",
    attrs: {
      "type": "ios-arrow-back",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "evaluation-main"
  }, [_c('div', {
    staticClass: "test-propress"
  }, [_c('div', {
    staticClass: "index-tip"
  }, [_c('span', {
    style: (_vm.prevStyle),
    on: {
      "click": function($event) {
        _vm.$_evaluation_prev(_vm.index)
      }
    }
  }, [_vm._v("上一题")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.index < 10 ? '0' + _vm.index : _vm.index) + "/" + _vm._s(_vm.total))]), _vm._v(" "), _c('span', {
    style: (_vm.nextStyle),
    on: {
      "click": function($event) {
        _vm.$_evaluation_next(_vm.index)
      }
    }
  }, [_vm._v("下一题")])]), _vm._v(" "), _c('div', {
    staticClass: "propress-box"
  }, [_c('div', {
    staticClass: "propress-style",
    style: ({
      width: _vm.progressPercent
    })
  })])]), _vm._v(" "), _vm._l((_vm.question), function(item, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.index === (key + 1)),
        expression: "index === (key + 1)"
      }]
    }, [_c('div', {
      staticClass: "evaluation-title"
    }, [_vm._v("\n          " + _vm._s((_vm.index + "、" + (item.title))) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "options-list"
    }, [_c('group', [_c('radio', {
      attrs: {
        "options": item.options
      },
      nativeOn: {
        "click": function($event) {
          _vm.change(_vm.index)
        }
      },
      scopedSlots: _vm._u([{
        key: "each-item",
        fn: function(scope) {
          return [_c('div', {
            class: {
              'selected-style': scope.selected, 'item-box': true
            }
          }, [_c('div', {
            staticClass: "item-box-con"
          }, [_vm._v("\n                    " + _vm._s(_vm._f("formatAnswer")(scope.label, scope.index)) + "\n                  ")])])]
        }
      }]),
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 1)], 1)])
  }), _vm._v(" "), (_vm.index === _vm.total) ? _c('div', {
    staticClass: "tip-text"
  }, [_c('div', {
    staticClass: "empty-split"
  }), _vm._v(" "), _c('h4', [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("本人已经了解并愿意遵守国家有关证券市场、基金市场管理的法律、法规、规章及相关业务规则，本人在此郑重承诺以上填写的内容真实、准确、完整。若本人提供的信息发生任何重大变化，本人将及时书面通知贵公司。")])]) : _vm._e(), _vm._v(" "), _c('submit-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.index === _vm.total),
      expression: "index === total"
    }],
    attrs: {
      "disabled": !_vm.isSubmit
    },
    on: {
      "click": function($event) {
        _vm.$_evaluation_submitCal(_vm.index)
      }
    }
  }, [_vm._v("提 交")])], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-selector"
  }, [_c('i'), _vm._v(" "), _c('div', {
    staticClass: "cover",
    on: {
      "click": _vm.isShow
    }
  }), _vm._v(" "), _c('x-input', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": _vm.title,
      "placeholder": "请选择",
      "disabled": _vm.disabled,
      "required": ""
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    ref: "popup",
    attrs: {
      "position": "top",
      "should-scroll-top-on-show": ""
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.options), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.emitValue(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell"
  }, [_c('div', [_c('p', {
    class: _vm.labelClass,
    style: ({
      width: _vm.$parent.labelWidth,
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "weui-cell__ft vux-cell-primary",
    class: {
      'vux-number-round': _vm.buttonStyle === 'round'
    },
    staticStyle: {
      "font-size": "0"
    }
  }, [_c('div', {
    style: ({
      float: _vm.align
    })
  }, [_c('a', {
    staticClass: "vux-number-selector vux-number-selector-sub",
    class: {
      'vux-number-disabled': _vm.disabledMin
    },
    on: {
      "click": _vm.sub
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "18",
      "height": "18"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.currentValue),
      expression: "currentValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "vux-number-input",
    style: ({
      width: _vm.width
    }),
    attrs: {
      "name": _vm.name,
      "readonly": !_vm.fillable,
      "pattern": "[0-9]*",
      "type": "number"
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "blur": [_vm.blur, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "vux-number-selector vux-number-selector-plus",
    class: {
      'vux-number-disabled': _vm.disabledMax
    },
    on: {
      "click": _vm.add
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "20",
      "height": "20"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.readonly),
      expression: "readonly"
    }],
    staticClass: "weui-cell__ft vux-cell-primary"
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-footer-fixed-btn"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("right")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(71),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      机构投资者中的金融机构需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n        1、营业执照扫描件、组织机构代码证扫描件、税务登记证扫描件（三证合一机构提供营业执照扫描件即可）；\n        "), _c('br'), _vm._v("\n        2、开户许可证扫描件；\n        "), _c('br'), _vm._v("\n        3、开展金融业务相关资格证明；\n        "), _c('br'), _vm._v("\n        4、法定代表人身份证正反面扫描件（或照片）；\n        "), _c('br'), _vm._v("\n        5、经办人身份证正反面扫描件（或照片）；\n        "), _c('br'), _vm._v("\n        6、-产品类投资者还需提供产品成立、备案证明文件；\n        "), _c('br'), _vm._v("\n        7、投资者基本信息表（机构）相关信息；*产品类投资者还需填写投资者信息表（产品）相关信息；\n        "), _c('br'), _vm._v("\n        8、经办人授权函\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": __webpack_require__(72),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
}]}

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.下载APP并注册\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者可以通过理财师分享的二维码下载投资者APP，根据实际情况选择自然人或机构注册\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.点击快速注册\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者进入APP登录页面，点击“快速注册”，进行注册\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.服务协议及隐私协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者注册前需要对网络服务协议和隐私协议进行确认，“同意并确认”后才能注册\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.填写注册信息\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t自然人：填写手机号码、短信验证码、登录密码、确认登录密码\n\t\t\t\t"), _c('br'), _vm._v(" 机构：填写机构名称、组织机构代码\\统一社会信用代码、经办人手机号码、短信验证码、登录密码、确认密码\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.注册成功\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t填写信息完成后，点击“提交”，提示注册成功\n\t\t\t")])])])])
}]}

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t1.预约申请\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者选择预约产品、填写预约金额，对投资者信息、风险承受能力、经办人授权函（如有）、产品主体（如有）进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t2.投资者账户填写\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者填写姓名或者机构名称、银行卡号、开户行名称（具体支行）\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t3.风险匹配\\不匹配警示函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者风险承受能力和产品匹配\\不匹配警示函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t4.投资者确认函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者确认函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t5.等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者发起的预约订单申请，需要等待管理人后台进行审核\n\t\t\t")])])])])
}]}

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('div', {
    staticClass: "firstContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t身份认证\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者四要素认证：姓名、身份证号、银行卡号、银行预留手机号码四要素未通过情况需要人脸识别\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t网络服务协议确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对网络服务协议确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t投资者信息及合格投资者承诺函确认\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者对投资者信息表、投资者资料、合格投资者承诺函进行确认\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t数字证书申请表上传\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t投资者上传签署盖章的数字证书申请表\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "0px",
      "border-top": "1px #E0E0E0 dashed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t等待管理人审核\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n\t\t\t\t特定对象确认提交管理人后台等待管理人审核，审核通过特定对象完成，审核失败，根据失败原型修改相关资料\n\t\t\t")])])])])
}]}

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(71),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      金融产品投资者需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n        1、营业执照扫描件、组织机构代码证扫描件、税务登记证扫描件（三证合一机构提供营业执照扫描件即可）；\n        "), _c('br'), _vm._v("\n        2、开户许可证扫描件；\n        "), _c('br'), _vm._v("\n        3、开展金融业务相关资格证明；\n        "), _c('br'), _vm._v("\n        4、法定代表人身份证正反面扫描件（或照片）；\n        "), _c('br'), _vm._v("\n        5、经办人身份证正反面扫描件（或照片）；\n        "), _c('br'), _vm._v("\n        6、产品类投资者还需提供产品成立、备案证明文件；\n        "), _c('br'), _vm._v("\n        7、投资者基本信息表（机构）相关信息；*产品类投资者还需填写投资者信息表（产品）相关信息；\n        "), _c('br'), _vm._v("\n        8、经办人授权函\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": __webpack_require__(72),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(20),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
}]}

/***/ }),
/* 1099 */,
/* 1100 */,
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(865)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1080),
  /* scopeId */
  "data-v-8bdd5c34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(786)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  "data-v-01a88030",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(875)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1087),
  /* scopeId */
  "data-v-c626a226",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(788)
__webpack_require__(789)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  "data-v-023cb156",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(878)
__webpack_require__(879)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1090),
  /* scopeId */
  "data-v-d64e3ef2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(873)
__webpack_require__(872)
__webpack_require__(874)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1086),
  /* scopeId */
  "data-v-b4accf8a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(804)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  "data-v-1ef35a6d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(855)
__webpack_require__(854)
__webpack_require__(856)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1070),
  /* scopeId */
  "data-v-7349b9de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(810)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  "data-v-2564cb28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(831)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1049),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(826)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(1046),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(794)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(888)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1097),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(808)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(813)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1034),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(805)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(823)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1043),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(869)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1083),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(847)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1064),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(887)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(1096),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(817)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1037),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(790)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(834)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1052),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(868)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(1082),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(853)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(1069),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(851)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1067),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(821)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1041),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(802)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(845)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(1062),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(886)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(1095),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(838)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1056),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(860)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1075),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(825)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1045),
  /* scopeId */
  "data-v-42f367b3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(799)
__webpack_require__(800)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  "data-v-11efb51c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(857)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1071),
  /* scopeId */
  "data-v-7646aae9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(836)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(1054),
  /* scopeId */
  "data-v-53792caa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(842)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1059),
  /* scopeId */
  "data-v-5b5b1899",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(861)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1076),
  /* scopeId */
  "data-v-7e27e9a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(866)
__webpack_require__(867)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1081),
  /* scopeId */
  "data-v-8e86d926",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(812)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1033),
  /* scopeId */
  "data-v-29c00764",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(819)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1039),
  /* scopeId */
  "data-v-367c2ebf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(806)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  "data-v-209c6b5d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(791)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  "data-v-0ab69db7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(833)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1051),
  /* scopeId */
  "data-v-4ee3dfa5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(871)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1085),
  /* scopeId */
  "data-v-ad44c13e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(864)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1079),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(889)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(1098),
  /* scopeId */
  "data-v-f70349be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(807)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  "data-v-225e3190",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(844)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1061),
  /* scopeId */
  "data-v-5ec5ee04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(863)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1078),
  /* scopeId */
  "data-v-892b6810",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(801)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  "data-v-14c21b9f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(885)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1094),
  /* scopeId */
  "data-v-f0f28718",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(793)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  "data-v-0c9250b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(841)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1058),
  /* scopeId */
  "data-v-585c0644",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(883)
__webpack_require__(884)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1093),
  /* scopeId */
  "data-v-ee8f9c82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(849)
__webpack_require__(850)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1066),
  /* scopeId */
  "data-v-69a4f5f1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(839)
__webpack_require__(840)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(1057),
  /* scopeId */
  "data-v-5752602a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(880)
__webpack_require__(881)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1091),
  /* scopeId */
  "data-v-ea5bf47e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(797)
__webpack_require__(798)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  "data-v-11aa20df",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(827)
__webpack_require__(828)
__webpack_require__(829)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(1047),
  /* scopeId */
  "data-v-49272e80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(843)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(1060),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(795)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(846)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(1063),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(1074),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(787)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })
],[408]);


// WEBPACK FOOTER //
// static/js/app.c1d4d9645f2df6316203.js